
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.b1458204999 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"−","E":"×10^","‰":"‰"},]);
Globalize.b1165082887 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"−","E":"×10^","‰":"‰"},]);
Globalize.a2031160443 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"−","E":"×10^","‰":"‰"},]);
Globalize.b1228670462 = numberParserFn([{",":"."," ":",","%":"%","+":"+","-":"-","×10^":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.a136552493 = pluralGeneratorFn(function(n
) {
  var s = String(n).split('.'), v0 = !s[1];
  return (n == 1 && v0) ? 'one' : 'other';
});
Globalize.b834073549 = messageFormatterFn((function(  ) {
  return function(d) { return "Stäng"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1302418251 = messageFormatterFn((function(  ) {
  return function(d) { return "Avbryt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2037312443 = messageFormatterFn((function(  ) {
  return function(d) { return "Avvisa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b688287811 = messageFormatterFn((function(  ) {
  return function(d) { return "Klar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1692066753 = messageFormatterFn((function(  ) {
  return function(d) { return "Ta bort"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1036067690 = messageFormatterFn((function(  ) {
  return function(d) { return "valda"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b798138761 = messageFormatterFn((function(  ) {
  return function(d) { return "Hämtar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b843832504 = messageFormatterFn((function(  ) {
  return function(d) { return "Rensa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a402504606 = messageFormatterFn((function(  ) {
  return function(d) { return "Öppnas i ett nytt fönster"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1326387940 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa mer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1254600983 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa mindre"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b57740901 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa mer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1855508568 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa mindre"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b607323965 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " har valts. Ange utcheckningsdatum."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1813651630 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " har valts. Klicka på " + d["1"] + " för att spara datumen och stänga datumväljaren."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b295530670 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " har valts, incheckningsdatum."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a170510223 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " har valts, utcheckningsdatum."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a784515301 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", datum avaktiverat"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a184632738 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", nuvarande månad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a931615107 = messageFormatterFn((function(  ) {
  return function(d) { return "Nu visas " + d["0"] + " och " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a95831175 = messageFormatterFn((function(  ) {
  return function(d) { return "Datumväljaren är öppen. Välj datum i tabellen nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1283011609 = messageFormatterFn((function(  ) {
  return function(d) { return "Avbryt, stäng datumväljaren utan att spara ändringarna. Eller välj datum i tabellen nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1399890615 = messageFormatterFn((function(  ) {
  return function(d) { return "Rensa valda datum."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a572685922 = messageFormatterFn((function(  ) {
  return function(d) { return "Spara ändringar och stäng datumväljaren."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2140388485 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " nätter";}, one: function() { return number(d["0"]) + " natt";}, two: function() { return number(d["0"]) + " nätter";}, few: function() { return number(d["0"]) + " nätter";}, many: function() { return number(d["0"]) + " nätter";}, other: function() { return number(d["0"]) + " nätter";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1641604469 = messageFormatterFn((function(  ) {
  return function(d) { return "Incheckning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1758815140 = messageFormatterFn((function(  ) {
  return function(d) { return "Utcheckning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1364764445 = messageFormatterFn((function(  ) {
  return function(d) { return "Rensa datum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1192637444 = messageFormatterFn((function(  ) {
  return function(d) { return "Klar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b988140638 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a971265624 = messageFormatterFn((function(  ) {
  return function(d) { return "Redigera incheckningsdatum i tabellen nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1081349673 = messageFormatterFn((function(  ) {
  return function(d) { return "Redigera utcheckningsdatum i tabellen nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a327885608 = messageFormatterFn((function(  ) {
  return function(d) { return "valt."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2043424517 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " har valts. Stäng kalendern eller gå vidare för att ändra datumet."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1218709453 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " till " + d["1"] + " har valts. Stäng kalendern eller gå vidare för att ändra datum."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b403825709 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " har valts. " + d["1"] + ". Stäng kalendern eller gå vidare för att ändra datumet."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1241646821 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " till " + d["1"] + " har valts. " + d["2"] + ". Stäng kalendern eller gå vidare för att ändra datum."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a496505964 = messageFormatterFn((function(  ) {
  return function(d) { return "Startdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b200590427 = messageFormatterFn((function(  ) {
  return function(d) { return "Slutdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1097664044 = messageFormatterFn((function(  ) {
  return function(d) { return "tomt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b55664590 = messageFormatterFn((function(  ) {
  return function(d) { return "Föregående månad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1201166442 = messageFormatterFn((function(  ) {
  return function(d) { return "Nästa månad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a770715577 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoppa till knappen " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1503395247 = messageFormatterFn((function(  ) {
  return function(d) { return "Från " + d["0"] + " till " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b763033204 = messageFormatterFn((function(  ) {
  return function(d) { return "Datum har rensats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b351294239 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "det finns " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " resultat";}, one: function() { return number(d["0"]) + " resultat";}, two: function() { return number(d["0"]) + " resultat";}, few: function() { return number(d["0"]) + " resultat";}, many: function() { return number(d["0"]) + " resultat";}, other: function() { return number(d["0"]) + " resultat";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2028828726 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + " resultat tillgängliga";}, one: function() { return number(d["1"]) + " resultat tillgängligt";}, two: function() { return number(d["1"]) + " resultat tillgängliga";}, few: function() { return number(d["1"]) + " resultat tillgängliga";}, many: function() { return number(d["1"]) + " resultat tillgängliga";}, other: function() { return number(d["1"]) + " resultat tillgängliga";} }) + " för “" + d["0"] + "”. Använd pilknapparna eller svep för att navigera i listan."; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1668340318 = messageFormatterFn((function(  ) {
  return function(d) { return "Öppen sökning på " + d["0"] + ". Skriv in en sökterm."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1352704815 = messageFormatterFn((function(  ) {
  return function(d) { return "Du valde " + d["0"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1796951150 = messageFormatterFn((function(  ) {
  return function(d) { return "Menyn har stängts."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b407352396 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Sökning på " + d["0"] + " öppen, visar för närvarande " + plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + " förslag";}, one: function() { return number(d["1"]) + " förslag";}, two: function() { return number(d["1"]) + " förslag";}, few: function() { return number(d["1"]) + " förslag";}, many: function() { return number(d["1"]) + " förslag";}, other: function() { return number(d["1"]) + " förslag";} }) + " för " + d["2"] + ". Navigera i listan nedan."; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a734414083 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Sökning för " + d["0"] + " öppen, visar " + plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + " förslag";}, one: function() { return number(d["1"]) + " förslag";}, two: function() { return number(d["1"]) + " förslag";}, few: function() { return number(d["1"]) + " förslag";}, many: function() { return number(d["1"]) + " förslag";}, other: function() { return number(d["1"]) + " förslag";} }) + ". Ange sökterm eller navigera i listan nedan."; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1275610785 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Sökning för " + d["0"] + " öppen, nuvarande val " + d["1"] + " . Visar " + plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + " förslag";}, one: function() { return number(d["1"]) + " förslag";}, two: function() { return number(d["1"]) + " förslag";}, few: function() { return number(d["1"]) + " förslag";}, many: function() { return number(d["1"]) + " förslag";}, other: function() { return number(d["1"]) + " förslag";} }) + " för " + d["3"] + ". Navigera i listan nedan."; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b647345883 = messageFormatterFn((function(  ) {
  return function(d) { return "Klart"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1829420420 = messageFormatterFn((function(  ) {
  return function(d) { return "Rensa alla"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1880808977 = messageFormatterFn((function(  ) {
  return function(d) { return "Valda alternativ"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a402806844 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " togs bort."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1636237731 = messageFormatterFn((function(  ) {
  return function(d) { return "Alla valda alternativ togs bort."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a852036340 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har angett data i textfältet. Sök eller välj bland kategoriförslag nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1409413803 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter \"" + d["0"] + "\""; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1651585324 = messageFormatterFn((function(  ) {
  return function(d) { return "Inga resultat för \"" + d["0"] + "\""; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a668068906 = messageFormatterFn((function(  ) {
  return function(d) { return "Flygplats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a433443795 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a530730985 = messageFormatterFn((function(  ) {
  return function(d) { return "Sevärdhet"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2118757774 = messageFormatterFn((function(  ) {
  return function(d) { return "I närheten"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1665244849 = messageFormatterFn((function(  ) {
  return function(d) { return "Testa \"" + d["0"] + "\""; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a379247990 = messageFormatterFn((function(  ) {
  return function(d) { return "Region/stad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b227997130 = messageFormatterFn((function(  ) {
  return function(d) { return "Flygplats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1085216882 = messageFormatterFn((function(  ) {
  return function(d) { return "Sevärdhet"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b814414625 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a155788063 = messageFormatterFn((function(  ) {
  return function(d) { return "Adress"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1848122839 = messageFormatterFn((function(  ) {
  return function(d) { return "Tågstation"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b420264474 = messageFormatterFn((function(  ) {
  return function(d) { return "Tunnelbanestation"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1572611466 = messageFormatterFn((function(  ) {
  return function(d) { return "Utforska resmål i närheten"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1006748607 = messageFormatterFn((function(  ) {
  return function(d) { return "Senaste sökningar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a570462757 = messageFormatterFn((function(  ) {
  return function(d) { return "Andra har även sökt efter:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b284038480 = messageFormatterFn((function(  ) {
  return function(d) { return "Upptäck trendande destinationer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1338223420 = messageFormatterFn((function(  ) {
  return function(d) { return "Populära destinationer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1542869320 = messageFormatterFn((function(  ) {
  return function(d) { return "Trendande destinationer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a969322938 = messageFormatterFn((function(  ) {
  return function(d) { return "Din plats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1806861577 = messageFormatterFn((function(  ) {
  return function(d) { return "Platsdelning är avaktiverat"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1370148345 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kan inte avgöra din plats. Aktivera platstjänster för att vi ska kunna avgöra din plats, eller ange en destination."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1117891403 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " rum";}, one: function() { return number(d["0"]) + " rum";}, two: function() { return number(d["0"]) + " rum";}, few: function() { return number(d["0"]) + " rum";}, many: function() { return number(d["0"]) + " rum";}, other: function() { return number(d["0"]) + " rum";} }) + ", " + plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + " gäster";}, one: function() { return number(d["1"]) + " gäst";}, two: function() { return number(d["1"]) + " gäster";}, few: function() { return number(d["1"]) + " gäster";}, many: function() { return number(d["1"]) + " gäster";}, other: function() { return number(d["1"]) + " gäster";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b174475221 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " gäster";}, one: function() { return number(d["0"]) + " gäst";}, two: function() { return number(d["0"]) + " gäster";}, few: function() { return number(d["0"]) + " gäster";}, many: function() { return number(d["0"]) + " gäster";}, other: function() { return number(d["0"]) + " gäster";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b923146791 = messageFormatterFn((function(  ) {
  return function(d) { return "Värdet av fältet " + d["0"] + " är nu " + d["1"] + ". Värdet av fältet " + d["2"] + " är nu " + d["3"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1507340408 = messageFormatterFn((function(  ) {
  return function(d) { return "Byt ut fälten " + d["0"] + " och " + d["1"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b988810581 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa lösenord"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1303152720 = messageFormatterFn((function(  ) {
  return function(d) { return "Dölj lösenord"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b71304983 = messageFormatterFn((function(  ) {
  return function(d) { return "Nu visas " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a911057676 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " av " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b482088918 = messageFormatterFn((function(  ) {
  return function(d) { return "Bild " + d["0"] + " av " + d["1"] + ". " + d["2"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1579863257 = messageFormatterFn((function(  ) {
  return function(d) { return "Hämta nästa bild"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1206725469 = messageFormatterFn((function(  ) {
  return function(d) { return "Hämta föregående bild"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1103044119 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Visa " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " bilder";}, one: function() { return number(d["0"]) + " bild";}, two: function() { return number(d["0"]) + " bilder";}, few: function() { return number(d["0"]) + " bilder";}, many: function() { return number(d["0"]) + " bilder";}, other: function() { return number(d["0"]) + " bilder";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2022732482 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Visa " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " bilder";}, one: function() { return number(d["0"]) + " bild";}, two: function() { return number(d["0"]) + " bilder";}, few: function() { return number(d["0"]) + " bilder";}, many: function() { return number(d["0"]) + " bilder";}, other: function() { return number(d["0"]) + " bilder";} }) + " för " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1891402491 = messageFormatterFn((function(  ) {
  return function(d) { return "Klart:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1973121001 = messageFormatterFn((function(  ) {
  return function(d) { return "Nu:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2102240425 = messageFormatterFn((function(  ) {
  return function(d) { return "Steg " + d["0"] + " av " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1100161755 = messageFormatterFn((function(  ) {
  return function(d) { return "Steg " + d["0"] + " av " + d["1"] + ":"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1610895386 = messageFormatterFn((function(  ) {
  return function(d) { return "Bild " + d["0"] + " av " + d["1"] + ". " + d["2"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b200033821 = messageFormatterFn((function(  ) {
  return function(d) { return "Nästa bild"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a636984671 = messageFormatterFn((function(  ) {
  return function(d) { return "Föregående bild"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b319713297 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", öppna i fullskärmsläge"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b883172539 = messageFormatterFn((function(  ) {
  return function(d) { return "Artikel " + d["0"] + ", öppna i fullskärmsläge"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b900554427 = messageFormatterFn((function(  ) {
  return function(d) { return "Nuvarande sida"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b599523317 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa fler länkstigar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b637344433 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa färre länkstigar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1683322610 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " procent har laddats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a511341037 = messageFormatterFn((function(  ) {
  return function(d) { return "Laddar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b458122845 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a280612474 = messageFormatterFn((function(  ) {
  return function(d) { return "Ett fel har inträffat."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a954219998 = messageFormatterFn((function(  ) {
  return function(d) { return "Prova att titta på videon på www.youtube.com eller aktivera Javascript om det är avaktiverat i din webbläsare."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2099981158 = messageFormatterFn((function(  ) {
  return function(d) { return "Spela upp video"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1425691370 = messageFormatterFn((function(  ) {
  return function(d) { return "Pausa videon"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b950355346 = messageFormatterFn((function(  ) {
  return function(d) { return "Videon laddas"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1035996636 = messageFormatterFn((function(  ) {
  return function(d) { return "360-graders bild"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1405601026 = messageFormatterFn((function(  ) {
  return function(d) { return "Detta är en 360-graders bild. Använd kontroll- och piltangenterna för att flytta runt den"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1406385969 = messageFormatterFn((function(  ) {
  return function(d) { return "Visar: " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b113550256 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyttat vänster. Placering: " + d["0"] + " grader"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1920123849 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyttat höger. Placering: " + d["0"] + " grader"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b294813340 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyttat upp."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b332847573 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyttat ner."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1628458012 = messageFormatterFn((function(  ) {
  return function(d) { return "Du är längst upp"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1443012626 = messageFormatterFn((function(  ) {
  return function(d) { return "Du är längst ner"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1183674086 = messageFormatterFn((function(  ) {
  return function(d) { return "Markera alla rader"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a289575941 = messageFormatterFn((function(  ) {
  return function(d) { return "Avmarkera alla rader"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a652918421 = messageFormatterFn((function(  ) {
  return function(d) { return "Sortera i fallande ordning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1840622607 = messageFormatterFn((function(  ) {
  return function(d) { return "Sortera i stigande ordning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2031784063 = messageFormatterFn((function(  ) {
  return function(d) { return "Kolumnen visas nu i fallande ordning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1313382151 = messageFormatterFn((function(  ) {
  return function(d) { return "Kolumnen visas nu i stigande ordning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a164990433 = messageFormatterFn((function(  ) {
  return function(d) { return "Expandera rad " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b573584320 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Visar " + d["0"] + " av " + plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + " objekt";}, one: function() { return number(d["1"]) + " objekt";}, two: function() { return number(d["1"]) + " objekt";}, few: function() { return number(d["1"]) + " objekt";}, many: function() { return number(d["1"]) + " objekt";}, other: function() { return number(d["1"]) + " objekt";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1537565296 = messageFormatterFn((function(  ) {
  return function(d) { return "dina nuvarande månader är " + d["0"] + " " + d["1"] + " och " + d["2"] + " " + d["3"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1406965352 = messageFormatterFn((function(  ) {
  return function(d) { return "din nuvarande månad är " + d["0"] + " " + d["1"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a31496813 = messageFormatterFn((function(  ) {
  return function(d) { return "dina nuvarande månader är mellan " + d["0"] + " " + d["1"] + " och " + d["2"] + " " + d["3"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1333052232 = messageFormatterFn((function(  ) {
  return function(d) { return "Incheckningsdatum har rensats."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1216834591 = messageFormatterFn((function(  ) {
  return function(d) { return "Utcheckningsdatum har rensats."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1973441376 = messageFormatterFn((function(  ) {
  return function(d) { return "Datum har rensats."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1815462523 = messageFormatterFn((function(  ) {
  return function(d) { return "Rensa datum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1238444635 = messageFormatterFn((function(  ) {
  return function(d) { return "Skicka"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1582266114 = messageFormatterFn((function(  ) {
  return function(d) { return "Nästa månad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1127067586 = messageFormatterFn((function(  ) {
  return function(d) { return "Föregående månad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1733903716 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoppa till Välj-knappen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b156443113 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoppa till knappen " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1422526456 = messageFormatterFn((function(  ) {
  return function(d) { return "Nästa månad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a132303032 = messageFormatterFn((function(  ) {
  return function(d) { return "Föregående månad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1261092991 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " har valts som ditt incheckningsdatum."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a475987194 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " har valts som ditt utcheckningsdatum."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1214007965 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " är inte ett giltigt incheckningsdatum."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b599461048 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " är inte ett giltigt utcheckningsdatum."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b185378327 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " är inte tillgängligt."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1289071450 = messageFormatterFn((function(  ) {
  return function(d) { return "Idag"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b188848824 = messageFormatterFn((function(  ) {
  return function(d) { return "Valt incheckningsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a851635777 = messageFormatterFn((function(  ) {
  return function(d) { return "Valt utcheckningsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1507309292 = messageFormatterFn((function(  ) {
  return function(d) { return "Valt datum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1229473776 = messageFormatterFn((function(  ) {
  return function(d) { return "Startdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2105189033 = messageFormatterFn((function(  ) {
  return function(d) { return "Slutdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1128150730 = messageFormatterFn((function(  ) {
  return function(d) { return "Avbryt, stäng datumfönstret utan att spara ändringarna. Eller välj datum i tabellen nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1263419269 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " av " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1726164656 = messageFormatterFn((function(  ) {
  return function(d) { return "Tryck på Esc för att avvisa."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1436249543 = messageFormatterFn((function(  ) {
  return function(d) { return "Tryck på Esc för att stänga."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b316399480 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange en siffra som är lägre än " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b574108103 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange en siffra som är högre än " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1280094982 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange en siffra mellan " + d["0"] + " och " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1365959223 = messageFormatterFn((function(  ) {
  return function(d) { return "Obligatoriskt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b526380695 = messageFormatterFn((function(  ) {
  return function(d) { return "Ta bort " + d["0"] + " från dina senaste sökningar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1006948324 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " har tagits bort från dina senaste sökningar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a334004542 = messageFormatterFn((function(  ) {
  return function(d) { return "Transport"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1732573344 = messageFormatterFn((function(  ) {
  return function(d) { return "Boende"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1362253704 = messageFormatterFn((function(  ) {
  return function(d) { return "Stjärngradering"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1059081762 = messageFormatterFn((function(  ) {
  return function(d) { return "5 stjärnor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b683728573 = messageFormatterFn((function(  ) {
  return function(d) { return "Minst 4 stjärnor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1868428388 = messageFormatterFn((function(  ) {
  return function(d) { return "Minst 3 stjärnor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a125618053 = messageFormatterFn((function(  ) {
  return function(d) { return "Minst 2 stjärnor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1159348714 = messageFormatterFn((function(  ) {
  return function(d) { return "Rensa alla filter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a787765702 = messageFormatterFn((function(  ) {
  return function(d) { return "Alla filter har rensats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b554089694 = messageFormatterFn((function(  ) {
  return function(d) { return "Vistelselängd"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1563794713 = messageFormatterFn((function(  ) {
  return function(d) { return "Flygklass"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2126692900 = messageFormatterFn((function(  ) {
  return function(d) { return "Detta är priset för vistelsen och flyget om du bokar dem separat på vår sida."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1502909731 = messageFormatterFn((function(  ) {
  return function(d) { return "Detta är priset för vistelsen, flyget och hyrbilen om du bokar dem separat på vår sida."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2126638123 = messageFormatterFn((function(  ) {
  return function(d) { return "Detta är priset för vistelsen och hyrbilen om du bokar dem separat på vår sida."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2066645307 = messageFormatterFn((function(  ) {
  return function(d) { return "Alla erbjudanden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b246259026 = messageFormatterFn((function(  ) {
  return function(d) { return "Tur-och-retur"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2036707426 = messageFormatterFn((function(  ) {
  return function(d) { return "Enkelresa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2077203925 = messageFormatterFn((function(  ) {
  return function(d) { return "hittades nyss"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b80236859 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "hittades för " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " timmar";}, one: function() { return number(d["0"]) + " timme";}, two: function() { return number(d["0"]) + " timmar";}, few: function() { return number(d["0"]) + " timmar";}, many: function() { return number(d["0"]) + " timmar";}, other: function() { return number(d["0"]) + " timmar";} }) + " sen"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b444871141 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "hittades för " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " dagar";}, one: function() { return number(d["0"]) + " dag";}, two: function() { return number(d["0"]) + " dagar";}, few: function() { return number(d["0"]) + " dagar";}, many: function() { return number(d["0"]) + " dagar";}, other: function() { return number(d["0"]) + " dagar";} }) + " sen"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1826882816 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - " + d["1"] + " med " + d["2"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b779111320 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta erbjudanden från " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b840684998 = messageFormatterFn((function(  ) {
  return function(d) { return "Avresa från"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a369491088 = messageFormatterFn((function(  ) {
  return function(d) { return "Destination"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1812216627 = messageFormatterFn((function(  ) {
  return function(d) { return "Resdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a896565519 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyg från*"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1067458500 = messageFormatterFn((function(  ) {
  return function(d) { return "Januari"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1067457539 = messageFormatterFn((function(  ) {
  return function(d) { return "Februari"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1067456578 = messageFormatterFn((function(  ) {
  return function(d) { return "Mars"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1067455617 = messageFormatterFn((function(  ) {
  return function(d) { return "April"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1067454656 = messageFormatterFn((function(  ) {
  return function(d) { return "Maj"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1067453695 = messageFormatterFn((function(  ) {
  return function(d) { return "Juni"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1067452734 = messageFormatterFn((function(  ) {
  return function(d) { return "Juli"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1067451773 = messageFormatterFn((function(  ) {
  return function(d) { return "Augusti"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1067450812 = messageFormatterFn((function(  ) {
  return function(d) { return "September"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1268536586 = messageFormatterFn((function(  ) {
  return function(d) { return "Oktober"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1268537547 = messageFormatterFn((function(  ) {
  return function(d) { return "November"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1268538508 = messageFormatterFn((function(  ) {
  return function(d) { return "December"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a812719823 = messageFormatterFn((function(  ) {
  return function(d) { return "*Skatter och avgifter ingår i priserna"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1102132038 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " med " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1168586790 = messageFormatterFn((function(  ) {
  return function(d) { return "senare datum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1237286758 = messageFormatterFn((function(  ) {
  return function(d) { return "tidigare datum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b567373061 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " till " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1773081884 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj flyg med " + d["0"] + ", med avresa " + d["1"] + " från " + d["2"] + " till " + d["3"] + ", med återresa " + d["4"] + ", till priset " + d["5"] + ". " + d["6"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1792793322 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj flyg med " + d["0"] + ", med avresa " + d["1"] + " från " + d["2"] + " till " + d["3"] + ", till priset " + d["4"] + ". " + d["5"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b51748918 = messageFormatterFn((function(  ) {
  return function(d) { return "Verifierad resenär"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a649176827 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " till " + d["1"] + " &" + "#" + "183; " + d["2"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b380182912 = messageFormatterFn((function(  ) {
  return function(d) { return "visa mer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b418004028 = messageFormatterFn((function(  ) {
  return function(d) { return "visa mindre"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a50616161 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "Få tillgång till medlemspriser!" + d["1"] + " Du kan spara i snitt " + d["2"] + " % på tusentals hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1723202991 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "Få tillgång till medlemspriser!" + d["1"] + " Du kan spara minst " + d["2"] + " % på tusentals hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a502939564 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "Få en bonusnatt*" + d["1"] + " för var tionde natt du bor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1866835847 = messageFormatterFn((function(  ) {
  return function(d) { return "Läs mer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a554057775 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "Förmåner" + d["1"] + " på fler än 1 000 000 boenden över hela världen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b736209527 = messageFormatterFn((function(  ) {
  return function(d) { return "GÅ MED NU"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1081769797 = messageFormatterFn((function(  ) {
  return function(d) { return "LOGGA IN"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2030671058 = messageFormatterFn((function(  ) {
  return function(d) { return "*Läs mer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a19149912 = messageFormatterFn((function(  ) {
  return function(d) { return "*Se regler och villkor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2015012215 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "Tillgång till hemliga priser!" + d["1"] + " Du kan få 10 % rabatt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a153488667 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1422994346 = messageFormatterFn((function(  ) {
  return function(d) { return "Alla hotell med " + d["0"] + " stjärnor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1503147941 = messageFormatterFn((function(  ) {
  return function(d) { return "Se priser"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a428438239 = messageFormatterFn((function(  ) {
  return function(d) { return "Se tillgänglighet"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2047844558 = messageFormatterFn((function(  ) {
  return function(d) { return "Kontrollera priser"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b403820398 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta erbjudanden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b429764694 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b338440537 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta boende"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1584587422 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a334543253 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b137303097 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b418275353 = messageFormatterFn((function(  ) {
  return function(d) { return "Hämta erbjudanden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b877868299 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1344750404 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa boende"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1479065705 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1620883936 = messageFormatterFn((function(  ) {
  return function(d) { return "Hämta boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b274624775 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa mig erbjudanden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b719667677 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa mig hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b735498418 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa mig boende"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1173187735 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa mig boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1186176782 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa mig boendealternativ"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b627031158 = messageFormatterFn((function(  ) {
  return function(d) { return "Inspiration"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1000336531 = messageFormatterFn((function(  ) {
  return function(d) { return "Överraska mig"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b183196145 = messageFormatterFn((function(  ) {
  return function(d) { return "Locka mig"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1563041421 = messageFormatterFn((function(  ) {
  return function(d) { return "Paket med boende och flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1562986644 = messageFormatterFn((function(  ) {
  return function(d) { return "Paket med boende och hyrbil"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1563046226 = messageFormatterFn((function(  ) {
  return function(d) { return "Paket med flyg och hyrbil"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1209583066 = messageFormatterFn((function(  ) {
  return function(d) { return "Paket med boende, flyg och hyrbil"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a114588937 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj två eller fler komponenter för att spara på din resa:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b768101929 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj minst en komponent för att skapa din resa:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1170825120 = messageFormatterFn((function(  ) {
  return function(d) { return "Boka paket och spara"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1724216844 = messageFormatterFn((function(  ) {
  return function(d) { return "Lägg till flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1976966365 = messageFormatterFn((function(  ) {
  return function(d) { return "Lägg till vistelse"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1392530852 = messageFormatterFn((function(  ) {
  return function(d) { return "Lägg till hyrbil"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1100275032 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyg tillagt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a506490945 = messageFormatterFn((function(  ) {
  return function(d) { return "Vistelse tillagd"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1431961024 = messageFormatterFn((function(  ) {
  return function(d) { return "Hyrbil tillagd"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1419424412 = messageFormatterFn((function(  ) {
  return function(d) { return "Betala med kontanter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1289177908 = messageFormatterFn((function(  ) {
  return function(d) { return "Betala med poäng"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b710626235 = messageFormatterFn((function(  ) {
  return function(d) { return "Betala med miles"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a809738810 = messageFormatterFn((function(  ) {
  return function(d) { return "Lägg till ett hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1429931480 = messageFormatterFn((function(  ) {
  return function(d) { return "Lägg till boende"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b660736610 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotell tillagt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b40543940 = messageFormatterFn((function(  ) {
  return function(d) { return "Boende tillagt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a824758508 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a109506895 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter destination, boende eller sevärdhet"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1228433611 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter stad eller flygplats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b956878993 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter stad, flygplats eller adress"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a409051910 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter stad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1408744244 = messageFormatterFn((function(  ) {
  return function(d) { return "Vart vill du resa?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1775725980 = messageFormatterFn((function(  ) {
  return function(d) { return "Varifrån avreser du?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1746002266 = messageFormatterFn((function(  ) {
  return function(d) { return "Vart reser du?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1322732012 = messageFormatterFn((function(  ) {
  return function(d) { return "Var hämtar du din hyrbil?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1027459770 = messageFormatterFn((function(  ) {
  return function(d) { return "Var lämnar du din hyrbil?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1344138029 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj minst en komponent"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b127452357 = messageFormatterFn((function(  ) {
  return function(d) { return "För att skapa din resa måste du välja minst en komponent"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1801971820 = messageFormatterFn((function(  ) {
  return function(d) { return "Ring " + d["0"] + " för expertråd om kryssningar."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2143499100 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta boende"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1621153567 = messageFormatterFn((function(  ) {
  return function(d) { return "Boende"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1379889840 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta och jämför flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b121350390 = messageFormatterFn((function(  ) {
  return function(d) { return "Spara med semesterpaket"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1074857788 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta och jämför hyrbilserbjudanden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a904957962 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta saker att göra"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1600963867 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter boende"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1265654855 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a632332371 = messageFormatterFn((function(  ) {
  return function(d) { return "Skapa ett semesterpaket"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b350266107 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter hyrbilserbjudanden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b655381741 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter saker att göra"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b676925803 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök och jämför flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a541874117 = messageFormatterFn((function(  ) {
  return function(d) { return "Spara med paketbokning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b602628745 = messageFormatterFn((function(  ) {
  return function(d) { return "Hyr en bil"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a203970332 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1286087204 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b859330789 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter hemestrar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a515479074 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter semesterboenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b629228988 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter hyrbilar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b959973374 = messageFormatterFn((function(  ) {
  return function(d) { return "Betala med miles"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1451051858 = messageFormatterFn((function(  ) {
  return function(d) { return "Betala med miles"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1230056655 = messageFormatterFn((function(  ) {
  return function(d) { return "Betala med miles"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2074021905 = messageFormatterFn((function(  ) {
  return function(d) { return "Använd MileagePlus-miles"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b16180447 = messageFormatterFn((function(  ) {
  return function(d) { return "Använd MileagePlus-miles"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b283094143 = messageFormatterFn((function(  ) {
  return function(d) { return "Betala med miles"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1004829329 = messageFormatterFn((function(  ) {
  return function(d) { return "Betala med miles"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2023022902 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a466002485 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter hemestrar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1012280892 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter semesterboenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a520398954 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter hyrbilar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1126786743 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1970192546 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2070618021 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyg + hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b397356724 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter flyg + hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1442341403 = messageFormatterFn((function(  ) {
  return function(d) { return "Aktiviteter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b403806043 = messageFormatterFn((function(  ) {
  return function(d) { return "Solresor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1271077519 = messageFormatterFn((function(  ) {
  return function(d) { return "Högre än snittpriserna."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b539745709 = messageFormatterFn((function(  ) {
  return function(d) { return "Under snittpriser."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1096721365 = messageFormatterFn((function(  ) {
  return function(d) { return "Högre priser"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b140474129 = messageFormatterFn((function(  ) {
  return function(d) { return "Lägre priser"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2146224665 = messageFormatterFn((function(  ) {
  return function(d) { return "Pristrendsuppgifterna kommer från de " + d["0"] + " första boendena på den här sidan baserat på vistelsepriser per natt för två vuxna under det senaste dygnet på vår sida."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a145678491 = messageFormatterFn((function(  ) {
  return function(d) { return "Kompakt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1177136906 = messageFormatterFn((function(  ) {
  return function(d) { return "Economy"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1194949998 = messageFormatterFn((function(  ) {
  return function(d) { return "Stor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1386684693 = messageFormatterFn((function(  ) {
  return function(d) { return "Lyx"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1919576511 = messageFormatterFn((function(  ) {
  return function(d) { return "Mellanstor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1909496156 = messageFormatterFn((function(  ) {
  return function(d) { return "Minivan"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b335599480 = messageFormatterFn((function(  ) {
  return function(d) { return "Övriga"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1380886886 = messageFormatterFn((function(  ) {
  return function(d) { return "Pickup"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a469006031 = messageFormatterFn((function(  ) {
  return function(d) { return "Premium"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b651730547 = messageFormatterFn((function(  ) {
  return function(d) { return "Sportbil"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b205372965 = messageFormatterFn((function(  ) {
  return function(d) { return "Standard"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b908344820 = messageFormatterFn((function(  ) {
  return function(d) { return "Stadsjeep"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b906177765 = messageFormatterFn((function(  ) {
  return function(d) { return "Minibuss"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a747356012 = messageFormatterFn((function(  ) {
  return function(d) { return "Biltyp"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1339113145 = messageFormatterFn((function(  ) {
  return function(d) { return "Har du en viss resa i sikte?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b759575827 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter flyg, hotell, paket och mer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b314299872 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter flyg, hotell och mer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1182577051 = messageFormatterFn((function(  ) {
  return function(d) { return "Inkludera paketpriser"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1716089573 = messageFormatterFn((function(  ) {
  return function(d) { return "Du får speciella insider-priser på boenden när de bokas i kombination med flyg, hyrbil, tåg eller kryssning för din resenär."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b872792054 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "/5"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1677254576 = messageFormatterFn((function(  ) {
  return function(d) { return "Verifierad " + d["0"] + "-recension"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b511421867 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " från " + d["1"] + " bodde på " + d["2"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b535381036 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " bodde på " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1724968673 = messageFormatterFn((function(  ) {
  return function(d) { return "En verifierad resenär från " + d["0"] + " bodde på " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b919138360 = messageFormatterFn((function(  ) {
  return function(d) { return "En verifierad resenär bodde på " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1296380745 = messageFormatterFn((function(  ) {
  return function(d) { return "Öppna gästrecensioner för " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b194104360 = messageFormatterFn((function(  ) {
  return function(d) { return "Publicerades för mindre än en timme sen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1033790870 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Publicerades för " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " timmar";}, one: function() { return number(d["0"]) + " timme";}, two: function() { return number(d["0"]) + " timmar";}, few: function() { return number(d["0"]) + " timmar";}, many: function() { return number(d["0"]) + " timmar";}, other: function() { return number(d["0"]) + " timmar";} }) + " sen"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a806349036 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Publicerades för " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " dagar";}, one: function() { return number(d["0"]) + " dag";}, two: function() { return number(d["0"]) + " dagar";}, few: function() { return number(d["0"]) + " dagar";}, many: function() { return number(d["0"]) + " dagar";}, other: function() { return number(d["0"]) + " dagar";} }) + " sen"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b756989018 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Publicerades för " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " veckor";}, one: function() { return number(d["0"]) + " vecka";}, two: function() { return number(d["0"]) + " veckor";}, few: function() { return number(d["0"]) + " veckor";}, many: function() { return number(d["0"]) + " veckor";}, other: function() { return number(d["0"]) + " veckor";} }) + " sen"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a769448208 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Publicerades för " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " månader";}, one: function() { return number(d["0"]) + " månad";}, two: function() { return number(d["0"]) + " månader";}, few: function() { return number(d["0"]) + " månader";}, many: function() { return number(d["0"]) + " månader";}, other: function() { return number(d["0"]) + " månader";} }) + " sen"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a807399714 = messageFormatterFn((function(  ) {
  return function(d) { return "Publicerades för 1 år sen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1730177746 = messageFormatterFn((function(  ) {
  return function(d) { return "Publicerades för över ett år sen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1864421962 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " av 5"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1765781118 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "/5"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a477204591 = messageFormatterFn((function(  ) {
  return function(d) { return "Fantastiskt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1302464006 = messageFormatterFn((function(  ) {
  return function(d) { return "Bra"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1077521775 = messageFormatterFn((function(  ) {
  return function(d) { return "Okej"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1044788193 = messageFormatterFn((function(  ) {
  return function(d) { return "Dåligt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a828816128 = messageFormatterFn((function(  ) {
  return function(d) { return "Väldigt dåligt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1227718441 = messageFormatterFn((function(  ) {
  return function(d) { return "Recensioner som verifierats av " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1559036064 = messageFormatterFn((function(  ) {
  return function(d) { return "Gästrecensioner"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b389883506 = messageFormatterFn((function(  ) {
  return function(d) { return "Stäng och gå tillbaka till hotelluppgifter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b152517927 = messageFormatterFn((function(  ) {
  return function(d) { return "Högst rankade hämtningsplatser i " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1753340071 = messageFormatterFn((function(  ) {
  return function(d) { return "Genomsnittlig hämtningstid: " + d["0"] + " minuter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a975027269 = messageFormatterFn((function(  ) {
  return function(d) { return "av 10"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a801071712 = messageFormatterFn((function(  ) {
  return function(d) { return "(" + d["0"] + " recensioner)"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1883545379 = messageFormatterFn((function(  ) {
  return function(d) { return "Bemötande"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1122919396 = messageFormatterFn((function(  ) {
  return function(d) { return "Renlighet"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1359116201 = messageFormatterFn((function(  ) {
  return function(d) { return "Hämtningstid"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2054296660 = messageFormatterFn((function(  ) {
  return function(d) { return "Service överlag"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a357935502 = messageFormatterFn((function(  ) {
  return function(d) { return "Recension från " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b43386420 = messageFormatterFn((function(  ) {
  return function(d) { return "Adress:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a668490125 = messageFormatterFn((function(  ) {
  return function(d) { return "Längdgrad:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a742447716 = messageFormatterFn((function(  ) {
  return function(d) { return "Breddgrad:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b807680335 = messageFormatterFn((function(  ) {
  return function(d) { return "Tidszon:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1965310614 = messageFormatterFn((function(  ) {
  return function(d) { return "IATA-kod:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1094097143 = messageFormatterFn((function(  ) {
  return function(d) { return "Namn: " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1144139725 = messageFormatterFn((function(  ) {
  return function(d) { return "Plats: " + d["0"] + ", " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1396356629 = messageFormatterFn((function(  ) {
  return function(d) { return "Flygplatskoder:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1237038205 = messageFormatterFn((function(  ) {
  return function(d) { return "IATA: " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1235743738 = messageFormatterFn((function(  ) {
  return function(d) { return "ICAO: " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1881893519 = messageFormatterFn((function(  ) {
  return function(d) { return "Information från Wikipedia om " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b943354683 = messageFormatterFn((function(  ) {
  return function(d) { return "Officiell webbplats för " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1514250326 = messageFormatterFn((function(  ) {
  return function(d) { return "Regn: " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1777188710 = messageFormatterFn((function(  ) {
  return function(d) { return "MAX: " + d["0"] + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2131652558 = messageFormatterFn((function(  ) {
  return function(d) { return "MIN: " + d["0"] + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1498792327 = messageFormatterFn((function(  ) {
  return function(d) { return "Längdgrad: " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a769231658 = messageFormatterFn((function(  ) {
  return function(d) { return "Breddgrad: " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1980450900 = messageFormatterFn((function(  ) {
  return function(d) { return "Förseningsprognos"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2059107965 = messageFormatterFn((function(  ) {
  return function(d) { return "Minimala störningar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2088177725 = messageFormatterFn((function(  ) {
  return function(d) { return "Måttliga störningar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a132845870 = messageFormatterFn((function(  ) {
  return function(d) { return "Grova störningar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b607981948 = messageFormatterFn((function(  ) {
  return function(d) { return "Flygplatsinformation"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b619680399 = messageFormatterFn((function(  ) {
  return function(d) { return "Bild med flygplatskarta"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1361630180 = messageFormatterFn((function(  ) {
  return function(d) { return "Fotogalleri – Flygplatskarta"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1522807202 = messageFormatterFn((function(  ) {
  return function(d) { return "Stäng flygplatsens fotogalleri"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b860288308 = messageFormatterFn((function(  ) {
  return function(d) { return "Stäng karta över flygplatsens närområde"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1052550846 = messageFormatterFn((function(  ) {
  return function(d) { return "Bild med flygplatskarta"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b867500108 = messageFormatterFn((function(  ) {
  return function(d) { return "Karta över flygplatsens närområde"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b452724237 = messageFormatterFn((function(  ) {
  return function(d) { return "Nuvarande förhållanden på " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1417218151 = messageFormatterFn((function(  ) {
  return function(d) { return "Få de bästa erbjudandena i " + d["0"] + ", " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a273457612 = messageFormatterFn((function(  ) {
  return function(d) { return "Få de bästa erbjudandena nära " + d["0"] + " för " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a712967250 = messageFormatterFn((function(  ) {
  return function(d) { return "Till helgen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1625877945 = messageFormatterFn((function(  ) {
  return function(d) { return "Billigaste helgen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a421148714 = messageFormatterFn((function(  ) {
  return function(d) { return "Ikväll"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a56086969 = messageFormatterFn((function(  ) {
  return function(d) { return "Se priser nära " + d["0"] + " för ikväll " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1051364012 = messageFormatterFn((function(  ) {
  return function(d) { return "Kolla priserna i " + d["0"] + " för ikväll, " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1857843847 = messageFormatterFn((function(  ) {
  return function(d) { return "Kolla priserna i " + d["0"] + " inför nästa helg, " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b421374595 = messageFormatterFn((function(  ) {
  return function(d) { return "Bäst erbjudande"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a370404332 = messageFormatterFn((function(  ) {
  return function(d) { return "Se priser nära " + d["0"] + " för nästa helg " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b109713882 = messageFormatterFn((function(  ) {
  return function(d) { return "Kolla priserna i " + d["0"] + " för imorgon natt, " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a705157021 = messageFormatterFn((function(  ) {
  return function(d) { return "Nästa helg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b219511940 = messageFormatterFn((function(  ) {
  return function(d) { return "Kolla priserna i " + d["0"] + " inför helgen, " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1406447477 = messageFormatterFn((function(  ) {
  return function(d) { return "Se priser nära " + d["0"] + " inför imorgon kväll " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b439458364 = messageFormatterFn((function(  ) {
  return function(d) { return "Hämta pris"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1263283836 = messageFormatterFn((function(  ) {
  return function(d) { return "Imorgon kväll"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1196410911 = messageFormatterFn((function(  ) {
  return function(d) { return "Se priser nära " + d["0"] + " inför helgen " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b432086299 = messageFormatterFn((function(  ) {
  return function(d) { return "Om två veckor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1498519860 = messageFormatterFn((function(  ) {
  return function(d) { return "Se priser nära " + d["0"] + " inför helgen om två veckor " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1426069553 = messageFormatterFn((function(  ) {
  return function(d) { return "Se priser i " + d["0"] + " inför helgen om två veckor " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b600773428 = messageFormatterFn((function(  ) {
  return function(d) { return "Om en månad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b881016101 = messageFormatterFn((function(  ) {
  return function(d) { return "Se priser nära " + d["0"] + " inför helgen om en månad " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1220106122 = messageFormatterFn((function(  ) {
  return function(d) { return "Se priser i " + d["0"] + " inför helgen om en månad " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b207182877 = messageFormatterFn((function(  ) {
  return function(d) { return "Om två månader"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a501007794 = messageFormatterFn((function(  ) {
  return function(d) { return "Se priser nära " + d["0"] + " inför helgen om två månader " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b133795251 = messageFormatterFn((function(  ) {
  return function(d) { return "Se priser i " + d["0"] + " inför helgen om två månader " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b837135679 = messageFormatterFn((function(  ) {
  return function(d) { return "Tillämpa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b31524073 = messageFormatterFn((function(  ) {
  return function(d) { return "Resultaten hämtas"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1510292599 = messageFormatterFn((function(  ) {
  return function(d) { return "Resultaten har uppdaterats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a142235349 = messageFormatterFn((function(  ) {
  return function(d) { return "Avboka din resa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1574011964 = messageFormatterFn((function(  ) {
  return function(d) { return "Ditt flyg har blivit inställt och flygbolaget har bokat om dig på ett annat flyg. Vi har upptäckt att det finns en risk att du missar ditt anslutande flyg eftersom mellanlandningen inte ger dig tillräckligt med tid för att ta dig till gaten."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1574011003 = messageFormatterFn((function(  ) {
  return function(d) { return "Om du inte tänker resa kan vi avboka hela resan åt dig. Om du avbokar kommer alla flyg som är kopplade till resplanen att avbokas. Vi kommer också att ge dig flygbolagskredit för det ursprungliga biljettpriset, som du kan använda till en framtida flygresa med samma flygbolag. Du behöver inte betala någon avbokningsavgift."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1574010042 = messageFormatterFn((function(  ) {
  return function(d) { return "Om du inte vill avboka din resa, låter vi den ändrade resplanen vara som den är."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1574009081 = messageFormatterFn((function(  ) {
  return function(d) { return "Vill du avboka din resa?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1571781706 = messageFormatterFn((function(  ) {
  return function(d) { return "Genom att klicka på ”Ja, avboka min resa” bekräftar jag att jag vill avboka alla flyg som är kopplade till min resplan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1545361899 = messageFormatterFn((function(  ) {
  return function(d) { return "Ja, avboka min resa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1659774390 = messageFormatterFn((function(  ) {
  return function(d) { return "Nej, avboka inte"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a574771218 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har avbokat din resa."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1800776793 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kommer att skicka en e-postbekräftelse till " + d["0"] + " inom 14 dagar. Det är inte säkert att vi kommer kunna skicka ett svar innan ditt avresedatum. Men vi kan försäkra dig om att din avbokning kommer att behandlas. Du behöver inte göra något mer."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1800775832 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kommer att få flygbolagskredit för det ursprungliga biljettpriset, som du kan använda till en framtida flygresa med samma flygbolag."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1800774871 = messageFormatterFn((function(  ) {
  return function(d) { return "På grund av den stora mängden resestörningar kan det ta upp till 30 dagar att behandla din flygbolagskredit. Du kommer att få ett till e-postmeddelande när flygbolagskrediten är tillgänglig. I e-postmeddelandet får du reda på mängden flygbolagskredit, giltighetstiden och hur du använder krediten för en framtida flygresa."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1833665938 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har inte avbokat din resa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a363400743 = messageFormatterFn((function(  ) {
  return function(d) { return "Tack för att du bekräftar att du vill behålla din resa."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a363401704 = messageFormatterFn((function(  ) {
  return function(d) { return "Många flyg har ställts in på grund av covid-19. Detta innebär att alternativen för att boka om ditt flyg är begränsade. Den nya flygresan var det bästa alternativet som flygbolaget kunde erbjuda."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a363402665 = messageFormatterFn((function(  ) {
  return function(d) { return "Du hittar den senaste informationen om din resa i din resplan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a539355477 = messageFormatterFn((function(  ) {
  return function(d) { return "Ja, få en kupong på " + d["0"] + " % " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1018536143 = messageFormatterFn((function(  ) {
  return function(d) { return "Nej, få återbetalning på 100 %"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1220960244 = messageFormatterFn((function(  ) {
  return function(d) { return "Få en kupong på " + d["0"] + " % för din hotellavbokning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1406738181 = messageFormatterFn((function(  ) {
  return function(d) { return "För din avbokade hotellbokning kan du be här om att få en kupong till ett värde på " + d["0"] + " % av värdet för den ursprungliga hotellbokningen istället för en full återbetalning. Om du väljer det här alternativet får du den här privata kupongen på ditt " + d["1"] + "-konto inom 30 dagar. Vi kommer att kontakta dig när din kupong är tillgänglig."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1406739142 = messageFormatterFn((function(  ) {
  return function(d) { return "Du behöver logga in på ditt konto hos " + d["0"] + " för att få tillgång till kupongkoden. Om du inte har något konto hos " + d["0"] + ", kommer vi att skapa ett åt dig genom att använda e-postadressen " + d["1"] + ". Vi skapar ett tillfälligt lösenord för dig och ber dig att skapa ett nytt lösenord när du loggar in för första gången."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1406740103 = messageFormatterFn((function(  ) {
  return function(d) { return "Vill du få den här kupongen?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1465111005 = messageFormatterFn((function(  ) {
  return function(d) { return "Genom att välja Ja, få en kupong på " + d["0"] + " % " + d["1"] + ", bekräftar jag att jag vill få en kupong till ett värde på " + d["0"] + " % av värdet på min ursprungliga bokning."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b394909560 = messageFormatterFn((function(  ) {
  return function(d) { return "Läs våra regler och villkor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1010019950 = messageFormatterFn((function(  ) {
  return function(d) { return "Tack! Ditt val har uppdaterats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1185877301 = messageFormatterFn((function(  ) {
  return function(d) { return "Om du valde att få kupongen på " + d["0"] + " %, kommer du att få den inom 30 dagar på samma " + d["1"] + "-konto som du använde för att göra den ursprungliga bokningen; logga bara in för att komma åt det."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1185876340 = messageFormatterFn((function(  ) {
  return function(d) { return "Om du inte har något konto hos " + d["0"] + ", kommer vi att skapa ett åt dig. Vi skapar ett tillfälligt lösenord för dig och ber dig att skapa ett nytt lösenord när du loggar in för första gången."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1185875379 = messageFormatterFn((function(  ) {
  return function(d) { return "Om du valde att behålla återbetalningen på 100 % behöver du inte göra något mer."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1143372681 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi är ledsna, men erbjudandet att byta ut din fulla återbetalning mot en kupong har gått ut. Din kontantåterbetalning kommer att krediteras till din ursprungliga betalningsmetod enligt överenskommelse."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1955332174 = messageFormatterFn((function(  ) {
  return function(d) { return "Tyvärr, något gick fel. Vi kommer att kreditera din fulla återbetalning till din ursprungliga betalningsmetod enligt överenskommelse. Vi ber om ursäkt för eventuella besvär."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1639946594 = messageFormatterFn((function(  ) {
  return function(d) { return "Något gick fel."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1566862082 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kan inte ge dig en återbetalning för du har redan bett om en kupong. Din kupongförfrågan håller på att behandlas nu."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a81361217 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "-kupong"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1443500024 = messageFormatterFn((function(  ) {
  return function(d) { return "Denna kupong utfärdas av " + d["0"] + " till vissa kunder som påverkas av coronaviruset covid-19. Om du har valt att få den här kupongen är du bunden av de villkor som anges häri. Denna kupong kommer att utfärdas för hela beloppet av din avbokade resebokning, inklusive skatter/skatteavgifter och eventuella avgifter, i förekommande fall, som ursprungligen debiterats (”basvärde”) plus ett extra kampanjbelopp motsvarande en procentandel av basvärdet (”kampanjvärde”).  Du bekräftar att basvärdet du får i form av denna kupong utgör en full återbetalning av alla rumsuthyrningsbelopp, underlättnings- och serviceavgifter samt skatter/skatteavgifter som debiterades dig vid din ursprungliga bokning."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1443500985 = messageFormatterFn((function(  ) {
  return function(d) { return "Berättigade bokningar: Denna kupong kan endast tillämpas för separata hotellbokningar som görs online på <a href=\"" + d["0"] + "\">" + d["1"] + "</a> och som förskottsbetalas vid bokningstillfället (med förbehåll för de begränsningar som anges i villkoren nedan)."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1443501946 = messageFormatterFn((function(  ) {
  return function(d) { return "Period för inlösen: Kupongen har inget utgångsdatum."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1172556508 = messageFormatterFn((function(  ) {
  return function(d) { return "Hur man löser in kupongen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a189582299 = messageFormatterFn((function(  ) {
  return function(d) { return "Du måste göra din separata hotellbokning med <a href=\"" + d["0"] + "\">" + d["1"] + "</a>"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a189583260 = messageFormatterFn((function(  ) {
  return function(d) { return "Använd webbsidan för att söka efter önskade vistelsedatum."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a189584221 = messageFormatterFn((function(  ) {
  return function(d) { return "Du måste vara inloggad på ditt " + d["0"] + "-användarkonto för att använda kupongen.  Om du ännu inte har ett " + d["0"] + "-konto, måste du skapa ett konto innan kupongen utfärdas. Den här kupongen kan inte tillämpas på bokningar med gästkonto."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a189585182 = messageFormatterFn((function(  ) {
  return function(d) { return "Under bokningsprocessen kommer du på betalningssidan att se sektionen ”Ange kupong- eller kampanjkod”, där en kod ska anges."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a189586143 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange kupongkoden i rätt fält och klicka sedan på ”Tillämpa kupong”. Om din bokning är kvalificerad, dras det tillämpliga beloppet från resebokningens pris men kan inte tillämpas på några skatter/skatteavgifter, tillämpliga avgifter, extrakostnader eller andra avgifter/kostnader som anges i paragraf 2 nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1314956325 = messageFormatterFn((function(  ) {
  return function(d) { return "Regler och villkor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1617872164 = messageFormatterFn((function(  ) {
  return function(d) { return "Med förbehåll för de begränsningar som anges i dessa villkor och i enlighet med ovanstående kan kupongen tillämpas på en separat och förskottsbetalad hotellbokning (inte en hotellbokning i kombination med en annan produkt såsom flyg + hotell eller flyg + hotell + bil) online via <a href=\"" + d["0"] + "\">" + d["1"] + "</a>.  Kupongen kan endast användas vid bokningar som förbetalas och kan inte lösas in mot bokningar som betalas på destinationen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1617871203 = messageFormatterFn((function(  ) {
  return function(d) { return "Kupongen kan inte lösas in mot skatter/skatteavgifter leverantörsavgifter, avboknings- eller ändringsavgifter, administrativa avgifter eller andra kostnader som ska betalas av kunden."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1617870242 = messageFormatterFn((function(  ) {
  return function(d) { return "Vanliga regler och villkor gäller (se <a href=\"" + d["0"] + "\">" + d["1"] + "</a>) och alla bokningar gäller i mån av plats."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1617869281 = messageFormatterFn((function(  ) {
  return function(d) { return "Kupongen kan inte kombineras med andra kuponger, kampanjer eller specialerbjudanden. Begränsning på en kupong per kvalificerande hotellbokning."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1617868320 = messageFormatterFn((function(  ) {
  return function(d) { return "Kupongen kan inte användas för tidigare gjord bokning.  Den anses som inlöst när en kvalificerande bokning har gjorts. Om ditt bokningsbelopp är mindre än kupongbeloppet får du restbeloppet i form av en annan kupong. Kupongen kan inte återanvändas, även om du ändrar eller avbokar din bokning. Om du ändrar eller avbokar en bokning som du gjort med kupongen, kommer eventuellt restbelopp att överföras till dig i form av en annan kupong. När kontantåterbetalningar av outnyttjade delar av kupongen krävs enligt lag, kommer återbetalningarna att begränsas till endast basvärdet, men inte till något återstående kampanjvärde. Kupongens basvärde kommer anses ha lösts in först, följt av kampanjvärdet."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1617867359 = messageFormatterFn((function(  ) {
  return function(d) { return "Kupongen är ogiltig när den är förbjuden enligt lag och får endast användas av den avsedda mottagaren som måste vara 18 år eller äldre."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1617866398 = messageFormatterFn((function(  ) {
  return function(d) { return "Otillbörligt användande av kupongen, inklusive, men inte begränsat till, publicering eller försäljning av kupongen är förbjudet och kan utgöra bedrägeri. "; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1617865437 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " förbehåller sig rätten att när som helst ändra eller dra tillbaka detta erbjudande och häva de bokningar som gjorts där kupongen erhållits på felaktigt sätt eller använts för spekulativa, falska eller bedrägliga bokningar."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1617864476 = messageFormatterFn((function(  ) {
  return function(d) { return "Det här erbjudandet tillhandahålls av Expedia, Inc."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1385582186 = messageFormatterFn((function(  ) {
  return function(d) { return "Regler och villkor för denna kupong gäller enligt angivet och kan inte ändras av någon obehörig representant, såsom anställda på Expedia, Inc. Dessa regler och villkor tillämpas och hanteras i enlighet med gällande lagar i Washington State, USA."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1385583147 = messageFormatterFn((function(  ) {
  return function(d) { return "Alla tvister rörande denna kupong (”anspråk”) kommer att lösas genom bindande skiljedom snarare än i domstol, förutom att du kan hävda anspråk på individuell basis i domstolen för små anspråk om de är kvalificerade. Detta inkluderar alla anspråk som du hävdar mot oss, våra dotterbolag, reseleverantörer eller företag som erbjuder produkter eller tjänster genom oss (som är mottagare av detta skiljedomsavtal). Alla förfaranden för att lösa anspråk kommer att genomföras endast på individuell basis och inte som grupp-, konsoliderad eller representativ talan. Om ett anspråk av någon anledning går vidare till domstol i stället för till skiljedomsförfarande frånsäger var och en av oss all rätt till juryrättegång. USA:s federala skiljedomslag och USA:s federala skiljedomslagstiftning gäller för dessa villkor. Ett skiljedomsbeslut kan bekräftas av alla behöriga domstolar."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a213674500 = messageFormatterFn((function(  ) {
  return function(d) { return "Avboka din bokning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1621777870 = messageFormatterFn((function(  ) {
  return function(d) { return "Avboka din bokning på " + d["0"] + " senast " + d["1"] + " och välj ett av följande alternativ:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1621778831 = messageFormatterFn((function(  ) {
  return function(d) { return "En kupong till ett värde av " + d["0"] + " % av det ursprungliga inköpspriset, som går att använda för att boka boende i framtiden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1621779792 = messageFormatterFn((function(  ) {
  return function(d) { return "En återbetalning på 100 % till din ursprungliga betalningsmetod"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1621780753 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kommer inte att behöva betala någon avbokningsavgift om du avbokar. Obs: Det kan ta upp till 30 dagar att behandla din kupong eller återbetalning."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b112227468 = messageFormatterFn((function(  ) {
  return function(d) { return "Genom att välja Avboka och få en kupong på " + d["0"] + " % eller Avboka och få en återbetalning på 100 %, bekräftar jag att jag vill att " + d["1"] + " avbokar min bokning."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a87881823 = messageFormatterFn((function(  ) {
  return function(d) { return "Läs reglerna och villkoren för kupongen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a659628383 = messageFormatterFn((function(  ) {
  return function(d) { return "Avboka och få en kupong på " + d["0"] + " %"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b926814350 = messageFormatterFn((function(  ) {
  return function(d) { return "Avboka och få en återbetalning på 100 %"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b7657798 = messageFormatterFn((function(  ) {
  return function(d) { return "Avboka inte"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b874045585 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har avbokat din bokning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1270196852 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi skickar en bekräftelse till " + d["0"] + " inom 24 timmar. Det kan ta upp till 30 dagar att få din återbetalning på 100 %."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a872871977 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kommer att kontakta dig när din kupong är redo. Du kommer att få tillgång till den från samma konto som du använde för din ursprungliga bokning. Om du inte har något konto, kommer vi att skapa ett åt dig genom att använda e-postadressen " + d["0"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a872872938 = messageFormatterFn((function(  ) {
  return function(d) { return "<b>Obs</b>: Det kan ta upp till 30 dagar innan du får din kuong på " + d["0"] + " %."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1670390415 = messageFormatterFn((function(  ) {
  return function(d) { return "Din bokning är fortfarande aktiv"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1940855174 = messageFormatterFn((function(  ) {
  return function(d) { return "Tack för att du bekräftar att du vill behålla din bokning."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b567810326 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi jobbar på att fixa det"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b620188632 = messageFormatterFn((function(  ) {
  return function(d) { return "Det verkar som om du redan har skickat in den här förfrågan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b620187671 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi börjar behandla din förfrågan så snart vi kan. Vi prioriterar förfrågningar efter resedatum och börjar med dem som har tidigast resedatum. I vissa fall är det möjligt att vi inte kan svara dig förrän efter din resa skulle ha påbörjats. Du behöver inte göra något mer, även om du inte hör något från oss direkt."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b620186710 = messageFormatterFn((function(  ) {
  return function(d) { return "<b>Obs:</b> Det kan ta upp till 30 dagar att behandla återbetalningar."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2055371096 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi beklagar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a881412217 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi hittar inte resplansnumret eller bekräftelsenumret. Kontrollera numret och försök igen. Du hittar numret i e-postmeddelandet du fick från oss när du utförde din bokning."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b212101626 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kan inte behandla din förfrågan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b212100665 = messageFormatterFn((function(  ) {
  return function(d) { return "Viktigt: Detta formulär ska endast användas för resedatum fram till 31 maj 2020. Om startdatumet för din resa infaller efter 31 maj 2020 ber vi dig att återkomma senare. Många av våra resepartners erbjuder för närvarande uppdaterade policyer till och med 31 maj 2020. Om du återkommer senare kan vi se till att de mest uppdaterade policyerna gäller för dina resplaner."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a953460197 = messageFormatterFn((function(  ) {
  return function(d) { return "Ditt flygbolag tar hand om alla avbokningar. Kontakta flygbolaget direkt."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1715238847 = messageFormatterFn((function(  ) {
  return function(d) { return "Något gick fel. Försök igen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1459150329 = messageFormatterFn((function(  ) {
  return function(d) { return "Antingen känner vi inte igen e-postadressen, eller så stämmer den inte överens med e-postadressen som är kopplad till det resplansnummer du angav. Ange samma e-postadress som du använde när du utförde den ursprungliga bokningen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2137251829 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi känner inte igen telefonnumret. Ange samma telefonnummer som du använde när du utförde den ursprungliga bokningen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b170223843 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kan inte utföra din avbokning eftersom det är mindre än 24 timmar kvar till ditt resedatum. Vill du ha mer information ska du logga in på ditt konto och kontrollera din resplan online."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1525445538 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kan avboka vissa av dina bokningar, men vi kan inte avboka alla. I de fall vi inte kan avboka ber vi dig att kontakta leverantören direkt."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1525446499 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan använda din resplan online för att ta reda på vilka bokningar som fortfarande måste avbokas. Obs: Det kan ta upp till 72 timmar för pågående avbokningar innan de visas som avbokade i din resplan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1861560053 = messageFormatterFn((function(  ) {
  return function(d) { return "Alla bokningar i den här resplanen har redan avbokats. Vill du ha mer information ska du logga in på ditt konto och kontrollera din resplan online."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1995247265 = messageFormatterFn((function(  ) {
  return function(d) { return "Ditt incheckningsdatum har passerat. Tyvärr går det inte längre att behandla din avbokning, eller utfärda någon återbetalning eller kupong."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1693355687 = messageFormatterFn((function(  ) {
  return function(d) { return "Tyvärr kan vi inte behandla din förfrågan eftersom deadlinen för avbokning ligger för nära. I din resplan hittar du mer information om hur du kan kontakta oss."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1066820405 = messageFormatterFn((function(  ) {
  return function(d) { return "Avboka dina flyg senast " + d["0"] + ", så får du flygbolagskredit av flygbolaget till ett värde som motsvarar det ursprungliga biljettpriset. Krediten går att använda för en framtida flygresa med samma flygbolag. Om du väljer att avboka kommer följande flyg att avbokas:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1066817522 = messageFormatterFn((function(  ) {
  return function(d) { return "Om flygbolaget redan har avbokat din bokning kan du ignorera det här meddelandet.  Om du har en paketbokning kommer inte några andra komponenter att avbokas på grund av detta."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a62536233 = messageFormatterFn((function(  ) {
  return function(d) { return "Avboka ditt flyg med " + d["0"] + " senast " + d["1"] + ", så får du flygbolagskredit av flygbolaget till ett värde som motsvarar det ursprungliga biljettpriset. Krediten går att använda för en framtida flygresa med samma flygbolag. Om du väljer att avboka kommer följande flyg att avbokas:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1716740379 = messageFormatterFn((function(  ) {
  return function(d) { return "Avboka din resa till " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1343204788 = messageFormatterFn((function(  ) {
  return function(d) { return "Om du avbokar din resa kommer vi att behandla avbokningen enligt informationen som finns i din resplan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1343205749 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi avbokar samtliga bokningar för den här resan. Eventuella bokningar som redan avbokats kommer inte att påverkas."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2105391769 = messageFormatterFn((function(  ) {
  return function(d) { return "På grund av typen av biljett kan vi inte avboka följande biljett åt dig. Kontakta flygbolaget direkt för att utföra ändringar."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1429249765 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ": " + d["1"] + " - " + d["2"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b302628971 = messageFormatterFn((function(  ) {
  return function(d) { return "Hyrbil med " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b638282537 = messageFormatterFn((function(  ) {
  return function(d) { return "1 aktivitet"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b823659964 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " aktiviteter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1954916867 = messageFormatterFn((function(  ) {
  return function(d) { return "1 flygtransfer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1294704016 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " flygtransfer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1343207671 = messageFormatterFn((function(  ) {
  return function(d) { return "Vill du avboka din resa?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b107844332 = messageFormatterFn((function(  ) {
  return function(d) { return "Genom att välja “Ja, avboka min resa” bekräftar jag att jag vill avboka samtliga bokningar i min resplan som inte redan har avbokats."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b178794542 = messageFormatterFn((function(  ) {
  return function(d) { return "Genom att välja “Ja, avboka min resa” bekräftar jag att jag vill avboka samtliga bokningar i den första listan som inte redan har avbokats."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1583945309 = messageFormatterFn((function(  ) {
  return function(d) { return "Ja, avboka min resa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a930973160 = messageFormatterFn((function(  ) {
  return function(d) { return "Nej, avboka inte"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a117408974 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har skickat in din förfrågan om att avboka din resa till " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b602163093 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kommer att få en e-postbekräftelse från oss inom några veckor."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b602162132 = messageFormatterFn((function(  ) {
  return function(d) { return "I vissa fall är det möjligt att vi inte kan svara dig förrän efter din resa skulle ha påbörjats. Du behöver inte göra något mer, även om du inte hör av oss direkt."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b602161171 = messageFormatterFn((function(  ) {
  return function(d) { return "<b>Obs:</b> Det stora antalet inställda resor för närvarande kan innebära att det tar längre tid att utfärda kredit, kuponger och återbetalningar."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1512767184 = messageFormatterFn((function(  ) {
  return function(d) { return "Om du väljer att ändra eller avboka ditt flyg efter " + d["0"] + ", kommer de ursprungliga prisreglerna att gälla. Det kan innebära att flygändringar, återbetalningar och krediter kanske inte är tillåtna."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1904233254 = messageFormatterFn((function(  ) {
  return function(d) { return "<b>Obs:</b> Om flyget är en del av en paketbokning kommer endast flyget att avbokas. Du kommer att behöva avboka de resterande komponenterna i ditt paket separat."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1464504363 = messageFormatterFn((function(  ) {
  return function(d) { return "Det är möjligt att du är berättigad till återbetalning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1150988846 = messageFormatterFn((function(  ) {
  return function(d) { return "Du fick nyligen flygbolagskredit för ett avbokat flyg där bokningen hade gjorts via oss. Du kan vara berättigad till en återbetalning istället för din flygbolagskredit för följande bokning:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b788684949 = messageFormatterFn((function(  ) {
  return function(d) { return "Flygbolagets bekräftelsenummer: " + d["0"] + " (" + d["1"] + ")"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1150990768 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan vara berättigad till en återbetalning istället för den existerande krediten för flyget ovan. Om du är berättigad kommer vi att ansöka om återbetalning åt dig från flygbolaget, för det ursprungliga biljettpriset. Beloppet förs över till din ursprungliga betalningsmetod. För att ansöka om återbetalning, klicka nedan senast " + d["0"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2103242193 = messageFormatterFn((function(  ) {
  return function(d) { return "Obs: På grund av det höga antalet flygavbokningar i samband med covid-19, kan behandlingen av återbetalningar ta minst tolv veckor, beroende på flygbolag. Ej återbetalningsbara bokningsavgifter som debiterades vid betalningstillfället återbetalas ej."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1150991729 = messageFormatterFn((function(  ) {
  return function(d) { return "Återbetalningen gäller endast för flyget som står ovan. Om du bokat andra flyg som kan vara berättigade till en återbetalning, kommer du att få ett separat e-postmeddelande för varje flyg. Om du bokat ett semesterpaket, täcker denna ansökan endast flygdelen i paketet."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1150992690 = messageFormatterFn((function(  ) {
  return function(d) { return "Vill du att vi ska ansöka om en återbetalning åt dig?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1221566886 = messageFormatterFn((function(  ) {
  return function(d) { return "Genom att välja \"Ja, ansök om återbetalning\" godkänner jag att ge upp min flygbolagskredit om jag kan få en återbetalning."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b697078437 = messageFormatterFn((function(  ) {
  return function(d) { return "Ja, ansök om återbetalning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a541242385 = messageFormatterFn((function(  ) {
  return function(d) { return "Nej, jag vill behålla min flygbolagskredit"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1197612876 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har ansökt om återbetalning för dig"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1314038099 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har skickat en ansökan om återbetalning till flygbolaget å dina vägnar. Om du är berättigad till återbetalning, kommer den att vara på samma belopp som det ursprungliga biljettpriset och kommer att göras till din ursprungliga betalningsmetod. Om flygbolaget inte kan ge dig någon återbetalning, kommer din flygbolagskredit fortfarande att finnas tillgänglig på ditt konto."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1314037138 = messageFormatterFn((function(  ) {
  return function(d) { return "Obs: På grund av det höga antalet flygavbokningar i samband med covid-19, kan behandlingen av återbetalningar ta minst tolv veckor, beroende på flygbolag. Du behöver inte göra något mer."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1178950179 = messageFormatterFn((function(  ) {
  return function(d) { return "Tack"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a978119478 = messageFormatterFn((function(  ) {
  return function(d) { return "Tack för att du bekräftar att du vill behålla din flygbolagskredit. Du hittar information om hur du använder din kredit i ditt konto."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1737641671 = messageFormatterFn((function(  ) {
  return function(d) { return "Din återbetalningsförfrågan"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1556863968 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har nyss fått flygbolagskredit för ett flyg med " + d["0"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1556865890 = messageFormatterFn((function(  ) {
  return function(d) { return "Om du vill ansöka om återbetalning ska du meddela oss senast " + d["0"] + ", så kommer en återbetalning motsvarande det ursprungliga biljettpriset att utföras till din ursprungliga betalningsmetod. Återbetalningen gäller endast för flyget som anges ovan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1556867812 = messageFormatterFn((function(  ) {
  return function(d) { return "Vill du att vi ska byta din kredit mot en återbetalning?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b128745624 = messageFormatterFn((function(  ) {
  return function(d) { return "Om du väljer “Ja, ansök om återbetalning” godkänner jag att ge upp min flygbolagskredit i utbyte mot en återbetalning."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a59837417 = messageFormatterFn((function(  ) {
  return function(d) { return "Ja, ansök om återbetalning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1298158239 = messageFormatterFn((function(  ) {
  return function(d) { return "Nej, jag vill behålla min flygbolagskredit"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a675128574 = messageFormatterFn((function(  ) {
  return function(d) { return "Tack"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1029896645 = messageFormatterFn((function(  ) {
  return function(d) { return "På grund av det ovanligt stora antalet störningar i resetrafiken kan förseningar förekomma för behandling av återbetalningar. Vi ber om ursäkt för eventuell väntetid och uppskattar ditt tålamod. Du behöver inte göra något mer."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1029895684 = messageFormatterFn((function(  ) {
  return function(d) { return "Din återbetalning kommer att behandlas snart, förutsatt att du inte redan har ansökt om återbetalning eller fått en återbetalning tidigare."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1569354447 = messageFormatterFn((function(  ) {
  return function(d) { return "Tack"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1629863192 = messageFormatterFn((function(  ) {
  return function(d) { return "Tack för att du bekräftar att du vill behålla din flygbolagskredit. Du hittar information om hur du använder din kredit i ditt konto."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a438041259 = messageFormatterFn((function(  ) {
  return function(d) { return "Om du ansöker om återbetalning, kommer beloppet för det ursprungliga biljettpriset att återbetalas till din ursprungliga betalningsmetod. Återbetalningen gäller endast för flyget som anges ovan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a438042220 = messageFormatterFn((function(  ) {
  return function(d) { return "Kontakta kundtjänst på " + d["0"] + " om du vill få en återbetalning istället för din flygbolagskredit."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1676635799 = messageFormatterFn((function(  ) {
  return function(d) { return "Viktigt meddelande"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a942729821 = messageFormatterFn((function(  ) {
  return function(d) { return "Öppnas i ett nytt fönster"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1409059524 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1736415077 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök hotell och flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1022551523 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök hotell och bilar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b889539902 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök hotell, flyg och bilar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1688048545 = messageFormatterFn((function(  ) {
  return function(d) { return "Se tillgänglighet"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1434338738 = messageFormatterFn((function(  ) {
  return function(d) { return "Se priser"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b823098599 = messageFormatterFn((function(  ) {
  return function(d) { return "Se erbjudanden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1053892901 = messageFormatterFn((function(  ) {
  return function(d) { return "Rätta till alla fel nedan för att fortsätta."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1062779724 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Korrigera " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " fel";}, one: function() { return "felet";}, two: function() { return number(d["0"]) + " fel";}, few: function() { return number(d["0"]) + " fel";}, many: function() { return number(d["0"]) + " fel";}, other: function() { return number(d["0"]) + " fel";} }) + " nedan för att fortsätta."; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2121751834 = messageFormatterFn((function(  ) {
  return function(d) { return "Gå till felet."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2059566791 = messageFormatterFn((function(  ) {
  return function(d) { return "Gå till det första felet"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a214036874 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + "-" + plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + " nätter";}, one: function() { return number(d["1"]) + " natt";}, two: function() { return number(d["1"]) + " nätter";}, few: function() { return number(d["1"]) + " nätter";}, many: function() { return number(d["1"]) + " nätter";}, other: function() { return number(d["1"]) + " nätter";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1070297514 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange datum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a931160072 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj datum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1050251256 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange giltigt incheckningsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1198984983 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange giltigt utcheckningsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1994305935 = messageFormatterFn((function(  ) {
  return function(d) { return "Lägg till ett utcheckningsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a857633072 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange ett giltigt datum för avresa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a576753004 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange ett giltigt datum för returresa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1374932106 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange ett giltigt hämtningsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a329654974 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange ett giltigt avlämningsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1500645925 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange ett giltigt startdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b420705164 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange ett giltigt slutdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a36620772 = messageFormatterFn((function(  ) {
  return function(d) { return "Ditt incheckningsdatum måste infalla mellan avresedatumet och datumet för returresan"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1036867703 = messageFormatterFn((function(  ) {
  return function(d) { return "Ditt utcheckningsdatum måste infalla mellan avresedatumet och datumet för returresan"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1252145786 = messageFormatterFn((function(  ) {
  return function(d) { return "Ditt incheckningsdatum måste infalla på ditt avresedatum eller senare"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1473557765 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Datumen får inte vara mer än " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " dagar";}, one: function() { return number(d["0"]) + " dag";}, two: function() { return number(d["0"]) + " dagar";}, few: function() { return number(d["0"]) + " dagar";}, many: function() { return number(d["0"]) + " dagar";}, other: function() { return number(d["0"]) + " dagar";} }) + " ifrån varandra"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a227488653 = messageFormatterFn((function(  ) {
  return function(d) { return "Utcheckningsdatum måste infalla efter incheckningsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1311248140 = messageFormatterFn((function(  ) {
  return function(d) { return "Utcheckningsdatum måste infalla inom 28 dagar efter incheckningsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2112257684 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " rum";}, one: function() { return number(d["0"]) + " rum";}, two: function() { return number(d["0"]) + " rum";}, few: function() { return number(d["0"]) + " rum";}, many: function() { return number(d["0"]) + " rum";}, other: function() { return number(d["0"]) + " rum";} }) + ", " + plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + " gäster";}, one: function() { return number(d["1"]) + " gäst";}, two: function() { return number(d["1"]) + " gäster";}, few: function() { return number(d["1"]) + " gäster";}, many: function() { return number(d["1"]) + " gäster";}, other: function() { return number(d["1"]) + " gäster";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a923318277 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " resenärer";}, one: function() { return number(d["0"]) + " resenär";}, two: function() { return number(d["0"]) + " resenärer";}, few: function() { return number(d["0"]) + " resenärer";}, many: function() { return number(d["0"]) + " resenärer";}, other: function() { return number(d["0"]) + " resenärer";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1390582545 = messageFormatterFn((function(  ) {
  return function(d) { return "Resenärer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b857806255 = messageFormatterFn((function(  ) {
  return function(d) { return "Gäster"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1140657711 = messageFormatterFn((function(  ) {
  return function(d) { return "Avbryt, stäng resenärsval utan att spara ändringarna. Eller redigera resenärsinformationen nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1119231763 = messageFormatterFn((function(  ) {
  return function(d) { return "Lägg till rum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a142950119 = messageFormatterFn((function(  ) {
  return function(d) { return "Be om 9 hotellrum eller fler"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1144411397 = messageFormatterFn((function(  ) {
  return function(d) { return "Vuxna"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b370858042 = messageFormatterFn((function(  ) {
  return function(d) { return "Ålder barn " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a231456468 = messageFormatterFn((function(  ) {
  return function(d) { return "Ålder på spädbarn " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1152059252 = messageFormatterFn((function(  ) {
  return function(d) { return "0-17 år"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a201961709 = messageFormatterFn((function(  ) {
  return function(d) { return "2-17 år"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1995500286 = messageFormatterFn((function(  ) {
  return function(d) { return "Yngre än 2 år"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b157902075 = messageFormatterFn((function(  ) {
  return function(d) { return "Yngre än 1 år"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1072397973 = messageFormatterFn((function(  ) {
  return function(d) { return "Spädbarn"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1057576779 = messageFormatterFn((function(  ) {
  return function(d) { return "Barn"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1362878837 = messageFormatterFn((function(  ) {
  return function(d) { return "Minst 12 år"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b626443439 = messageFormatterFn((function(  ) {
  return function(d) { return "2-11 år"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b694270079 = messageFormatterFn((function(  ) {
  return function(d) { return "Yngre än 2 år"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2039958275 = messageFormatterFn((function(  ) {
  return function(d) { return "Barn " + d["0"] + ", ålder uppdaterad till " + d["1"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1465469323 = messageFormatterFn((function(  ) {
  return function(d) { return "Spädbarn " + d["0"] + " på " + d["1"] + " år har uppdaterats."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1931882499 = messageFormatterFn((function(  ) {
  return function(d) { return "Minska antalet vuxna i rum " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1026424393 = messageFormatterFn((function(  ) {
  return function(d) { return "Minska antalet barn i rum " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1379254697 = messageFormatterFn((function(  ) {
  return function(d) { return "Minska antalet spädbarn i rum " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1550064387 = messageFormatterFn((function(  ) {
  return function(d) { return "Minska antalet vuxna"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b48076233 = messageFormatterFn((function(  ) {
  return function(d) { return "Minska antalet barn"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b762738775 = messageFormatterFn((function(  ) {
  return function(d) { return "Minska antalet spädbarn"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1394414697 = messageFormatterFn((function(  ) {
  return function(d) { return "Klar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1139601447 = messageFormatterFn((function(  ) {
  return function(d) { return "Öka antalet vuxna i rum " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a146455187 = messageFormatterFn((function(  ) {
  return function(d) { return "Öka antalet barn i rum " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a848934028 = messageFormatterFn((function(  ) {
  return function(d) { return "Öka antalet spädbarn i rum " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a122239449 = messageFormatterFn((function(  ) {
  return function(d) { return "Öka antalet vuxna"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a718141459 = messageFormatterFn((function(  ) {
  return function(d) { return "Öka antal barn"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2114592972 = messageFormatterFn((function(  ) {
  return function(d) { return "Öka antalet spädbarn"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b207996076 = messageFormatterFn((function(  ) {
  return function(d) { return "Ta bort rum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a851029852 = messageFormatterFn((function(  ) {
  return function(d) { return "Ta bort rum " + d["0"] + " av " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1582808066 = messageFormatterFn((function(  ) {
  return function(d) { return "Rum " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b248667994 = messageFormatterFn((function(  ) {
  return function(d) { return "Rum " + d["0"] + " av " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b211567845 = messageFormatterFn((function(  ) {
  return function(d) { return "Rum " + d["0"] + " tillagt. Redigera resenärsinformationen nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1641228938 = messageFormatterFn((function(  ) {
  return function(d) { return "Resenärsval öppet. Redigera resenärsinformationen nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1909972091 = messageFormatterFn((function(  ) {
  return function(d) { return "Rum borttaget. Redigera resenärsinformation för rum " + d["0"] + " nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1029644195 = messageFormatterFn((function(  ) {
  return function(d) { return "Under 1"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b682195355 = messageFormatterFn((function(  ) {
  return function(d) { return "Byt ut avreseort mot destination och vice versa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1327302243 = messageFormatterFn((function(  ) {
  return function(d) { return "Avreseort och destination har bytts ut mot varandra"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b972710422 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange en destination"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2099821584 = messageFormatterFn((function(  ) {
  return function(d) { return "Destination och avreseort kan inte vara desamma."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b579410522 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan bara boka paket för mellan en och sex resenärer. Ändra antalet resenärer i din sökning."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1934306550 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vi kan endast boka mellan 1 och " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " gäster";}, one: function() { return number(d["0"]) + " gäst";}, two: function() { return number(d["0"]) + " gäster";}, few: function() { return number(d["0"]) + " gäster";}, many: function() { return number(d["0"]) + " gäster";}, other: function() { return number(d["0"]) + " gäster";} }) + ". Ändra antalet resenärer i din sökning."; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b946754694 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi tillåter max sex resenärer per bokning."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1971462441 = messageFormatterFn((function(  ) {
  return function(d) { return "Det måste finnas minst 1 resenär (minst " + d["0"] + " år) för varje spädbarn i knät."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b204366116 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange barnens ålder."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a530272940 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange barnets ålder."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1801416131 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange spädbarnens ålder."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1255479724 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange spädbarnets ålder."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1129456744 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Tyvärr kan din bokning inte inkludera fler än " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " spädbarn";}, one: function() { return number(d["0"]) + " spädbarn";}, two: function() { return number(d["0"]) + " spädbarn";}, few: function() { return number(d["0"]) + " spädbarn";}, many: function() { return number(d["0"]) + " spädbarn";}, other: function() { return number(d["0"]) + " spädbarn";} }) + " per resenär (över " + d["1"] + " år)."; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2053864500 = messageFormatterFn((function(  ) {
  return function(d) { return "Till"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1901315794 = messageFormatterFn((function(  ) {
  return function(d) { return "Destination"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a201395568 = messageFormatterFn((function(  ) {
  return function(d) { return "Till"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b57224924 = messageFormatterFn((function(  ) {
  return function(d) { return "Till"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1968087266 = messageFormatterFn((function(  ) {
  return function(d) { return "Från"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b355421710 = messageFormatterFn((function(  ) {
  return function(d) { return "Från"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1170368108 = messageFormatterFn((function(  ) {
  return function(d) { return "Avresa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1918626896 = messageFormatterFn((function(  ) {
  return function(d) { return "Återresa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1506844559 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj datum för att se priser"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1084277807 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj en destination och datum för att se priser"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1772779217 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj datum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1746405814 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyg från"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1137893023 = messageFormatterFn((function(  ) {
  return function(d) { return "Stad eller flygplats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a877660048 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj en avreseort"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a858306612 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyg till"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b812059853 = messageFormatterFn((function(  ) {
  return function(d) { return "Stad eller flygplats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1120614394 = messageFormatterFn((function(  ) {
  return function(d) { return "Typ av flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1628790878 = messageFormatterFn((function(  ) {
  return function(d) { return "Tur-och-retur"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1052844549 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyg " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1822680788 = messageFormatterFn((function(  ) {
  return function(d) { return "Economy"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2146746650 = messageFormatterFn((function(  ) {
  return function(d) { return "Business Class"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b99453390 = messageFormatterFn((function(  ) {
  return function(d) { return "First Class"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2122882029 = messageFormatterFn((function(  ) {
  return function(d) { return "Premium Economy"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b182518989 = messageFormatterFn((function(  ) {
  return function(d) { return "Önskad klass"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1527103759 = messageFormatterFn((function(  ) {
  return function(d) { return "Avbryt och stäng fönstret med val av klass utan att spara ändringarna. Eller välj en annan klass nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a387313286 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange varifrån du ska flyga."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1152831922 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange vart du ska flyga."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b691755413 = messageFormatterFn((function(  ) {
  return function(d) { return "Lägg till flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1274601776 = messageFormatterFn((function(  ) {
  return function(d) { return "Ta bort flygresa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1686454196 = messageFormatterFn((function(  ) {
  return function(d) { return "Flygbolagets åldersregler"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b784560751 = messageFormatterFn((function(  ) {
  return function(d) { return "Var kommer spädbarnet att sitta?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1263865781 = messageFormatterFn((function(  ) {
  return function(d) { return "Var kommer spädbarnen att sitta?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2140365059 = messageFormatterFn((function(  ) {
  return function(d) { return "På egen sittplats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2093602433 = messageFormatterFn((function(  ) {
  return function(d) { return "I knät"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1557581925 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter resor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1722416712 = messageFormatterFn((function(  ) {
  return function(d) { return "Ring 1-888-444-1695 för expertråd om kryssningar."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1649109084 = messageFormatterFn((function(  ) {
  return function(d) { return "Boendenamn, stad eller flygplats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1225763125 = messageFormatterFn((function(  ) {
  return function(d) { return "Skapa en resa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a640179218 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj minst två komponenter:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b175437920 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj minst två komponenter för att skapa din resa:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1717662232 = messageFormatterFn((function(  ) {
  return function(d) { return "Semesterns längd"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a567639603 = messageFormatterFn((function(  ) {
  return function(d) { return "Önskad flygklass"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a785016351 = messageFormatterFn((function(  ) {
  return function(d) { return "Jag behöver bara boende under en del av resan"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1051073454 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj en till komponent"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b857832709 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj en annan kombination av komponenter för att börja skapa din resa."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b53388403 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj minst två komponenter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a893128229 = messageFormatterFn((function(  ) {
  return function(d) { return "För att skapa din resa måste du välja minst två komponenter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1342122877 = messageFormatterFn((function(  ) {
  return function(d) { return "Paket"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1534092929 = messageFormatterFn((function(  ) {
  return function(d) { return "Paket"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1758032279 = messageFormatterFn((function(  ) {
  return function(d) { return "Stad eller attraktion"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b428615782 = messageFormatterFn((function(  ) {
  return function(d) { return "Paket med flyg eller hyrbil kan bara bokas för vistelser på ett boende."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1960784660 = messageFormatterFn((function(  ) {
  return function(d) { return "Enkel"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1411891602 = messageFormatterFn((function(  ) {
  return function(d) { return "Flera destinationer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1612416314 = messageFormatterFn((function(  ) {
  return function(d) { return "Business Class"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1739229683 = messageFormatterFn((function(  ) {
  return function(d) { return "Ta bort"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1115176846 = messageFormatterFn((function(  ) {
  return function(d) { return "Ta bort flyg " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a485179443 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyg " + d["0"] + " har tagits bort"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b847605278 = messageFormatterFn((function(  ) {
  return function(d) { return "Hämtning och avlämning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b851935512 = messageFormatterFn((function(  ) {
  return function(d) { return "Hämtningsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1932842681 = messageFormatterFn((function(  ) {
  return function(d) { return "Hämtningstid"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b579892694 = messageFormatterFn((function(  ) {
  return function(d) { return "Avlämningsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a271723435 = messageFormatterFn((function(  ) {
  return function(d) { return "Avlämningstid"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1523846642 = messageFormatterFn((function(  ) {
  return function(d) { return "Hämtning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a65698756 = messageFormatterFn((function(  ) {
  return function(d) { return "Avlämning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1533198837 = messageFormatterFn((function(  ) {
  return function(d) { return "Hyrbilsfirma"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b254063527 = messageFormatterFn((function(  ) {
  return function(d) { return "Rabattyp"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a847380407 = messageFormatterFn((function(  ) {
  return function(d) { return "Inkluderar priser för AARP-medlemmar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1522060479 = messageFormatterFn((function(  ) {
  return function(d) { return "Medlemskap krävs och verifieras vid hämtning."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b439421909 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Förare under " + d["0"] + " eller över " + plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + " år";}, one: function() { return number(d["1"]) + " år";}, two: function() { return number(d["1"]) + " år";}, few: function() { return number(d["1"]) + " år";}, many: function() { return number(d["1"]) + " år";}, other: function() { return number(d["1"]) + " år";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a625523924 = messageFormatterFn((function(  ) {
  return function(d) { return "En extra avgift kan tillkomma för unga och äldre förare."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1244479178 = messageFormatterFn((function(  ) {
  return function(d) { return "Förarens ålder"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1798388921 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange förarens ålder."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1408214703 = messageFormatterFn((function(  ) {
  return function(d) { return "Jag vill hyra en bil på en annan plats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1289086078 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotellnamn"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b933660769 = messageFormatterFn((function(  ) {
  return function(d) { return "Boendets namn"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b866241139 = messageFormatterFn((function(  ) {
  return function(d) { return "Ute efter sport-, konsert- eller teaterevenemang?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2014381357 = messageFormatterFn((function(  ) {
  return function(d) { return "Är du ute efter sportevenemang, konserter eller musikfestivaler?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1200895735 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter evenemangsbiljetter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b516613265 = messageFormatterFn((function(  ) {
  return function(d) { return "Saker att göra i"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1195918154 = messageFormatterFn((function(  ) {
  return function(d) { return "Aktiviteter i"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1835889823 = messageFormatterFn((function(  ) {
  return function(d) { return "Lägg till boende"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1529792455 = messageFormatterFn((function(  ) {
  return function(d) { return "Lägg till flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a497689919 = messageFormatterFn((function(  ) {
  return function(d) { return "Lägg till bil"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b795576666 = messageFormatterFn((function(  ) {
  return function(d) { return "Ta bort ett hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1558709920 = messageFormatterFn((function(  ) {
  return function(d) { return "Ta bort ett flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1491598598 = messageFormatterFn((function(  ) {
  return function(d) { return "Ta bort en hyrbil"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a519460165 = messageFormatterFn((function(  ) {
  return function(d) { return "Endast direktflyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b505575781 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan endast lägga till ett flyg eller en hyrbil vid bokning av max sex rum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a731120601 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan endast lägga till ett flyg eller en hyrbil vid bokningar med max sex resenärer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b636390886 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyg + hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1381524484 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyg + hotell + bil"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1735047814 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyg + bil"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1995071404 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotell + bil"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1964102783 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1876556944 = messageFormatterFn((function(  ) {
  return function(d) { return "Jag behöver bara boende under en del av min vistelse"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a888338490 = messageFormatterFn((function(  ) {
  return function(d) { return "Avresa från"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1513277476 = messageFormatterFn((function(  ) {
  return function(d) { return "Destination"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1263183437 = messageFormatterFn((function(  ) {
  return function(d) { return "Stad eller flygplats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a841764763 = messageFormatterFn((function(  ) {
  return function(d) { return "Ditt avresedatum måste ligga efter avresedatumet för ditt tidigare flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a855429340 = messageFormatterFn((function(  ) {
  return function(d) { return "Det ser ut som om du endast valt en produkt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b374872671 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj en produkt till för att komma igång med din paketbokning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a487625017 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har valt flyg och hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1288192433 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har valt flyg, hotell och hyrbilar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1537490471 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har valt flyg och hyrbilar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a655851937 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har valt hotell och hyrbilar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1323746387 = messageFormatterFn((function(  ) {
  return function(d) { return "Incheckningsdatumet måste ligga på samma dag som ditt avresedatum eller efter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b987257118 = messageFormatterFn((function(  ) {
  return function(d) { return "Ditt utcheckningsdatum måste ligga efter ditt avresedatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1196905488 = messageFormatterFn((function(  ) {
  return function(d) { return "Incheckning måste ske mellan det första avresedatumet och det sista datumet för återresa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a23431937 = messageFormatterFn((function(  ) {
  return function(d) { return "Utcheckning måste ske mellan det första avresedatumet och det sista datumet för återresa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1690577996 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta de bästa erbjudandena på paketresor och all inclusive-semestrar."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1793264943 = messageFormatterFn((function(  ) {
  return function(d) { return "Från"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2056753611 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj en längd"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b542103349 = messageFormatterFn((function(  ) {
  return function(d) { return "Erbjudanden med transfer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a816325226 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Boka för " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " personer";}, one: function() { return number(d["0"]) + " person";}, two: function() { return number(d["0"]) + " personer";}, few: function() { return number(d["0"]) + " personer";}, many: function() { return number(d["0"]) + " personer";}, other: function() { return number(d["0"]) + " personer";} }) + " eller fler"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1726565747 = messageFormatterFn((function(  ) {
  return function(d) { return "Avresa tidigast"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a103050476 = messageFormatterFn((function(  ) {
  return function(d) { return "Återresa senast"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1788976893 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök all inclusive-resorter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1459790988 = messageFormatterFn((function(  ) {
  return function(d) { return "Boende"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1739990643 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotellnamn, stad eller flygplats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b922366346 = messageFormatterFn((function(  ) {
  return function(d) { return "Jag vill bo någon annanstans"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1707837771 = messageFormatterFn((function(  ) {
  return function(d) { return "Från"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a314425006 = messageFormatterFn((function(  ) {
  return function(d) { return "Till"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1795465217 = messageFormatterFn((function(  ) {
  return function(d) { return "Destination, boendenamn, flygplats, sevärdhet eller adress"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1537010033 = messageFormatterFn((function(  ) {
  return function(d) { return "Destination, boendenamn eller sevärdhet"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1342458524 = messageFormatterFn((function(  ) {
  return function(d) { return "Flygtransfer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b126999530 = messageFormatterFn((function(  ) {
  return function(d) { return "Från flygplatsen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b518155545 = messageFormatterFn((function(  ) {
  return function(d) { return "Till flygplatsen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1175928120 = messageFormatterFn((function(  ) {
  return function(d) { return "Från"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1840526873 = messageFormatterFn((function(  ) {
  return function(d) { return "Till"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1848503673 = messageFormatterFn((function(  ) {
  return function(d) { return "Flygplats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b933257052 = messageFormatterFn((function(  ) {
  return function(d) { return "Flygets ankomstdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b468011005 = messageFormatterFn((function(  ) {
  return function(d) { return "Flygets ankomsttid"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b636371745 = messageFormatterFn((function(  ) {
  return function(d) { return "Flygets avgångsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b171125698 = messageFormatterFn((function(  ) {
  return function(d) { return "Flygets avgångstid"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1943343591 = messageFormatterFn((function(  ) {
  return function(d) { return "Boka tur-och-retur"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b931913187 = messageFormatterFn((function(  ) {
  return function(d) { return "Hyrbilar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b407159762 = messageFormatterFn((function(  ) {
  return function(d) { return "Stad, flygplats eller adress"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1725353656 = messageFormatterFn((function(  ) {
  return function(d) { return "Samma som för hämtning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1399839549 = messageFormatterFn((function(  ) {
  return function(d) { return "Önskad firma"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1339191480 = messageFormatterFn((function(  ) {
  return function(d) { return "Jag har en rabattkod"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1978175520 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj hyrbilsfirma"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2000624687 = messageFormatterFn((function(  ) {
  return function(d) { return "Lägg till en annan avlämningsplats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a49680311 = messageFormatterFn((function(  ) {
  return function(d) { return "Förarens ålder"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a301642698 = messageFormatterFn((function(  ) {
  return function(d) { return "Jag har ingen kod"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b337133854 = messageFormatterFn((function(  ) {
  return function(d) { return "Företag eller kontrakt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1622700430 = messageFormatterFn((function(  ) {
  return function(d) { return "Special eller annons"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a194386893 = messageFormatterFn((function(  ) {
  return function(d) { return "Rabattkod"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1453354413 = messageFormatterFn((function(  ) {
  return function(d) { return "Rabattkupongkod"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1512200562 = messageFormatterFn((function(  ) {
  return function(d) { return "Företagsrabatt " + "#"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1514057194 = messageFormatterFn((function(  ) {
  return function(d) { return "Rabattkod för företag"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b322578460 = messageFormatterFn((function(  ) {
  return function(d) { return "FASTSTART Org ID"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a898260097 = messageFormatterFn((function(  ) {
  return function(d) { return "Alamo Insiders " + "#"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1697466118 = messageFormatterFn((function(  ) {
  return function(d) { return "AWD " + "#"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1228067309 = messageFormatterFn((function(  ) {
  return function(d) { return "Wizard " + "#"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1276592527 = messageFormatterFn((function(  ) {
  return function(d) { return "BCD " + "#"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1900349935 = messageFormatterFn((function(  ) {
  return function(d) { return "Fast Break " + "#"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b659648448 = messageFormatterFn((function(  ) {
  return function(d) { return "Dollar Express " + "#"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1873159226 = messageFormatterFn((function(  ) {
  return function(d) { return "Kund " + "#"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b486596181 = messageFormatterFn((function(  ) {
  return function(d) { return "Enterprise Plus " + "#"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a887964154 = messageFormatterFn((function(  ) {
  return function(d) { return "Kontrakt " + "#"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2133904925 = messageFormatterFn((function(  ) {
  return function(d) { return "Privilege " + "#"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a737012434 = messageFormatterFn((function(  ) {
  return function(d) { return "CDP"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1907788546 = messageFormatterFn((function(  ) {
  return function(d) { return "National Contract ID"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b121856552 = messageFormatterFn((function(  ) {
  return function(d) { return "Emerald Club ID"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a906004615 = messageFormatterFn((function(  ) {
  return function(d) { return "Företagskonto"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1143181292 = messageFormatterFn((function(  ) {
  return function(d) { return "Payless Perks " + "#"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b790109778 = messageFormatterFn((function(  ) {
  return function(d) { return "Blue Chip " + "#"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b61277130 = messageFormatterFn((function(  ) {
  return function(d) { return "Ace Rent A Car"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1799816030 = messageFormatterFn((function(  ) {
  return function(d) { return "Advantage Rent A Car"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b694262741 = messageFormatterFn((function(  ) {
  return function(d) { return "Alamo Rent A Car"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b151875190 = messageFormatterFn((function(  ) {
  return function(d) { return "Avis"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1941665360 = messageFormatterFn((function(  ) {
  return function(d) { return "Budget"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a643779219 = messageFormatterFn((function(  ) {
  return function(d) { return "Dollar Rent A Car"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1835365553 = messageFormatterFn((function(  ) {
  return function(d) { return "Economy Rent a Car"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b699116596 = messageFormatterFn((function(  ) {
  return function(d) { return "Enterprise"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a579736252 = messageFormatterFn((function(  ) {
  return function(d) { return "Europcar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b174106663 = messageFormatterFn((function(  ) {
  return function(d) { return "Fox Rent a Car"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1982338530 = messageFormatterFn((function(  ) {
  return function(d) { return "Hertz"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b338027592 = messageFormatterFn((function(  ) {
  return function(d) { return "Midway Car Rental"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b225106483 = messageFormatterFn((function(  ) {
  return function(d) { return "National Car Rental"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a895874708 = messageFormatterFn((function(  ) {
  return function(d) { return "NÜ Car Rentals"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a948708808 = messageFormatterFn((function(  ) {
  return function(d) { return "Payless"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b138443782 = messageFormatterFn((function(  ) {
  return function(d) { return "Routes Car Rental"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1107008509 = messageFormatterFn((function(  ) {
  return function(d) { return "Sixt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1575953725 = messageFormatterFn((function(  ) {
  return function(d) { return "Thrifty Car Rental"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a510225625 = messageFormatterFn((function(  ) {
  return function(d) { return "U-Save"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a579553185 = messageFormatterFn((function(  ) {
  return function(d) { return "Silvercar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2005046048 = messageFormatterFn((function(  ) {
  return function(d) { return "Green Motion"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a672777064 = messageFormatterFn((function(  ) {
  return function(d) { return "NextCar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b264255435 = messageFormatterFn((function(  ) {
  return function(d) { return "Rent-a-Wreck"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2045031255 = messageFormatterFn((function(  ) {
  return function(d) { return "Priceless"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1472127097 = messageFormatterFn((function(  ) {
  return function(d) { return "00.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1307391787 = messageFormatterFn((function(  ) {
  return function(d) { return "00.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a376240316 = messageFormatterFn((function(  ) {
  return function(d) { return "00.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1891688728 = messageFormatterFn((function(  ) {
  return function(d) { return "00.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1636447385 = messageFormatterFn((function(  ) {
  return function(d) { return "01.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1143071499 = messageFormatterFn((function(  ) {
  return function(d) { return "01.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a540560604 = messageFormatterFn((function(  ) {
  return function(d) { return "01.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2056009016 = messageFormatterFn((function(  ) {
  return function(d) { return "01.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1765530104 = messageFormatterFn((function(  ) {
  return function(d) { return "02.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1013988780 = messageFormatterFn((function(  ) {
  return function(d) { return "02.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a669643323 = messageFormatterFn((function(  ) {
  return function(d) { return "02.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2109875561 = messageFormatterFn((function(  ) {
  return function(d) { return "02.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1894612823 = messageFormatterFn((function(  ) {
  return function(d) { return "03.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b884906061 = messageFormatterFn((function(  ) {
  return function(d) { return "03.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a798726042 = messageFormatterFn((function(  ) {
  return function(d) { return "03.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1980792842 = messageFormatterFn((function(  ) {
  return function(d) { return "03.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2023695542 = messageFormatterFn((function(  ) {
  return function(d) { return "04.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b755823342 = messageFormatterFn((function(  ) {
  return function(d) { return "04.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a927808761 = messageFormatterFn((function(  ) {
  return function(d) { return "04.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1851710123 = messageFormatterFn((function(  ) {
  return function(d) { return "04.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2142189035 = messageFormatterFn((function(  ) {
  return function(d) { return "05.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b626740623 = messageFormatterFn((function(  ) {
  return function(d) { return "05.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1056891480 = messageFormatterFn((function(  ) {
  return function(d) { return "05.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1722627404 = messageFormatterFn((function(  ) {
  return function(d) { return "05.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2013106316 = messageFormatterFn((function(  ) {
  return function(d) { return "06.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b497657904 = messageFormatterFn((function(  ) {
  return function(d) { return "06.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1185974199 = messageFormatterFn((function(  ) {
  return function(d) { return "06.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1593544685 = messageFormatterFn((function(  ) {
  return function(d) { return "06.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1884023597 = messageFormatterFn((function(  ) {
  return function(d) { return "07.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b368575185 = messageFormatterFn((function(  ) {
  return function(d) { return "07.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1315056918 = messageFormatterFn((function(  ) {
  return function(d) { return "07.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1464461966 = messageFormatterFn((function(  ) {
  return function(d) { return "07.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1754940878 = messageFormatterFn((function(  ) {
  return function(d) { return "08.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b239492466 = messageFormatterFn((function(  ) {
  return function(d) { return "08.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1444139637 = messageFormatterFn((function(  ) {
  return function(d) { return "08.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1335379247 = messageFormatterFn((function(  ) {
  return function(d) { return "08.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1625858159 = messageFormatterFn((function(  ) {
  return function(d) { return "09.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b110409747 = messageFormatterFn((function(  ) {
  return function(d) { return "09.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1573222356 = messageFormatterFn((function(  ) {
  return function(d) { return "09.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1206296528 = messageFormatterFn((function(  ) {
  return function(d) { return "09.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1213961659 = messageFormatterFn((function(  ) {
  return function(d) { return "10.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1565557225 = messageFormatterFn((function(  ) {
  return function(d) { return "10.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a118074878 = messageFormatterFn((function(  ) {
  return function(d) { return "10.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1633523290 = messageFormatterFn((function(  ) {
  return function(d) { return "10.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1343044378 = messageFormatterFn((function(  ) {
  return function(d) { return "11.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1436474506 = messageFormatterFn((function(  ) {
  return function(d) { return "11.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a247157597 = messageFormatterFn((function(  ) {
  return function(d) { return "11.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1762606009 = messageFormatterFn((function(  ) {
  return function(d) { return "11.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a130113928 = messageFormatterFn((function(  ) {
  return function(d) { return "12.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1645562340 = messageFormatterFn((function(  ) {
  return function(d) { return "12.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b965772853 = messageFormatterFn((function(  ) {
  return function(d) { return "12.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a549675559 = messageFormatterFn((function(  ) {
  return function(d) { return "12.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a294434216 = messageFormatterFn((function(  ) {
  return function(d) { return "13.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1809882628 = messageFormatterFn((function(  ) {
  return function(d) { return "13.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b801452565 = messageFormatterFn((function(  ) {
  return function(d) { return "13.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a713995847 = messageFormatterFn((function(  ) {
  return function(d) { return "13.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a423516935 = messageFormatterFn((function(  ) {
  return function(d) { return "14.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1938965347 = messageFormatterFn((function(  ) {
  return function(d) { return "14.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b672369846 = messageFormatterFn((function(  ) {
  return function(d) { return "14.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a843078566 = messageFormatterFn((function(  ) {
  return function(d) { return "14.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a552599654 = messageFormatterFn((function(  ) {
  return function(d) { return "15.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2068048066 = messageFormatterFn((function(  ) {
  return function(d) { return "15.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b543287127 = messageFormatterFn((function(  ) {
  return function(d) { return "15.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a972161285 = messageFormatterFn((function(  ) {
  return function(d) { return "15.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a681682373 = messageFormatterFn((function(  ) {
  return function(d) { return "16.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2097836511 = messageFormatterFn((function(  ) {
  return function(d) { return "16.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b414204408 = messageFormatterFn((function(  ) {
  return function(d) { return "16.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1101244004 = messageFormatterFn((function(  ) {
  return function(d) { return "16.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a810765092 = messageFormatterFn((function(  ) {
  return function(d) { return "17.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1968753792 = messageFormatterFn((function(  ) {
  return function(d) { return "17.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b285121689 = messageFormatterFn((function(  ) {
  return function(d) { return "17.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1230326723 = messageFormatterFn((function(  ) {
  return function(d) { return "17.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a939847811 = messageFormatterFn((function(  ) {
  return function(d) { return "18.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1839671073 = messageFormatterFn((function(  ) {
  return function(d) { return "18.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b156038970 = messageFormatterFn((function(  ) {
  return function(d) { return "18.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1359409442 = messageFormatterFn((function(  ) {
  return function(d) { return "18.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1068930530 = messageFormatterFn((function(  ) {
  return function(d) { return "19.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1710588354 = messageFormatterFn((function(  ) {
  return function(d) { return "19.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b26956251 = messageFormatterFn((function(  ) {
  return function(d) { return "19.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1488492161 = messageFormatterFn((function(  ) {
  return function(d) { return "19.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1198013249 = messageFormatterFn((function(  ) {
  return function(d) { return "20.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1581505635 = messageFormatterFn((function(  ) {
  return function(d) { return "20.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a102126468 = messageFormatterFn((function(  ) {
  return function(d) { return "20.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1617574880 = messageFormatterFn((function(  ) {
  return function(d) { return "20.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1327095968 = messageFormatterFn((function(  ) {
  return function(d) { return "21.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1452422916 = messageFormatterFn((function(  ) {
  return function(d) { return "21.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a231209187 = messageFormatterFn((function(  ) {
  return function(d) { return "21.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1746657599 = messageFormatterFn((function(  ) {
  return function(d) { return "21.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b128051510 = messageFormatterFn((function(  ) {
  return function(d) { return "22.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1387396902 = messageFormatterFn((function(  ) {
  return function(d) { return "22.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1223938291 = messageFormatterFn((function(  ) {
  return function(d) { return "22.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a291510121 = messageFormatterFn((function(  ) {
  return function(d) { return "22.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1031209 = messageFormatterFn((function(  ) {
  return function(d) { return "23.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1516479621 = messageFormatterFn((function(  ) {
  return function(d) { return "23.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1094855572 = messageFormatterFn((function(  ) {
  return function(d) { return "23.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a420592840 = messageFormatterFn((function(  ) {
  return function(d) { return "23.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b891332178 = messageFormatterFn((function(  ) {
  return function(d) { return "00.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1911573494 = messageFormatterFn((function(  ) {
  return function(d) { return "00.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b663644047 = messageFormatterFn((function(  ) {
  return function(d) { return "00.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1683885363 = messageFormatterFn((function(  ) {
  return function(d) { return "00.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1734107698 = messageFormatterFn((function(  ) {
  return function(d) { return "01.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1540618282 = messageFormatterFn((function(  ) {
  return function(d) { return "01.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1506419567 = messageFormatterFn((function(  ) {
  return function(d) { return "01.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1768306413 = messageFormatterFn((function(  ) {
  return function(d) { return "01.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2050325421 = messageFormatterFn((function(  ) {
  return function(d) { return "02.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1030084105 = messageFormatterFn((function(  ) {
  return function(d) { return "02.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2016953744 = messageFormatterFn((function(  ) {
  return function(d) { return "02.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1257772236 = messageFormatterFn((function(  ) {
  return function(d) { return "02.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1539791244 = messageFormatterFn((function(  ) {
  return function(d) { return "03.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a519549928 = messageFormatterFn((function(  ) {
  return function(d) { return "03.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1767479375 = messageFormatterFn((function(  ) {
  return function(d) { return "03.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a747238059 = messageFormatterFn((function(  ) {
  return function(d) { return "03.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1029257067 = messageFormatterFn((function(  ) {
  return function(d) { return "04.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a9015751 = messageFormatterFn((function(  ) {
  return function(d) { return "04.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1256945198 = messageFormatterFn((function(  ) {
  return function(d) { return "04.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a236703882 = messageFormatterFn((function(  ) {
  return function(d) { return "04.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a518722890 = messageFormatterFn((function(  ) {
  return function(d) { return "05.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b501518426 = messageFormatterFn((function(  ) {
  return function(d) { return "05.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a746411021 = messageFormatterFn((function(  ) {
  return function(d) { return "05.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b273830295 = messageFormatterFn((function(  ) {
  return function(d) { return "05.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a8188713 = messageFormatterFn((function(  ) {
  return function(d) { return "06.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1012052603 = messageFormatterFn((function(  ) {
  return function(d) { return "06.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a235876844 = messageFormatterFn((function(  ) {
  return function(d) { return "06.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b784364472 = messageFormatterFn((function(  ) {
  return function(d) { return "06.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b502345464 = messageFormatterFn((function(  ) {
  return function(d) { return "07.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1522586780 = messageFormatterFn((function(  ) {
  return function(d) { return "07.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b274657333 = messageFormatterFn((function(  ) {
  return function(d) { return "07.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1294898649 = messageFormatterFn((function(  ) {
  return function(d) { return "07.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1012879641 = messageFormatterFn((function(  ) {
  return function(d) { return "08.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2033120957 = messageFormatterFn((function(  ) {
  return function(d) { return "08.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b785191510 = messageFormatterFn((function(  ) {
  return function(d) { return "08.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1805432826 = messageFormatterFn((function(  ) {
  return function(d) { return "08.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1523413818 = messageFormatterFn((function(  ) {
  return function(d) { return "09.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1751312162 = messageFormatterFn((function(  ) {
  return function(d) { return "09.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1295725687 = messageFormatterFn((function(  ) {
  return function(d) { return "09.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1979000293 = messageFormatterFn((function(  ) {
  return function(d) { return "09.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a129736176 = messageFormatterFn((function(  ) {
  return function(d) { return "10.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b890505140 = messageFormatterFn((function(  ) {
  return function(d) { return "10.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a357424307 = messageFormatterFn((function(  ) {
  return function(d) { return "10.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b662817009 = messageFormatterFn((function(  ) {
  return function(d) { return "10.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b380798001 = messageFormatterFn((function(  ) {
  return function(d) { return "11.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1401039317 = messageFormatterFn((function(  ) {
  return function(d) { return "11.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b153109870 = messageFormatterFn((function(  ) {
  return function(d) { return "11.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1173351186 = messageFormatterFn((function(  ) {
  return function(d) { return "11.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b997409987 = messageFormatterFn((function(  ) {
  return function(d) { return "12.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2017651303 = messageFormatterFn((function(  ) {
  return function(d) { return "12.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b769721856 = messageFormatterFn((function(  ) {
  return function(d) { return "12.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1789963172 = messageFormatterFn((function(  ) {
  return function(d) { return "12.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1840185507 = messageFormatterFn((function(  ) {
  return function(d) { return "13.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1434540473 = messageFormatterFn((function(  ) {
  return function(d) { return "13.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1612497376 = messageFormatterFn((function(  ) {
  return function(d) { return "13.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1662228604 = messageFormatterFn((function(  ) {
  return function(d) { return "13.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1944247612 = messageFormatterFn((function(  ) {
  return function(d) { return "14.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a924006296 = messageFormatterFn((function(  ) {
  return function(d) { return "14.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2123031553 = messageFormatterFn((function(  ) {
  return function(d) { return "14.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1151694427 = messageFormatterFn((function(  ) {
  return function(d) { return "14.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1433713435 = messageFormatterFn((function(  ) {
  return function(d) { return "15.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a413472119 = messageFormatterFn((function(  ) {
  return function(d) { return "15.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1661401566 = messageFormatterFn((function(  ) {
  return function(d) { return "15.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a641160250 = messageFormatterFn((function(  ) {
  return function(d) { return "15.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a923179258 = messageFormatterFn((function(  ) {
  return function(d) { return "16.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b97062058 = messageFormatterFn((function(  ) {
  return function(d) { return "16.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1150867389 = messageFormatterFn((function(  ) {
  return function(d) { return "16.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a130626073 = messageFormatterFn((function(  ) {
  return function(d) { return "16.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a412645081 = messageFormatterFn((function(  ) {
  return function(d) { return "17.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b607596235 = messageFormatterFn((function(  ) {
  return function(d) { return "17.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a640333212 = messageFormatterFn((function(  ) {
  return function(d) { return "17.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b379908104 = messageFormatterFn((function(  ) {
  return function(d) { return "17.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b97889096 = messageFormatterFn((function(  ) {
  return function(d) { return "18.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1118130412 = messageFormatterFn((function(  ) {
  return function(d) { return "18.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a129799035 = messageFormatterFn((function(  ) {
  return function(d) { return "18.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b890442281 = messageFormatterFn((function(  ) {
  return function(d) { return "18.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b608423273 = messageFormatterFn((function(  ) {
  return function(d) { return "19.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1628664589 = messageFormatterFn((function(  ) {
  return function(d) { return "19.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b380735142 = messageFormatterFn((function(  ) {
  return function(d) { return "19.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1400976458 = messageFormatterFn((function(  ) {
  return function(d) { return "19.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1118957450 = messageFormatterFn((function(  ) {
  return function(d) { return "20.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2139198766 = messageFormatterFn((function(  ) {
  return function(d) { return "20.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b891269319 = messageFormatterFn((function(  ) {
  return function(d) { return "20.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1911510635 = messageFormatterFn((function(  ) {
  return function(d) { return "20.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1629491627 = messageFormatterFn((function(  ) {
  return function(d) { return "21.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1645234353 = messageFormatterFn((function(  ) {
  return function(d) { return "21.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1401803496 = messageFormatterFn((function(  ) {
  return function(d) { return "21.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1872922484 = messageFormatterFn((function(  ) {
  return function(d) { return "21.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a23658367 = messageFormatterFn((function(  ) {
  return function(d) { return "22.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b996582949 = messageFormatterFn((function(  ) {
  return function(d) { return "22.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a251346498 = messageFormatterFn((function(  ) {
  return function(d) { return "22.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b768894818 = messageFormatterFn((function(  ) {
  return function(d) { return "22.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b486875810 = messageFormatterFn((function(  ) {
  return function(d) { return "23.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1507117126 = messageFormatterFn((function(  ) {
  return function(d) { return "23.15"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b259187679 = messageFormatterFn((function(  ) {
  return function(d) { return "23.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1279428995 = messageFormatterFn((function(  ) {
  return function(d) { return "23.45"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1494374590 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj en senare upphämtningstid"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1798554996 = messageFormatterFn((function(  ) {
  return function(d) { return "Tiden du valt har redan varit. Ändra ditt val"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b15957429 = messageFormatterFn((function(  ) {
  return function(d) { return "Avreseflyget måste avgå minst två timmar efter det ankommande flyget."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1241705447 = messageFormatterFn((function(  ) {
  return function(d) { return "Till"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a332847577 = messageFormatterFn((function(  ) {
  return function(d) { return "Avgång tidigast"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1370872530 = messageFormatterFn((function(  ) {
  return function(d) { return "Avgång senast"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1702485253 = messageFormatterFn((function(  ) {
  return function(d) { return "Resenärer i hytt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1211324318 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj destination"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1419926271 = messageFormatterFn((function(  ) {
  return function(d) { return "Populärast"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a60581832 = messageFormatterFn((function(  ) {
  return function(d) { return "Västindien"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1234964498 = messageFormatterFn((function(  ) {
  return function(d) { return "Bahamas"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1149728076 = messageFormatterFn((function(  ) {
  return function(d) { return "Mexiko"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b633485750 = messageFormatterFn((function(  ) {
  return function(d) { return "Alaska"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a168446265 = messageFormatterFn((function(  ) {
  return function(d) { return "Europa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1783147681 = messageFormatterFn((function(  ) {
  return function(d) { return "Bermuda"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1301463942 = messageFormatterFn((function(  ) {
  return function(d) { return "Hawaii"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a859978382 = messageFormatterFn((function(  ) {
  return function(d) { return "Kanada/New England"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b727538182 = messageFormatterFn((function(  ) {
  return function(d) { return "Andra destinationer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1565443378 = messageFormatterFn((function(  ) {
  return function(d) { return "Arktis/Antarktis"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1622317111 = messageFormatterFn((function(  ) {
  return function(d) { return "Mellanöstern"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1388123665 = messageFormatterFn((function(  ) {
  return function(d) { return "Afrika"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a4021518 = messageFormatterFn((function(  ) {
  return function(d) { return "Panamakanalen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2055704033 = messageFormatterFn((function(  ) {
  return function(d) { return "Asien"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a629484047 = messageFormatterFn((function(  ) {
  return function(d) { return "Stillahavskusten"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1719449716 = messageFormatterFn((function(  ) {
  return function(d) { return "Australien/Nya Zeeland"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1271128432 = messageFormatterFn((function(  ) {
  return function(d) { return "Centralamerika"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1966240970 = messageFormatterFn((function(  ) {
  return function(d) { return "Galapagos"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a185216367 = messageFormatterFn((function(  ) {
  return function(d) { return "Havsutflykt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a749384603 = messageFormatterFn((function(  ) {
  return function(d) { return "Över Atlanten"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1409427005 = messageFormatterFn((function(  ) {
  return function(d) { return "Hela världen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1406801816 = messageFormatterFn((function(  ) {
  return function(d) { return "Sydamerika"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a43937043 = messageFormatterFn((function(  ) {
  return function(d) { return "Södra Stillahavsområdet"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a9460472 = messageFormatterFn((function(  ) {
  return function(d) { return "Över Stilla havet"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1294113949 = messageFormatterFn((function(  ) {
  return function(d) { return "Avgångshamn"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b86292819 = messageFormatterFn((function(  ) {
  return function(d) { return "Avresedatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1421751699 = messageFormatterFn((function(  ) {
  return function(d) { return "Resans längd"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1643617353 = messageFormatterFn((function(  ) {
  return function(d) { return "Kryssningslinje"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1867526119 = messageFormatterFn((function(  ) {
  return function(d) { return "Okej"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1996262698 = messageFormatterFn((function(  ) {
  return function(d) { return "Foto av " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2038870498 = messageFormatterFn((function(  ) {
  return function(d) { return "Öppna " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b611063258 = messageFormatterFn((function(  ) {
  return function(d) { return "<a href=\"" + d["0"] + "\">Foto</a><span> av </span><a href=\"" + d["1"] + "\">" + d["2"] + "</a><span> (</span><a href=\"" + d["3"] + "\">" + d["4"] + "</a><span>)</span>"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1166252923 = messageFormatterFn((function(  ) {
  return function(d) { return "<a href=\"" + d["0"] + "\">Foto</a> av " + d["1"] + " (<a href=\"" + d["2"] + "\">" + d["3"] + "</a>)"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b29777517 = messageFormatterFn((function(  ) {
  return function(d) { return "\"" + d["0"] + "\"-foto av " + d["1"] + " (" + d["2"] + ") / Urklipp från original"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1418922003 = messageFormatterFn((function(  ) {
  return function(d) { return "Uppskattat pris för 1 natt och 2 vuxna"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b118770101 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1737901186 = messageFormatterFn((function(  ) {
  return function(d) { return "Bild av " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1388966760 = messageFormatterFn((function(  ) {
  return function(d) { return "Boka nu, betala vid vistelsen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1269080857 = messageFormatterFn((function(  ) {
  return function(d) { return "Gratis avbokning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b406074616 = messageFormatterFn((function(  ) {
  return function(d) { return "Full återbetalning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a30434830 = messageFormatterFn((function(  ) {
  return function(d) { return "Boka nu, betala vid vistelsen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2086292887 = messageFormatterFn((function(  ) {
  return function(d) { return "Gratis avbokning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a254521527 = messageFormatterFn((function(  ) {
  return function(d) { return "Se alla boenden i " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a315164102 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return "Se " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return d["1"] + " boenden";}, one: function() { return d["1"] + " boende";}, two: function() { return d["1"] + " boenden";}, few: function() { return "alla " + d["1"] + " boenden";}, many: function() { return "alla " + d["1"] + " boenden";}, other: function() { return "alla " + d["1"] + " boenden";} }) + " i " + d["2"]; }
})(messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1334732102 = messageFormatterFn((function(  ) {
  return function(d) { return "Se alla tillgängliga boenden i " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1084691472 = messageFormatterFn((function(  ) {
  return function(d) { return "Hittar du inte det du letar efter?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1912391461 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa alla boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b69679001 = messageFormatterFn((function(  ) {
  return function(d) { return "Se fler boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1690758380 = messageFormatterFn((function(  ) {
  return function(d) { return "Se fler"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1070558111 = messageFormatterFn((function(  ) {
  return function(d) { return "Se fler " + d["0"] + " i " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a58306008 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har fler " + d["0"] + ". Hitta rätt för för dig."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a440242229 = messageFormatterFn((function(  ) {
  return function(d) { return "Se fler boenden med all inclusive"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1574837231 = messageFormatterFn((function(  ) {
  return function(d) { return "Se fler strandboenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1943069230 = messageFormatterFn((function(  ) {
  return function(d) { return "Se fler boutiqueboenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2021431729 = messageFormatterFn((function(  ) {
  return function(d) { return "Se fler budgetboenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b378681206 = messageFormatterFn((function(  ) {
  return function(d) { return "Se fler företagsboenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1274043135 = messageFormatterFn((function(  ) {
  return function(d) { return "Se fler boenden med kasino"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1220633881 = messageFormatterFn((function(  ) {
  return function(d) { return "Se fler familjevänliga boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b649669943 = messageFormatterFn((function(  ) {
  return function(d) { return "Se fler boenden med fitnesscenter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b331873876 = messageFormatterFn((function(  ) {
  return function(d) { return "Se fler golfboenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2072574352 = messageFormatterFn((function(  ) {
  return function(d) { return "Se fler boenden med kök"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1918271312 = messageFormatterFn((function(  ) {
  return function(d) { return "Se fler boenden med pentry"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1969934825 = messageFormatterFn((function(  ) {
  return function(d) { return "Se fler lyxboenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1659531601 = messageFormatterFn((function(  ) {
  return function(d) { return "Se fler boenden med utsikt mot havet"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1932375062 = messageFormatterFn((function(  ) {
  return function(d) { return "Se fler boenden där husdjur tillåts"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1345347994 = messageFormatterFn((function(  ) {
  return function(d) { return "Se fler boenden med pool"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a79107771 = messageFormatterFn((function(  ) {
  return function(d) { return "Se fler romantiska boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2099190051 = messageFormatterFn((function(  ) {
  return function(d) { return "Se fler skidboenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1002511600 = messageFormatterFn((function(  ) {
  return function(d) { return "Se fler boenden med spa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2063255923 = messageFormatterFn((function(  ) {
  return function(d) { return "Se fler boenden med vattenpark"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a111215648 = messageFormatterFn((function(  ) {
  return function(d) { return "Se fler boenden med bröllopslokaler"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1359850267 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vi har " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " ytterligare";}, one: function() { return number(d["0"]) + " ytterligare";}, two: function() { return number(d["0"]) + " ytterligare";}, few: function() { return number(d["0"]) + " ytterligare";}, many: function() { return number(d["0"]) + " ytterligare";}, other: function() { return number(d["0"]) + " ytterligare";} }) + " all-inclusive-hotell att välja bland"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b5599019 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vi har " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " ytterligare";}, one: function() { return number(d["0"]) + " ytterligare";}, two: function() { return number(d["0"]) + " ytterligare";}, few: function() { return number(d["0"]) + " ytterligare";}, many: function() { return number(d["0"]) + " ytterligare";}, other: function() { return number(d["0"]) + " ytterligare";} }) + " strandhotell att välja bland"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1307900396 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vi har " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " ytterligare";}, one: function() { return number(d["0"]) + " ytterligare";}, two: function() { return number(d["0"]) + " ytterligare";}, few: function() { return number(d["0"]) + " ytterligare";}, many: function() { return number(d["0"]) + " ytterligare";}, other: function() { return number(d["0"]) + " ytterligare";} }) + " boutiquehotell att välja bland"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a854604597 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vi har " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " ytterligare";}, one: function() { return number(d["0"]) + " ytterligare";}, two: function() { return number(d["0"]) + " ytterligare";}, few: function() { return number(d["0"]) + " ytterligare";}, many: function() { return number(d["0"]) + " ytterligare";}, other: function() { return number(d["0"]) + " ytterligare";} }) + " budgethotell att välja bland"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1831995504 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vi har " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " ytterligare";}, one: function() { return number(d["0"]) + " ytterligare";}, two: function() { return number(d["0"]) + " ytterligare";}, few: function() { return number(d["0"]) + " ytterligare";}, many: function() { return number(d["0"]) + " ytterligare";}, other: function() { return number(d["0"]) + " ytterligare";} }) + " affärshotell att välja bland"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1254826011 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vi har " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " ytterligare";}, one: function() { return number(d["0"]) + " ytterligare";}, two: function() { return number(d["0"]) + " ytterligare";}, few: function() { return number(d["0"]) + " ytterligare";}, many: function() { return number(d["0"]) + " ytterligare";}, other: function() { return number(d["0"]) + " ytterligare";} }) + " kasinohotell att välja bland"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1357470721 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vi har " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " ytterligare familjevänliga hotell";}, one: function() { return number(d["0"]) + " ytterligare familjevänligt hotell";}, two: function() { return number(d["0"]) + " ytterligare familjevänliga hotell";}, few: function() { return number(d["0"]) + " ytterligare familjevänliga hotell";}, many: function() { return number(d["0"]) + " ytterligare familjevänliga hotell";}, other: function() { return number(d["0"]) + " ytterligare familjevänliga hotell";} }) + " att välja bland"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b704855633 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vi har " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " ytterligare";}, one: function() { return number(d["0"]) + " ytterligare";}, two: function() { return number(d["0"]) + " ytterligare";}, few: function() { return number(d["0"]) + " ytterligare";}, many: function() { return number(d["0"]) + " ytterligare";}, other: function() { return number(d["0"]) + " ytterligare";} }) + " hotell med fitnesscenter att välja bland"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a462455698 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vi har " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " ytterligare";}, one: function() { return number(d["0"]) + " ytterligare";}, two: function() { return number(d["0"]) + " ytterligare";}, few: function() { return number(d["0"]) + " ytterligare";}, many: function() { return number(d["0"]) + " ytterligare";}, other: function() { return number(d["0"]) + " ytterligare";} }) + " golfhotell att välja bland"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1913484202 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vi har " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " ytterligare";}, one: function() { return number(d["0"]) + " ytterligare";}, two: function() { return number(d["0"]) + " ytterligare";}, few: function() { return number(d["0"]) + " ytterligare";}, many: function() { return number(d["0"]) + " ytterligare";}, other: function() { return number(d["0"]) + " ytterligare";} }) + " hotell med kök att välja bland"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1875436854 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vi har " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " ytterligare";}, one: function() { return number(d["0"]) + " ytterligare";}, two: function() { return number(d["0"]) + " ytterligare";}, few: function() { return number(d["0"]) + " ytterligare";}, many: function() { return number(d["0"]) + " ytterligare";}, other: function() { return number(d["0"]) + " ytterligare";} }) + " hotell med pentry att välja bland"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a403327741 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vi har " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " ytterligare";}, one: function() { return number(d["0"]) + " ytterligare";}, two: function() { return number(d["0"]) + " ytterligare";}, few: function() { return number(d["0"]) + " ytterligare";}, many: function() { return number(d["0"]) + " ytterligare";}, other: function() { return number(d["0"]) + " ytterligare";} }) + " lyxhotell att välja bland"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1138803605 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vi har " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " ytterligare";}, one: function() { return number(d["0"]) + " ytterligare";}, two: function() { return number(d["0"]) + " ytterligare";}, few: function() { return number(d["0"]) + " ytterligare";}, many: function() { return number(d["0"]) + " ytterligare";}, other: function() { return number(d["0"]) + " ytterligare";} }) + " hotell med havsutsikt att välja bland"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1202470908 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vi har " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " ytterligare";}, one: function() { return number(d["0"]) + " ytterligare";}, two: function() { return number(d["0"]) + " ytterligare";}, few: function() { return number(d["0"]) + " ytterligare";}, many: function() { return number(d["0"]) + " ytterligare";}, other: function() { return number(d["0"]) + " ytterligare";} }) + " hotell där husdjur är tillåtna att välja bland"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b691701172 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vi har " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " ytterligare";}, one: function() { return number(d["0"]) + " ytterligare";}, two: function() { return number(d["0"]) + " ytterligare";}, few: function() { return number(d["0"]) + " ytterligare";}, many: function() { return number(d["0"]) + " ytterligare";}, other: function() { return number(d["0"]) + " ytterligare";} }) + " hotell med pool att välja bland"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1138825121 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vi har " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " ytterligare romantiska";}, one: function() { return number(d["0"]) + " ytterligare romantiskt";}, two: function() { return number(d["0"]) + " ytterligare romantiska";}, few: function() { return number(d["0"]) + " ytterligare romantiska";}, many: function() { return number(d["0"]) + " ytterligare romantiska";}, other: function() { return number(d["0"]) + " ytterligare romantiska";} }) + " hotell att välja bland"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1445341635 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vi har " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " ytterligare";}, one: function() { return number(d["0"]) + " ytterligare";}, two: function() { return number(d["0"]) + " ytterligare";}, few: function() { return number(d["0"]) + " ytterligare";}, many: function() { return number(d["0"]) + " ytterligare";}, other: function() { return number(d["0"]) + " ytterligare";} }) + " skidhotell att välja bland"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1845812522 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vi har " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " ytterligare";}, one: function() { return number(d["0"]) + " ytterligare";}, two: function() { return number(d["0"]) + " ytterligare";}, few: function() { return number(d["0"]) + " ytterligare";}, many: function() { return number(d["0"]) + " ytterligare";}, other: function() { return number(d["0"]) + " ytterligare";} }) + " spahotell att välja bland"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a615328115 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vi har " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " ytterligare";}, one: function() { return number(d["0"]) + " ytterligare";}, two: function() { return number(d["0"]) + " ytterligare";}, few: function() { return number(d["0"]) + " ytterligare";}, many: function() { return number(d["0"]) + " ytterligare";}, other: function() { return number(d["0"]) + " ytterligare";} }) + " hotell med vattenpark att välja bland"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1676854778 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vi har " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " ytterligare";}, one: function() { return number(d["0"]) + " ytterligare";}, two: function() { return number(d["0"]) + " ytterligare";}, few: function() { return number(d["0"]) + " ytterligare";}, many: function() { return number(d["0"]) + " ytterligare";}, other: function() { return number(d["0"]) + " ytterligare";} }) + " hotell med bröllopslokal att välja bland"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1202006139 = messageFormatterFn((function(  ) {
  return function(d) { return "Öppna hotellsidan för " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b784740979 = messageFormatterFn((function(  ) {
  return function(d) { return "För 2 gäster"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1731948278 = messageFormatterFn((function(  ) {
  return function(d) { return "per natt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1549590823 = messageFormatterFn((function(  ) {
  return function(d) { return "Priset är " + d["0"] + " per natt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a723167356 = messageFormatterFn((function(  ) {
  return function(d) { return "Priset är " + d["0"] + " per natt mellan " + d["1"] + " och " + d["2"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1734743700 = messageFormatterFn((function(  ) {
  return function(d) { return "Hämta priser"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b491082472 = messageFormatterFn((function(  ) {
  return function(d) { return "Recension från " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1499539786 = messageFormatterFn((function(  ) {
  return function(d) { return "Bra!"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1499540747 = messageFormatterFn((function(  ) {
  return function(d) { return "Mycket bra!"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1499541708 = messageFormatterFn((function(  ) {
  return function(d) { return "Utmärkt!"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1499542669 = messageFormatterFn((function(  ) {
  return function(d) { return "Underbart!"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1499543630 = messageFormatterFn((function(  ) {
  return function(d) { return "Enastående!"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1469214819 = messageFormatterFn((function(  ) {
  return function(d) { return "Bra"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1469215780 = messageFormatterFn((function(  ) {
  return function(d) { return "Väldigt bra"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1469216741 = messageFormatterFn((function(  ) {
  return function(d) { return "Fantastiskt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1469217702 = messageFormatterFn((function(  ) {
  return function(d) { return "Utmärkt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1469218663 = messageFormatterFn((function(  ) {
  return function(d) { return "Enastående"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2098917301 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { 0: function() { return "Inga recensioner";}, zero: function() { return d["1"] + " recensioner";}, one: function() { return d["1"] + " recension";}, two: function() { return d["1"] + " recensioner";}, few: function() { return d["1"] + " recensioner";}, many: function() { return d["1"] + " recensioner";}, other: function() { return d["1"] + " recensioner";} }); }
})(messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1191926587 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " har lagts till i dina listor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1805187202 = messageFormatterFn((function(  ) {
  return function(d) { return "Spara " + d["0"] + " i dina listor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b427924603 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " har tagits bort från dina listor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a627696760 = messageFormatterFn((function(  ) {
  return function(d) { return "Ta bort " + d["0"] + " från dina listor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2051401139 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Rekommenderas av " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " gäster";}, one: function() { return number(d["0"]) + " gäst";}, two: function() { return number(d["0"]) + " gäster";}, few: function() { return number(d["0"]) + " gäster";}, many: function() { return number(d["0"]) + " gäster";}, other: function() { return number(d["0"]) + " gäster";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1763130954 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return d["1"] + " miles";}, one: function() { return d["1"] + " mile";}, two: function() { return d["1"] + " miles";}, few: function() { return d["1"] + " miles";}, many: function() { return d["1"] + " miles";}, other: function() { return d["1"] + " miles";} }) + " från " + d["2"]; }
})(messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1497473737 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return d["1"] + " km";}, one: function() { return d["1"] + " km";}, two: function() { return d["1"] + " km";}, few: function() { return d["1"] + " km";}, many: function() { return d["1"] + " km";}, other: function() { return d["1"] + " km";} }) + " från " + d["2"]; }
})(messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1111535511 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " min";}, one: function() { return number(d["0"]) + " min";}, two: function() { return number(d["0"]) + " min";}, few: function() { return number(d["0"]) + " min";}, many: function() { return number(d["0"]) + " min";}, other: function() { return number(d["0"]) + " min";} }) + " promenad från " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a635994654 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " min";}, one: function() { return number(d["0"]) + " min";}, two: function() { return number(d["0"]) + " min";}, few: function() { return number(d["0"]) + " min";}, many: function() { return number(d["0"]) + " min";}, other: function() { return number(d["0"]) + " min";} }) + " med bil från " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1438600882 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " timmar";}, one: function() { return number(d["0"]) + " timme";}, two: function() { return number(d["0"]) + " timmar";}, few: function() { return number(d["0"]) + " timmar";}, many: function() { return number(d["0"]) + " timmar";}, other: function() { return number(d["0"]) + " timmar";} }) + " med bil från " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1545713639 = messageFormatterFn((function(  ) {
  return function(d) { return "Det finns inga resultat med dina filterinställningar."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b338705011 = messageFormatterFn((function(  ) {
  return function(d) { return "Justera dina filter eller se alternativen nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1417510875 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj datum för att se priser"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1899573869 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return d["1"] + " km";}, one: function() { return d["1"] + " km";}, two: function() { return d["1"] + " km";}, few: function() { return d["1"] + " km";}, many: function() { return d["1"] + " km";}, other: function() { return d["1"] + " km";} }) + " från centrum"; }
})(messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1899629607 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return d["1"] + " mi";}, one: function() { return d["1"] + " mi";}, two: function() { return d["1"] + " mi";}, few: function() { return d["1"] + " mi";}, many: function() { return d["1"] + " mi";}, other: function() { return d["1"] + " mi";} }) + " från centrum"; }
})(messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2062175273 = messageFormatterFn((function(  ) {
  return function(d) { return "Flygpaket kan bara bokas för vistelser på ett hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1047714280 = messageFormatterFn((function(  ) {
  return function(d) { return "Okej"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1324712567 = messageFormatterFn((function(  ) {
  return function(d) { return "Jag behöver flera boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a164125148 = messageFormatterFn((function(  ) {
  return function(d) { return "Fristående priser"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1656762244 = messageFormatterFn((function(  ) {
  return function(d) { return "Paketpriser"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1638377220 = messageFormatterFn((function(  ) {
  return function(d) { return "Ny bokningsupplevelse"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1146295427 = messageFormatterFn((function(  ) {
  return function(d) { return "Se en lista över alla hotell i " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1205118149 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa en lista över alla hotell nära " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b269120917 = messageFormatterFn((function(  ) {
  return function(d) { return "Föregående månad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a651990247 = messageFormatterFn((function(  ) {
  return function(d) { return "Nästa månad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a424995832 = messageFormatterFn((function(  ) {
  return function(d) { return "Se på karta"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a943478562 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa karta"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1329880325 = messageFormatterFn((function(  ) {
  return function(d) { return "Karta för " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1192821161 = messageFormatterFn((function(  ) {
  return function(d) { return "Karta över hotell i " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1717778875 = messageFormatterFn((function(  ) {
  return function(d) { return "Stäng karta"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a155309880 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { 0: function() { return "Inga recensioner";}, zero: function() { return d["1"] + " recensioner";}, one: function() { return d["1"] + " recension";}, two: function() { return d["1"] + " recensioner";}, few: function() { return d["1"] + " recensioner";}, many: function() { return d["1"] + " recensioner";}, other: function() { return d["1"] + " recensioner";} }); }
})(messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a171439588 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " / 5"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a464005382 = messageFormatterFn((function(  ) {
  return function(d) { return "Se boenden i närheten"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a321325322 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök i det här området"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1570975349 = messageFormatterFn((function(  ) {
  return function(d) { return "Det finns inga resultat med dina filterinställningar."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1612709215 = messageFormatterFn((function(  ) {
  return function(d) { return "Försök ändra dina filter."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a675662624 = messageFormatterFn((function(  ) {
  return function(d) { return "Det finns inga tillgängliga boenden i området."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1755957654 = messageFormatterFn((function(  ) {
  return function(d) { return "Flytta på kartan för att utöka sökningen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1196781002 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + "<br />från " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1720065812 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + "\nfrån " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1403855257 = messageFormatterFn((function(  ) {
  return function(d) { return "Markören för " + d["0"] + " är inte vald"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1779492658 = messageFormatterFn((function(  ) {
  return function(d) { return "Markören för " + d["0"] + " är vald"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1514635656 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", " + d["1"] + " och " + d["2"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1514636617 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " och " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1514637578 = messageFormatterFn((function(  ) {
  return function(d) { return "- " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b639759028 = messageFormatterFn((function(  ) {
  return function(d) { return "Saker att besöka"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b166551959 = messageFormatterFn((function(  ) {
  return function(d) { return "Upptäck staden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a577296899 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a757764003 = messageFormatterFn((function(  ) {
  return function(d) { return "Populära städer i " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1093125720 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med luftkonditionering"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a961499754 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " all-inclusive-hotell";}, one: function() { return number(d["0"]) + " all-inclusive-hotell";}, two: function() { return number(d["0"]) + " all-inclusive-hotell";}, few: function() { return number(d["0"]) + " all-inclusive-hotell";}, many: function() { return number(d["0"]) + " all-inclusive-hotell";}, other: function() { return number(d["0"]) + " all-inclusive-hotell";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1032171909 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med balkonger"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b692255142 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " strandhotell";}, one: function() { return number(d["0"]) + " strandhotell";}, two: function() { return number(d["0"]) + " strandhotell";}, few: function() { return number(d["0"]) + " strandhotell";}, many: function() { return number(d["0"]) + " strandhotell";}, other: function() { return number(d["0"]) + " strandhotell";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b928093149 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " boutiquehotell";}, one: function() { return number(d["0"]) + " boutiquehotell";}, two: function() { return number(d["0"]) + " boutiquehotell";}, few: function() { return number(d["0"]) + " boutiquehotell";}, many: function() { return number(d["0"]) + " boutiquehotell";}, other: function() { return number(d["0"]) + " boutiquehotell";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2047671598 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med frukost"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1419653316 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " budgethotell";}, one: function() { return number(d["0"]) + " budgethotell";}, two: function() { return number(d["0"]) + " budgethotell";}, few: function() { return number(d["0"]) + " budgethotell";}, many: function() { return number(d["0"]) + " budgethotell";}, other: function() { return number(d["0"]) + " budgethotell";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a880840063 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " affärshotell";}, one: function() { return number(d["0"]) + " affärshotell";}, two: function() { return number(d["0"]) + " affärshotell";}, few: function() { return number(d["0"]) + " affärshotell";}, many: function() { return number(d["0"]) + " affärshotell";}, other: function() { return number(d["0"]) + " affärshotell";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1271160460 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " kasinohotell";}, one: function() { return number(d["0"]) + " kasinohotell";}, two: function() { return number(d["0"]) + " kasinohotell";}, few: function() { return number(d["0"]) + " kasinohotell";}, many: function() { return number(d["0"]) + " kasinohotell";}, other: function() { return number(d["0"]) + " kasinohotell";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b531816796 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med barnpassning"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b644991318 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med concierge"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b157624841 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med anslutande rum"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b439053554 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " familjevänliga hotell";}, one: function() { return number(d["0"]) + " familjevänligt hotell";}, two: function() { return number(d["0"]) + " familjevänliga hotell";}, few: function() { return number(d["0"]) + " familjevänliga hotell";}, many: function() { return number(d["0"]) + " familjevänliga hotell";}, other: function() { return number(d["0"]) + " familjevänliga hotell";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1824014668 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med fitnesscenter"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b918618878 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med gratis flygplatstransport"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b714542362 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med gratis frukost"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1282761341 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med gratis parkering"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1238757281 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " golfhotell";}, one: function() { return number(d["0"]) + " golfhotell";}, two: function() { return number(d["0"]) + " golfhotell";}, few: function() { return number(d["0"]) + " golfhotell";}, many: function() { return number(d["0"]) + " golfhotell";}, other: function() { return number(d["0"]) + " golfhotell";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1567909805 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med bubbelpool"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1977174510 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med inomhuspool"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b558460581 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med kök"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a131560635 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med pentry"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b573369707 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med tvättmöjligheter"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2101771471 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med lazy river"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2041175412 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " lyxhotell";}, one: function() { return number(d["0"]) + " lyxhotell";}, two: function() { return number(d["0"]) + " lyxhotell";}, few: function() { return number(d["0"]) + " lyxhotell";}, many: function() { return number(d["0"]) + " lyxhotell";}, other: function() { return number(d["0"]) + " lyxhotell";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a813361652 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " rökfria hotell";}, one: function() { return number(d["0"]) + " rökfritt hotell";}, two: function() { return number(d["0"]) + " rökfria hotell";}, few: function() { return number(d["0"]) + " rökfria hotell";}, many: function() { return number(d["0"]) + " rökfria hotell";}, other: function() { return number(d["0"]) + " rökfria hotell";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2142051226 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med havsutsikt"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a356590799 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med utomhuspool"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a686798959 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med parkering"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a185341185 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " där husdjur är tillåtna"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1496514779 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med pool"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1136450088 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " vid floden"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b372066576 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " romantiska hotell";}, one: function() { return number(d["0"]) + " romantiskt hotell";}, two: function() { return number(d["0"]) + " romantiska hotell";}, few: function() { return number(d["0"]) + " romantiska hotell";}, many: function() { return number(d["0"]) + " romantiska hotell";}, other: function() { return number(d["0"]) + " romantiska hotell";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1394161743 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med rumsservice"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1334555256 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " skidhotell";}, one: function() { return number(d["0"]) + " skidhotell";}, two: function() { return number(d["0"]) + " skidhotell";}, few: function() { return number(d["0"]) + " skidhotell";}, many: function() { return number(d["0"]) + " skidhotell";}, other: function() { return number(d["0"]) + " skidhotell";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1334413989 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " spahotell";}, one: function() { return number(d["0"]) + " spahotell";}, two: function() { return number(d["0"]) + " spahotell";}, few: function() { return number(d["0"]) + " spahotell";}, many: function() { return number(d["0"]) + " spahotell";}, other: function() { return number(d["0"]) + " spahotell";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1137808506 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med sviter"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1454890232 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell med vattenpark";}, one: function() { return number(d["0"]) + " hotell med vattenpark";}, two: function() { return number(d["0"]) + " hotell med vattenpark";}, few: function() { return number(d["0"]) + " hotell med vattenpark";}, many: function() { return number(d["0"]) + " hotell med vattenpark";}, other: function() { return number(d["0"]) + " hotell med vattenpark";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a825931065 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med vattenrutschkana"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b439727349 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med bröllopslokal"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1728090342 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med 1 stjärna"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b840586661 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med 2 stjärnor"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a46917020 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med 3 stjärnor"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a934420701 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med 4 stjärnor"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1821924382 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }) + " med 5 stjärnor"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a402065462 = messageFormatterFn((function(  ) {
  return function(d) { return "från <strong>" + d["0"] + "</strong>"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a422563525 = messageFormatterFn((function(  ) {
  return function(d) { return "från <span class=\"uitk-type-600 uitk-type-bold\">" + d["0"] + "</span>"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1426068744 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2065021648 = messageFormatterFn((function(  ) {
  return function(d) { return "per natt/rum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2001600598 = messageFormatterFn((function(  ) {
  return function(d) { return "hittades nyss"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a669365116 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "hittades för " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " timmar";}, one: function() { return number(d["0"]) + " timme";}, two: function() { return number(d["0"]) + " timmar";}, few: function() { return number(d["0"]) + " timmar";}, many: function() { return number(d["0"]) + " timmar";}, other: function() { return number(d["0"]) + " timmar";} }) + " sen"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a240404038 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "hittades för " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " dagar";}, one: function() { return number(d["0"]) + " dag";}, two: function() { return number(d["0"]) + " dagar";}, few: function() { return number(d["0"]) + " dagar";}, many: function() { return number(d["0"]) + " dagar";}, other: function() { return number(d["0"]) + " dagar";} }) + " sen"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1498648019 = messageFormatterFn((function(  ) {
  return function(d) { return "tur-och-retur"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a417425081 = messageFormatterFn((function(  ) {
  return function(d) { return "per dag"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1399490737 = messageFormatterFn((function(  ) {
  return function(d) { return "flyg + hotell per person"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b694132438 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1519240334 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a500136714 = messageFormatterFn((function(  ) {
  return function(d) { return "Hyrbilar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1012956929 = messageFormatterFn((function(  ) {
  return function(d) { return "Semesterpaket"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1116583165 = messageFormatterFn((function(  ) {
  return function(d) { return "Semesterboenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1285616719 = messageFormatterFn((function(  ) {
  return function(d) { return "Se boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2068933102 = messageFormatterFn((function(  ) {
  return function(d) { return "Se mer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1296544718 = messageFormatterFn((function(  ) {
  return function(d) { return "Se mindre"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a636660054 = messageFormatterFn((function(  ) {
  return function(d) { return "Populära sevärdheter i " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a400286273 = messageFormatterFn((function(  ) {
  return function(d) { return "Populära sevärdheter i " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a349732997 = messageFormatterFn((function(  ) {
  return function(d) { return "Toppaktiviteter i " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1129922497 = messageFormatterFn((function(  ) {
  return function(d) { return "Se alla aktiviteter i " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1456208045 = messageFormatterFn((function(  ) {
  return function(d) { return "Populära sevärdheter i " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1254677186 = messageFormatterFn((function(  ) {
  return function(d) { return "Populära sevärdheter i " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1199580151 = messageFormatterFn((function(  ) {
  return function(d) { return "Se boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1090623775 = messageFormatterFn((function(  ) {
  return function(d) { return "Var ska man bo i " + d["0"] + "?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1542408869 = messageFormatterFn((function(  ) {
  return function(d) { return "Andra områden i " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a476311487 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök på hotell i " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1030048885 = messageFormatterFn((function(  ) {
  return function(d) { return "Se boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1076125069 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta resor för " + d["0"] + " med hotell + flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b803115784 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta hotell i " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1367399059 = messageFormatterFn((function(  ) {
  return function(d) { return "Populärt för " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a9042941 = messageFormatterFn((function(  ) {
  return function(d) { return "Läs vår guide om var man ska bo"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1980018400 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return d["1"] + " områdesrecensioner";}, one: function() { return d["1"] + " områdesrecension";}, two: function() { return d["1"] + " områdesrecensioner";}, few: function() { return d["1"] + " områdesrecensioner";}, many: function() { return d["1"] + " områdesrecensioner";}, other: function() { return d["1"] + " områdesrecensioner";} }); }
})(messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b975355830 = messageFormatterFn((function(  ) {
  return function(d) { return "Bilder av " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b878901483 = messageFormatterFn((function(  ) {
  return function(d) { return "Bilder av " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a381574568 = messageFormatterFn((function(  ) {
  return function(d) { return "Stäng galleriet med miniatyrbilder"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1264137725 = messageFormatterFn((function(  ) {
  return function(d) { return "Se hotell i närheten"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a181524684 = messageFormatterFn((function(  ) {
  return function(d) { return "Boka biljett"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2141466477 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta ett rum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1990441387 = messageFormatterFn((function(  ) {
  return function(d) { return "Stäng kartan"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1389968371 = messageFormatterFn((function(  ) {
  return function(d) { return "Utforska karta"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a261737821 = messageFormatterFn((function(  ) {
  return function(d) { return "Stäng kort"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b523995289 = messageFormatterFn((function(  ) {
  return function(d) { return "Utforska " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2042680333 = messageFormatterFn((function(  ) {
  return function(d) { return "Utforska sevärdheter i " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1195440426 = messageFormatterFn((function(  ) {
  return function(d) { return "Rum från " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b866881895 = messageFormatterFn((function(  ) {
  return function(d) { return "Priser från " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a552674999 = messageFormatterFn((function(  ) {
  return function(d) { return "Bild av " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1003238262 = messageFormatterFn((function(  ) {
  return function(d) { return "Beskuren"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b468442007 = messageFormatterFn((function(  ) {
  return function(d) { return "Frukost ingår"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1630574235 = messageFormatterFn((function(  ) {
  return function(d) { return "Nästa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1699274203 = messageFormatterFn((function(  ) {
  return function(d) { return "Föregående"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1812461832 = messageFormatterFn((function(  ) {
  return function(d) { return "Hämta nästa bild"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1881161800 = messageFormatterFn((function(  ) {
  return function(d) { return "Hämta föregående bild"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1991433034 = messageFormatterFn((function(  ) {
  return function(d) { return "Stäng fotogalleri"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a884932149 = messageFormatterFn((function(  ) {
  return function(d) { return "Vanliga frågor och svar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b327601485 = messageFormatterFn((function(  ) {
  return function(d) { return "Hur mycket kostar ett hotell i " + d["0"] + "?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2078684965 = messageFormatterFn((function(  ) {
  return function(d) { return "Månad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a664586596 = messageFormatterFn((function(  ) {
  return function(d) { return "Pris"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1929976824 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotell i " + d["0"] + " med två till fyra stjärnor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a699119990 = messageFormatterFn((function(  ) {
  return function(d) { return "Snittpriserna baseras på hotellbokningar från " + d["0"] + " på " + d["1"] + " för en natt och två vuxna."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1296367458 = messageFormatterFn((function(  ) {
  return function(d) { return "Snittpriserna baseras på bokningar av 2- till 4-stjärniga hotell från " + d["0"] + " på " + d["1"] + " för en natt och två vuxna. Hotellen har två till fyra stjärnor."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b857304858 = messageFormatterFn((function(  ) {
  return function(d) { return "Alla priser anges i " + d["0"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b187473001 = messageFormatterFn((function(  ) {
  return function(d) { return "* Prisuppgifter saknas"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a508530918 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingen data"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1652306242 = messageFormatterFn((function(  ) {
  return function(d) { return "Se lista"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b677439411 = messageFormatterFn((function(  ) {
  return function(d) { return "Hur mycket kostar det att bo i " + d["0"] + "?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b364852272 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Bokades senast för " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " minuter";}, one: function() { return number(d["0"]) + " minut";}, two: function() { return number(d["0"]) + " minuter";}, few: function() { return number(d["0"]) + " minuter";}, many: function() { return number(d["0"]) + " minuter";}, other: function() { return number(d["0"]) + " minuter";} }) + " sen"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a455327616 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Bokades senast för " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " timmar";}, one: function() { return number(d["0"]) + " timme";}, two: function() { return number(d["0"]) + " timmar";}, few: function() { return number(d["0"]) + " timmar";}, many: function() { return number(d["0"]) + " timmar";}, other: function() { return number(d["0"]) + " timmar";} }) + " sen"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b162274308 = messageFormatterFn((function(  ) {
  return function(d) { return "Avbryt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1052588578 = messageFormatterFn((function(  ) {
  return function(d) { return "Avvisa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a191039020 = messageFormatterFn((function(  ) {
  return function(d) { return "Rensa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1287755861 = messageFormatterFn((function(  ) {
  return function(d) { return "Städer som liknar " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b619244696 = messageFormatterFn((function(  ) {
  return function(d) { return "Läs reseguider och tips om att besöka " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1100257395 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Se " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " foton";}, one: function() { return number(d["0"]) + " foto";}, two: function() { return number(d["0"]) + " foton";}, few: function() { return "alla " + number(d["0"]) + " foton";}, many: function() { return "alla " + number(d["0"]) + " foton";}, other: function() { return "alla " + number(d["0"]) + " foton";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2070867593 = messageFormatterFn((function(  ) {
  return function(d) { return "Översikt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2019318611 = messageFormatterFn((function(  ) {
  return function(d) { return "Video"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1882423379 = messageFormatterFn((function(  ) {
  return function(d) { return "Förslag på områden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1032934525 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a67525129 = messageFormatterFn((function(  ) {
  return function(d) { return "Saker att göra"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1598423117 = messageFormatterFn((function(  ) {
  return function(d) { return "Recensioner"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1545223785 = messageFormatterFn((function(  ) {
  return function(d) { return "Bloggar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b631736696 = messageFormatterFn((function(  ) {
  return function(d) { return "Liknande resmål"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a126336999 = messageFormatterFn((function(  ) {
  return function(d) { return "Utforska " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1569508151 = messageFormatterFn((function(  ) {
  return function(d) { return "Reseguide till " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1136195367 = messageFormatterFn((function(  ) {
  return function(d) { return "Populära platser att besöka"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b479103938 = messageFormatterFn((function(  ) {
  return function(d) { return "Populära aktiviteter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1923542846 = messageFormatterFn((function(  ) {
  return function(d) { return "Typer av aktiviteter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a369578298 = messageFormatterFn((function(  ) {
  return function(d) { return "Lägsta pris per natt som vi hittade under de senaste 24 timmarna, baserat på 1 natt för 2 vuxna. Priser och tillgänglighet kan komma att ändras. Ytterligare villkor kan gälla."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1647642801 = messageFormatterFn((function(  ) {
  return function(d) { return "Se tillgänglighet"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1187245279 = messageFormatterFn((function(  ) {
  return function(d) { return "Prisökning från " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1800486141 = messageFormatterFn((function(  ) {
  return function(d) { return "Prissänkning från " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a528618386 = messageFormatterFn((function(  ) {
  return function(d) { return "Utsåld"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1131660570 = messageFormatterFn((function(  ) {
  return function(d) { return "Se alla dina senaste sökningar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b327896909 = messageFormatterFn((function(  ) {
  return function(d) { return "Du skulle kunna se lägre priser"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1271966437 = messageFormatterFn((function(  ) {
  return function(d) { return "Spara i genomsnitt " + d["0"] + " % på tusentals hotell när du är inloggad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1651232295 = messageFormatterFn((function(  ) {
  return function(d) { return "Spara minst " + d["0"] + " % på tusentals hotell när du är inloggad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a50749107 = messageFormatterFn((function(  ) {
  return function(d) { return "Med medlemspriser skulle du kunna spara minst 10 % nu på tusentals boenden."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a606552019 = messageFormatterFn((function(  ) {
  return function(d) { return "Gå med nu, det är gratis"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a800132015 = messageFormatterFn((function(  ) {
  return function(d) { return "Logga in"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1876779149 = messageFormatterFn((function(  ) {
  return function(d) { return "Hittar du inte det du letar efter?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a915302553 = messageFormatterFn((function(  ) {
  return function(d) { return "Pröva att sortera efter dessa alternativ"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a789124553 = messageFormatterFn((function(  ) {
  return function(d) { return "januari"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b842269311 = messageFormatterFn((function(  ) {
  return function(d) { return "februari"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b893278814 = messageFormatterFn((function(  ) {
  return function(d) { return "mars"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1541113883 = messageFormatterFn((function(  ) {
  return function(d) { return "april"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1614158652 = messageFormatterFn((function(  ) {
  return function(d) { return "maj"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a989692449 = messageFormatterFn((function(  ) {
  return function(d) { return "juni"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b14739977 = messageFormatterFn((function(  ) {
  return function(d) { return "juli"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b490322462 = messageFormatterFn((function(  ) {
  return function(d) { return "augusti"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1410724816 = messageFormatterFn((function(  ) {
  return function(d) { return "september"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a712251455 = messageFormatterFn((function(  ) {
  return function(d) { return "oktober"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b754667759 = messageFormatterFn((function(  ) {
  return function(d) { return "november"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a421020676 = messageFormatterFn((function(  ) {
  return function(d) { return "december"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1479890704 = messageFormatterFn((function(  ) {
  return function(d) { return "Bild från " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b794427069 = messageFormatterFn((function(  ) {
  return function(d) { return "Boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b659408984 = messageFormatterFn((function(  ) {
  return function(d) { return "Boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b89280081 = messageFormatterFn((function(  ) {
  return function(d) { return "Semesterpaket"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b695369053 = messageFormatterFn((function(  ) {
  return function(d) { return "Hyrbilar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1819009829 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1718208193 = messageFormatterFn((function(  ) {
  return function(d) { return "Aktiviteter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b319067166 = messageFormatterFn((function(  ) {
  return function(d) { return "Aktiviteter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1820010377 = messageFormatterFn((function(  ) {
  return function(d) { return "Grupper"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1449717790 = messageFormatterFn((function(  ) {
  return function(d) { return "Flygtransfer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1598170127 = messageFormatterFn((function(  ) {
  return function(d) { return "Semesterbostäder"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a447873884 = messageFormatterFn((function(  ) {
  return function(d) { return "Semesterbostäder"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1222863146 = messageFormatterFn((function(  ) {
  return function(d) { return "All inclusive-semestrar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2080377782 = messageFormatterFn((function(  ) {
  return function(d) { return "Kryssningar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1317919814 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + d["1"] + " av " + d["2"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a220151141 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1313688862 = messageFormatterFn((function(  ) {
  return function(d) { return "Luxury Hotels and Resorts Collection"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a642142224 = messageFormatterFn((function(  ) {
  return function(d) { return "Vet du vart du vill åka?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1946592822 = messageFormatterFn((function(  ) {
  return function(d) { return "Justera din sökning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1056812223 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2116911378 = messageFormatterFn((function(  ) {
  return function(d) { return "Populära filter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b872864630 = messageFormatterFn((function(  ) {
  return function(d) { return "Avancerade alternativ"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a323714336 = messageFormatterFn((function(  ) {
  return function(d) { return "Bra för affärsresor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a66434308 = messageFormatterFn((function(  ) {
  return function(d) { return "Bra för familjer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a711931129 = messageFormatterFn((function(  ) {
  return function(d) { return "Gratis avbokning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1428073744 = messageFormatterFn((function(  ) {
  return function(d) { return "Frukost ingår"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1774426087 = messageFormatterFn((function(  ) {
  return function(d) { return "Verifierad resenär"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2092772370 = messageFormatterFn((function(  ) {
  return function(d) { return "Fantastiskt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2092771409 = messageFormatterFn((function(  ) {
  return function(d) { return "Bra"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2092770448 = messageFormatterFn((function(  ) {
  return function(d) { return "Okej"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2092769487 = messageFormatterFn((function(  ) {
  return function(d) { return "Under förväntan"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2092768526 = messageFormatterFn((function(  ) {
  return function(d) { return "Väldigt dåligt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1052778262 = messageFormatterFn((function(  ) {
  return function(d) { return "Recensioner av " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b993915627 = messageFormatterFn((function(  ) {
  return function(d) { return "Toppdestination"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a469209359 = messageFormatterFn((function(  ) {
  return function(d) { return "Gästbetyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a185369461 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return d["1"] + " recensioner";}, one: function() { return d["1"] + " recension";}, two: function() { return d["1"] + " recensioner";}, few: function() { return d["1"] + " recensioner";}, many: function() { return d["1"] + " recensioner";}, other: function() { return d["1"] + " recensioner";} }); }
})(messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2089849852 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return "Se " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return d["1"] + " recensioner";}, one: function() { return d["1"] + " recension";}, two: function() { return d["1"] + " recensioner";}, few: function() { return "alla " + d["1"] + " recensioner";}, many: function() { return "alla " + d["1"] + " recensioner";}, other: function() { return "alla " + d["1"] + " recensioner";} }) + " för " + d["2"]; }
})(messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2106163186 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa fler"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1588956885 = messageFormatterFn((function(  ) {
  return function(d) { return "mindre än en timme sedan"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1237277290 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "för " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " timmar";}, one: function() { return "en timme";}, two: function() { return number(d["0"]) + " timmar";}, few: function() { return number(d["0"]) + " timmar";}, many: function() { return number(d["0"]) + " timmar";}, other: function() { return number(d["0"]) + " timmar";} }) + " sen"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b98195220 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "för " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " dagar";}, one: function() { return "en dag";}, two: function() { return number(d["0"]) + " dagar";}, few: function() { return number(d["0"]) + " dagar";}, many: function() { return number(d["0"]) + " dagar";}, other: function() { return number(d["0"]) + " dagar";} }) + " sen"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1266910118 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "för " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " veckor";}, one: function() { return "en vecka";}, two: function() { return number(d["0"]) + " veckor";}, few: function() { return number(d["0"]) + " veckor";}, many: function() { return number(d["0"]) + " veckor";}, other: function() { return number(d["0"]) + " veckor";} }) + " sen"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b914188016 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "för " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " månader";}, one: function() { return "en månad";}, two: function() { return number(d["0"]) + " månader";}, few: function() { return number(d["0"]) + " månader";}, many: function() { return number(d["0"]) + " månader";}, other: function() { return number(d["0"]) + " månader";} }) + " sen"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a154284322 = messageFormatterFn((function(  ) {
  return function(d) { return "ett år sedan"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a638602134 = messageFormatterFn((function(  ) {
  return function(d) { return "över ett år sedan"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2044981648 = messageFormatterFn((function(  ) {
  return function(d) { return "Planera din resa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1790174444 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " timmar";}, one: function() { return number(d["0"]) + " timme";}, two: function() { return number(d["0"]) + " timmar";}, few: function() { return number(d["0"]) + " timmar";}, many: function() { return number(d["0"]) + " timmar";}, other: function() { return number(d["0"]) + " timmar";} }) + " med bil"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1716129364 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " timmar";}, one: function() { return number(d["0"]) + " timme";}, two: function() { return number(d["0"]) + " timmar";}, few: function() { return number(d["0"]) + " timmar";}, many: function() { return number(d["0"]) + " timmar";}, other: function() { return number(d["0"]) + " timmar";} }) + ", " + plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + " minuter";}, one: function() { return number(d["1"]) + " minut";}, two: function() { return number(d["1"]) + " minuter";}, few: function() { return number(d["1"]) + " minuter";}, many: function() { return number(d["1"]) + " minuter";}, other: function() { return number(d["1"]) + " minuter";} }) + " med bil"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b133518916 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " minuter";}, one: function() { return number(d["0"]) + " minut";}, two: function() { return number(d["0"]) + " minuter";}, few: function() { return number(d["0"]) + " minuter";}, many: function() { return number(d["0"]) + " minuter";}, other: function() { return number(d["0"]) + " minuter";} }) + " med bil"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1994855435 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "°C (i snitt)"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1994852552 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "°F (i snitt)"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a636080280 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "/natt i snitt per rum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1342220762 = messageFormatterFn((function(  ) {
  return function(d) { return "Weekendresor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1018698447 = messageFormatterFn((function(  ) {
  return function(d) { return "Rekommenderade resmål baserat på hotell du har tittat på"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b181602735 = messageFormatterFn((function(  ) {
  return function(d) { return "Resmål för dig"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1080464164 = messageFormatterFn((function(  ) {
  return function(d) { return "Två nätter för två resenärer nära " + d["0"] + " i januari"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1466877958 = messageFormatterFn((function(  ) {
  return function(d) { return "Två nätter för två resenärer nära " + d["0"] + " i februari"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a818740789 = messageFormatterFn((function(  ) {
  return function(d) { return "Två nätter för två resenärer nära " + d["0"] + " i mars"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b811748936 = messageFormatterFn((function(  ) {
  return function(d) { return "Två nätter för två resenärer nära " + d["0"] + " i april"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a894710423 = messageFormatterFn((function(  ) {
  return function(d) { return "Två nätter för två resenärer nära " + d["0"] + " i maj"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1898537254 = messageFormatterFn((function(  ) {
  return function(d) { return "Två nätter för två resenärer nära " + d["0"] + " i juni"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1898496892 = messageFormatterFn((function(  ) {
  return function(d) { return "Två nätter för två resenärer nära " + d["0"] + " i juli"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a444585063 = messageFormatterFn((function(  ) {
  return function(d) { return "Två nätter för två resenärer nära " + d["0"] + " i augusti"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b692796989 = messageFormatterFn((function(  ) {
  return function(d) { return "Två nätter för två resenärer nära " + d["0"] + " i september"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1478339118 = messageFormatterFn((function(  ) {
  return function(d) { return "Två nätter för två resenärer nära " + d["0"] + " i oktober"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a615413142 = messageFormatterFn((function(  ) {
  return function(d) { return "Två nätter för två resenärer nära " + d["0"] + " i november"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a426598345 = messageFormatterFn((function(  ) {
  return function(d) { return "Två nätter för två resenärer nära " + d["0"] + " i december"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b205964969 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a901937398 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyg långt och vandra outtröttligt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1007970028 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta ditt nya äventyr uppe bland molnen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1068806084 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotell för drömresan"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b101182490 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta det perfekta boendet för din nästa resa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1388136307 = messageFormatterFn((function(  ) {
  return function(d) { return "Sätt ihop ett paket"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b81864687 = messageFormatterFn((function(  ) {
  return function(d) { return "Boka flyg, hotell eller hyrbil samtidigt och spara mer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b622136635 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter hyrbilar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a309953123 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök, jämför och spara med hyrbilsfirmor du litar på"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a725768302 = messageFormatterFn((function(  ) {
  return function(d) { return "Kryssningar som ger total avkoppling"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1903991763 = messageFormatterFn((function(  ) {
  return function(d) { return "Saker att göra, oavsett vart vägen leder"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2017690383 = messageFormatterFn((function(  ) {
  return function(d) { return "Upptäck fantastiska upplevelser och aktiviteter för din nästa resa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a106323680 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta och jämför flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a788263658 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök, jämför och boka flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b181786800 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta och boka hotell till nästa resa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1307531997 = messageFormatterFn((function(  ) {
  return function(d) { return "Spara med semesterpaket"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b478145433 = messageFormatterFn((function(  ) {
  return function(d) { return "Skapa ditt eget semesterpaket och spara på nästa resa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b600618193 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta och jämför hyrbilar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1415731641 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök, jämför och spara på de största hyrbilsfirmorna i branschen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1831546820 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta och jämför kryssningar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1752661181 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta saker att göra"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b591397945 = messageFormatterFn((function(  ) {
  return function(d) { return "Utforska och boka aktiviteter för din nästa resa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b708730753 = messageFormatterFn((function(  ) {
  return function(d) { return "Saker att göra i"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1800509844 = messageFormatterFn((function(  ) {
  return function(d) { return "Hyrbilar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1012536244 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a804834670 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a173816074 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter aktiviteter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b333009122 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter semesterpaket"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1813295280 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj minst två produkter för att skapa din resa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a174108218 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter semesterboenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1084409260 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter bilar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1247135891 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter kryssningar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1438085263 = messageFormatterFn((function(  ) {
  return function(d) { return "Mer info om " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b51948952 = messageFormatterFn((function(  ) {
  return function(d) { return "Rekommenderade hotell vid " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a85461967 = messageFormatterFn((function(  ) {
  return function(d) { return "Rekommenderade hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1285355045 = messageFormatterFn((function(  ) {
  return function(d) { return "Bo här"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b380505816 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + "/5 (" + plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + " recensioner";}, one: function() { return number(d["1"]) + " recension";}, two: function() { return number(d["1"]) + " recensioner";}, few: function() { return number(d["1"]) + " recensioner";}, many: function() { return number(d["1"]) + " recensioner";}, other: function() { return number(d["1"]) + " recensioner";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b75814330 = messageFormatterFn((function(  ) {
  return function(d) { return "#" + d["0"] + " för " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1662116460 = messageFormatterFn((function(  ) {
  return function(d) { return "Video av " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a429265584 = messageFormatterFn((function(  ) {
  return function(d) { return "<b>" + d["0"] + " %</b> av resenärer rekommenderar aktiviteten"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a382454091 = messageFormatterFn((function(  ) {
  return function(d) { return "Per vuxen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2097276269 = messageFormatterFn((function(  ) {
  return function(d) { return "Har du inte bestämt vart du ska än?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1936014594 = messageFormatterFn((function(  ) {
  return function(d) { return "Stränder"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b411358977 = messageFormatterFn((function(  ) {
  return function(d) { return "Familjevänligt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b527038516 = messageFormatterFn((function(  ) {
  return function(d) { return "Romantiskt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2104453888 = messageFormatterFn((function(  ) {
  return function(d) { return "Berg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a974331706 = messageFormatterFn((function(  ) {
  return function(d) { return "Historiskt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1596132095 = messageFormatterFn((function(  ) {
  return function(d) { return "Spa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1891372669 = messageFormatterFn((function(  ) {
  return function(d) { return "Golf"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1172997808 = messageFormatterFn((function(  ) {
  return function(d) { return "Kasinon"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a945727388 = messageFormatterFn((function(  ) {
  return function(d) { return "Äventyrsbad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1469747153 = messageFormatterFn((function(  ) {
  return function(d) { return "Bubbelpool"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2145837129 = messageFormatterFn((function(  ) {
  return function(d) { return "Pool"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1464624254 = messageFormatterFn((function(  ) {
  return function(d) { return "Stäng"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1829527221 = messageFormatterFn((function(  ) {
  return function(d) { return "Din kommande resa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1925714834 = messageFormatterFn((function(  ) {
  return function(d) { return "Din resa till " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a859155898 = messageFormatterFn((function(  ) {
  return function(d) { return "Rabatterat för dig!"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1077914922 = messageFormatterFn((function(  ) {
  return function(d) { return "Se hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b563913184 = messageFormatterFn((function(  ) {
  return function(d) { return "Rabatt på bilar för dig!"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1278015748 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har fått tillgång till hyrbilsrabatter på upp till " + d["0"] + " % eftersom du bokat på Expedia."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b87553660 = messageFormatterFn((function(  ) {
  return function(d) { return "Se bilar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b173473216 = messageFormatterFn((function(  ) {
  return function(d) { return "Rabatt på hotell för dig!"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a913245476 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har fått tillgång till hotellrabatter på upp till " + d["0"] + " % eftersom du bokat på Expedia."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b437465273 = messageFormatterFn((function(  ) {
  return function(d) { return "<b>" + d["0"] + "</b> (" + d["1"] + ") <b>- " + d["2"] + "</b> (" + d["3"] + ")"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b810509407 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " (" + d["1"] + ") - " + d["2"] + " (" + d["3"] + ")"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a752162785 = messageFormatterFn((function(  ) {
  return function(d) { return "Regler och villkor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b515297096 = messageFormatterFn((function(  ) {
  return function(d) { return "Prisinformation"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a333906846 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa mer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b399970253 = messageFormatterFn((function(  ) {
  return function(d) { return "Priset var " + d["0"] + " och är nu " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1832894897 = messageFormatterFn((function(  ) {
  return function(d) { return "Erbjudanden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1648773933 = messageFormatterFn((function(  ) {
  return function(d) { return "Kampanjen har tyvärr avslutats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1538197131 = messageFormatterFn((function(  ) {
  return function(d) { return "Kolla in andra rekommendationer och erbjudanden på resor nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b39828118 = messageFormatterFn((function(  ) {
  return function(d) { return "Familjer uppskattar:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b372576484 = messageFormatterFn((function(  ) {
  return function(d) { return "Resenärer uppskattar:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a220440857 = messageFormatterFn((function(  ) {
  return function(d) { return "Bra för barnfamiljer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1902514469 = messageFormatterFn((function(  ) {
  return function(d) { return "Bra för spahelger"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b454928683 = messageFormatterFn((function(  ) {
  return function(d) { return "Resenärerna tycker till..."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2082492773 = messageFormatterFn((function(  ) {
  return function(d) { return "Filter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a180186450 = messageFormatterFn((function(  ) {
  return function(d) { return "Filtrera din sökning efter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a736535236 = messageFormatterFn((function(  ) {
  return function(d) { return "Sortera och filtrera"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a837093858 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa fler"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a799272742 = messageFormatterFn((function(  ) {
  return function(d) { return "Se mindre"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1603103733 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa mindre"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b593086571 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa mer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1511880180 = messageFormatterFn((function(  ) {
  return function(d) { return "Hämta pris"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b378198026 = messageFormatterFn((function(  ) {
  return function(d) { return "Fortsätt din planering"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a827628002 = messageFormatterFn((function(  ) {
  return function(d) { return "per resenär"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a975156336 = messageFormatterFn((function(  ) {
  return function(d) { return "per person"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2002476552 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Utforska liknande " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + "-stjärniga";}, one: function() { return number(d["0"]) + "-stjärniga";}, two: function() { return number(d["0"]) + "-stjärniga";}, few: function() { return number(d["0"]) + "-stjärniga";}, many: function() { return number(d["0"]) + "-stjärniga";}, other: function() { return number(d["0"]) + "-stjärniga";} }) + " hotell"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a355153214 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Många " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + "-stjärniga";}, one: function() { return number(d["0"]) + "-stjärniga";}, two: function() { return number(d["0"]) + "-stjärniga";}, few: function() { return number(d["0"]) + "-stjärniga";}, many: function() { return number(d["0"]) + "-stjärniga";}, other: function() { return number(d["0"]) + "-stjärniga";} }) + " hotell har samma bekvämligheter som " + plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + "-stjärniga";}, one: function() { return number(d["1"]) + "-stjärniga";}, two: function() { return number(d["1"]) + "-stjärniga";}, few: function() { return number(d["1"]) + "-stjärniga";}, many: function() { return number(d["1"]) + "-stjärniga";}, other: function() { return number(d["1"]) + "-stjärniga";} }) + " hotell. Se alla " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + "-stjärniga";}, one: function() { return number(d["0"]) + "-stjärniga";}, two: function() { return number(d["0"]) + "-stjärniga";}, few: function() { return number(d["0"]) + "-stjärniga";}, many: function() { return number(d["0"]) + "-stjärniga";}, other: function() { return number(d["0"]) + "-stjärniga";} }) + " hotell i " + d["2"] + "."; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1619385743 = messageFormatterFn((function(  ) {
  return function(d) { return "Hittar du inte det du letar efter?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b182508359 = messageFormatterFn((function(  ) {
  return function(d) { return "Se alla boenden i " + d["0"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a58636957 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan även använda de här populära alternativen för att filtrera din sökning."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b438782211 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return d["1"] + "-stjärnigt";}, one: function() { return d["1"] + "-stjärnigt";}, two: function() { return d["1"] + "-stjärnigt";}, few: function() { return d["1"] + "-stjärnigt";}, many: function() { return d["1"] + "-stjärnigt";}, other: function() { return d["1"] + "-stjärnigt";} }) + " boende"; }
})(messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1031834215 = messageFormatterFn((function(  ) {
  return function(d) { return "Tur-och-retur, direkt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b68880474 = messageFormatterFn((function(  ) {
  return function(d) { return "Tur-och-retur"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a509068354 = messageFormatterFn((function(  ) {
  return function(d) { return "Direkt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a973949870 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " nätters";}, one: function() { return number(d["0"]) + " natts";}, two: function() { return number(d["0"]) + " nätters";}, few: function() { return number(d["0"]) + " nätters";}, many: function() { return number(d["0"]) + " nätters";}, other: function() { return number(d["0"]) + " nätters";} }) + " vistelse"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b12456426 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter detta paket med flyg och hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b669540986 = messageFormatterFn((function(  ) {
  return function(d) { return "Inkluderar " + d["0"] + " och " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1753146848 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " nätters";}, one: function() { return number(d["0"]) + " natts";}, two: function() { return number(d["0"]) + " nätters";}, few: function() { return number(d["0"]) + " nätters";}, many: function() { return number(d["0"]) + " nätters";}, other: function() { return number(d["0"]) + " nätters";} }) + " vistelse"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a86998776 = messageFormatterFn((function(  ) {
  return function(d) { return "Läs information"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a562356702 = messageFormatterFn((function(  ) {
  return function(d) { return "Stäng"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b300536746 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " (" + d["1"] + ") till " + d["2"] + " (" + d["3"] + ")"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a906960547 = messageFormatterFn((function(  ) {
  return function(d) { return "Spara " + d["0"] + " % på ditt flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1814673313 = messageFormatterFn((function(  ) {
  return function(d) { return "Spara " + d["0"] + " % på din hyrbil"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b936995887 = messageFormatterFn((function(  ) {
  return function(d) { return "Priset var " + d["0"] + " och är nu " + d["1"] + " per person"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b12401649 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj detta paket med hotell och hyrbil"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2018087426 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Kompakt hyrbil och " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " nätters";}, one: function() { return number(d["0"]) + " natts";}, two: function() { return number(d["0"]) + " nätters";}, few: function() { return number(d["0"]) + " nätters";}, many: function() { return number(d["0"]) + " nätters";}, other: function() { return number(d["0"]) + " nätters";} }) + " vistelse"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a502378481 = messageFormatterFn((function(  ) {
  return function(d) { return "Klicka och avboka: Ditt hotell är giltigt för gratis avbokning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a995919313 = messageFormatterFn((function(  ) {
  return function(d) { return "Klicka och avboka: Ditt flyg är giltigt för gratis avbokning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1313416701 = messageFormatterFn((function(  ) {
  return function(d) { return "Resplansnummer " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b78036673 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan göra en gratis avbokning innan du checkar in och bli återbetalad genom din ursprungliga betalningsmetod. Vi avbokar automatiskt din bokning när du klickar på knappen nedan. Kom ihåg att du inte behöver ringa för att bekräfta den här avbokningen - vi tar hand om det här. Om du vill behålla din bokning eller redan har avbokat den stänger du den här sidan utan att klicka på knappen nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1269168353 = messageFormatterFn((function(  ) {
  return function(d) { return "Ditt flygbolag kommer låta dig avboka ditt flyg gratis upp till 24 timmar innan du reser, och ger dig kredit för att boka flyg med dem i framtiden. Vi avbokar automatiskt ditt flyg när du klickar på knappen nedan. Kom ihåg att du inte behöver ringa för att bekräfta den här avbokningen - vi tar hand om det här. Om du vill behålla din bokning eller redan har avbokat den stänger du den här sidan utan att klicka på knappen nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a423833033 = messageFormatterFn((function(  ) {
  return function(d) { return "Avboka ditt boende"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1301665456 = messageFormatterFn((function(  ) {
  return function(d) { return "Avboka din bokning på " + d["0"] + " senast den " + d["1"] + " för att få en full återbetalning."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1301664495 = messageFormatterFn((function(  ) {
  return function(d) { return "Vid en avbokning får du en full återbetalning via samma betalningsmetod du valde vid bokningen. Det kan ta upp till 30 dagar innan du mottar din återbetalning."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1301663534 = messageFormatterFn((function(  ) {
  return function(d) { return "Vill du avboka din bokning?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2032729080 = messageFormatterFn((function(  ) {
  return function(d) { return "Genom att välja ”Ja, jag vill avboka” bekräftar jag att jag vill avboka och att jag inte kommer att debiteras en avbokningsavgift."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1398763549 = messageFormatterFn((function(  ) {
  return function(d) { return "Läs våra regler och villkor."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a9802561 = messageFormatterFn((function(  ) {
  return function(d) { return "Ja, jag vill avboka"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1648970470 = messageFormatterFn((function(  ) {
  return function(d) { return "Nej, avboka inte"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1859398055 = messageFormatterFn((function(  ) {
  return function(d) { return "Regler och villkor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1073430434 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan avboka en förbetald hotellbokning utan att debiteras en avbokningsavgift, vilket du kan läsa mer om i reglerna och restriktionerna för bokningen,"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1073429473 = messageFormatterFn((function(  ) {
  return function(d) { return "Om du inte avbokar innan det avbokningsdatum som anges i detta meddelande kommer du att debiteras en avgift motsvarande priset för nätterna, skatteavgifter och serviceavgifter."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1073428512 = messageFormatterFn((function(  ) {
  return function(d) { return "Det kan ta upp till 30 dagar innan du an se återbetalningen på ditt konto, beroende på vilken bank du har."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b260962810 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har avbokat din bokning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b163976748 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kommer att skicka en bekräftelse till " + d["0"] + " inom 14 dagar. Det kan ta upp till 30 dagar innan du mottar din återbetalning."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1727457054 = messageFormatterFn((function(  ) {
  return function(d) { return "Din bokning är fortfarande aktiv"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a566957804 = messageFormatterFn((function(  ) {
  return function(d) { return "Tack för att du bekräftar att du vill behålla din bokning."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1458330227 = messageFormatterFn((function(  ) {
  return function(d) { return "Avboka ditt flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b492935156 = messageFormatterFn((function(  ) {
  return function(d) { return "Avboka ditt flyg så ger vi dig flygbolagskredit för det ursprungliga biljettpriset, som du kan använda till en framtida flygresa med samma flygbolag."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1266921536 = messageFormatterFn((function(  ) {
  return function(d) { return "Avboka ditt flyg senast " + d["0"] + ", så får du flygbolagskredit av flygbolaget till ett värde som motsvarar det ursprungliga biljettpriset. Du kan använda krediten till en framtida flygresa med samma flygbolag inom 24 månader från det ursprungliga inköpsdatumet."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b492934195 = messageFormatterFn((function(  ) {
  return function(d) { return "Om flygbolaget redan har ställt in din bokning kan du ignorera det här meddelandet."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b492933234 = messageFormatterFn((function(  ) {
  return function(d) { return "Vill du avboka ditt flyg?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a150565820 = messageFormatterFn((function(  ) {
  return function(d) { return "Genom att välja ”Ja, avboka mitt flyg” bekräftar jag att jag vill avboka och att jag inte kommer att debiteras en avbokningsavgift."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1071871739 = messageFormatterFn((function(  ) {
  return function(d) { return "Ja, avboka mitt flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1181613014 = messageFormatterFn((function(  ) {
  return function(d) { return "Nej, avboka inte"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1249024202 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har avbokat ditt flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a192251375 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi skickar en e-postbekräftelse till " + d["0"] + " inom några veckor. Det är inte säkert att vi kommer kunna skicka ett svar innan ditt avresedatum. Men vi kan försäkra dig om att din avbokning kommer att behandlas. Du behöver inte göra något mer."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a192252336 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi ger dig flygbolagskredit för det ursprungliga biljettpriset, som du kan använda till en framtida flygresa med samma flygbolag."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a192253297 = messageFormatterFn((function(  ) {
  return function(d) { return "På grund av den stora mängden resestörningar kan det ta upp till 30 dagar att behandla din flygbolagskredit. Du kommer att få ett till e-postmeddelande när flygbolagskrediten är tillgänglig. E-postmeddelandet kommer att innehålla mängden flygbolagskredit, giltighetstiden och information om hur du kan använda krediten för en framtida flygresa."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1739675174 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har inte ändrat din bokning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1945528408 = messageFormatterFn((function(  ) {
  return function(d) { return "Tack för att du bekräftat att du inte vill att vi avbokar ditt flyg."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2073651005 = messageFormatterFn((function(  ) {
  return function(d) { return "Avboka eller behåll din hotellbokning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1656041622 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har samarbetat med våra resepartners för att erbjuda dig ersättning i form av en värdekupong om du bestämmer dig för att avboka din icke-återbetalningsbara bokning."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1656042583 = messageFormatterFn((function(  ) {
  return function(d) { return "Du måste avboka senast " + d["0"] + " för att få en kupong. Kupongens värde kommer vara samma som det ursprungliga priset. Bara meddela oss om du vill avboka eller behålla din bokning."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a95875387 = messageFormatterFn((function(  ) {
  return function(d) { return "Avboka min bokning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a193359968 = messageFormatterFn((function(  ) {
  return function(d) { return "Behåll min bokning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a623870080 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har avbokat din bokning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b688215559 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kommer att se uppdateringen i din resplan inom 72 timmar. Obs: Kupongbeloppet kommer inte att visas på din resplan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b688214598 = messageFormatterFn((function(  ) {
  return function(d) { return "På grund av det stora antalet störningar i resetrafiken kan det ta upp till 30 dagar för din kupong att utfärdas. Du får inget e-postmeddelande förrän din kupong är klar. Du behöver inte göra något mer."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b688213637 = messageFormatterFn((function(  ) {
  return function(d) { return "Kupongen är giltig i ett år från att den utfärdas och ska användas för en ny bokning på samma boende."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a100747364 = messageFormatterFn((function(  ) {
  return function(d) { return "Din bokning är fortfarande aktiv"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a454363954 = messageFormatterFn((function(  ) {
  return function(d) { return "Tack för att du bekräftar att du vill behålla din bokning."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a771123561 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi beklagar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1064521742 = messageFormatterFn((function(  ) {
  return function(d) { return "Avboka dina flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a538902471 = messageFormatterFn((function(  ) {
  return function(d) { return "Om du avbokar dina flyg så ger vi dig flygbolagskredit för de ursprungliga biljettpriserna, som du kan använda till framtida flygresor med samma flygbolag. Om du väljer att avboka kommer samtliga av följande flyg att avbokas:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a435365463 = messageFormatterFn((function(  ) {
  return function(d) { return "Om du avbokar dina flyg så ger vi dig flygbolagskredit för de ursprungliga biljettpriserna, som du kan använda till framtida flygresor med samma flygbolag. Om du väljer att avboka kommer samtliga av följande flyg att avbokas:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a538903432 = messageFormatterFn((function(  ) {
  return function(d) { return "Om flygbolagen redan har avbokat dina bokningar kan du ignorera det här meddelandet."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a435366424 = messageFormatterFn((function(  ) {
  return function(d) { return "Om flygbolaget redan har avbokat dina bokningar kan du ignorera det här meddelandet."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a538904393 = messageFormatterFn((function(  ) {
  return function(d) { return "Vill du avboka dina flyg?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a538905354 = messageFormatterFn((function(  ) {
  return function(d) { return "Obs: Vi kommer att avboka alla flyg ovan samtidigt. Vi kan inte avboka flygresorna separat."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a544374305 = messageFormatterFn((function(  ) {
  return function(d) { return "Genom att välja ”Ja, avboka mina flyg” bekräftar jag att jag vill avboka alla mina flyg och att jag inte kommer att debiteras en avbokningsavgift."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a93313258 = messageFormatterFn((function(  ) {
  return function(d) { return "Ja, avboka mina flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b874403601 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har avbokat dina flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a292810730 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kommer att skicka " + d["0"] + " e-postbekräftelser (en för varje flyg) till " + d["1"] + " inom de kommande veckorna. Det är inte säkert att vi kommer kunna skicka ett svar innan ditt avresedatum. Men vi kan försäkra dig om att din avbokning kommer att behandlas. Du behöver inte göra något mer."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a292811691 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kommer att få flygbolagskredit för de ursprungliga biljettpriserna, som du kan använda till framtida flygresor med samma flygbolag."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1829867413 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kommer att få flygbolagskredit för de ursprungliga biljettpriserna, som du kan använda till framtida flygresor med samma flygbolag."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a292812652 = messageFormatterFn((function(  ) {
  return function(d) { return "På grund av den stora mängden resestörningar kan det ta upp till 30 dagar att behandla din flygbolagskredit. Du kommer att få " + d["0"] + " till e-postmeddelanden när flygbolagskrediten är tillgänglig. E-postmeddelandena kommer att innehålla mängden flygbolagskredit, giltighetstiderna och information om hur du kan använda krediten för framtida flygresor."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a749948223 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ": " + d["1"] + " - " + d["2"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2117765108 = messageFormatterFn((function(  ) {
  return function(d) { return "Avboka ditt flyg med " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b772358675 = messageFormatterFn((function(  ) {
  return function(d) { return "Avbokar du ditt flyg med " + d["0"] + " så ger vi dig kredit hos flygbolaget för det ursprungliga biljettpriset som du kan använda för en framtida flygresa med " + d["0"] + ". Om du väljer att avboka kommer följande flyg att avbokas:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b772357714 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kan tyvärr inte avboka följande flyg. Du måste kontakta flygbolaget för att avboka det här flyget."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b772356753 = messageFormatterFn((function(  ) {
  return function(d) { return "Genom att välja ”Ja, avboka mitt flyg med " + d["0"] + "” bekräftar jag att jag vill avboka mitt flyg med " + d["0"] + " och att jag inte måste betala en avbokningsavgift. Jag förstår även att jag måste avboka mitt flyg med " + d["1"] + " via flygbolaget."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1855128580 = messageFormatterFn((function(  ) {
  return function(d) { return "Ja, avboka mitt flyg med " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a602865765 = messageFormatterFn((function(  ) {
  return function(d) { return "Nej, avboka inte mitt flyg med " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b867949559 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har avbokat ditt flyg med " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1665737968 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi skickar en e-postbekräftelse till " + d["0"] + " inom några veckor. Det är inte säkert att vi kommer kunna skicka ett svar innan ditt avresedatum. Men vi kan försäkra dig om att din avbokning kommer att behandlas. Du behöver inte göra något mer."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1665737007 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kommer att få kredit hos flygbolaget för det ursprungliga biljettpriset med " + d["0"] + " som du kan använda för en framtida resa med " + d["0"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1665736046 = messageFormatterFn((function(  ) {
  return function(d) { return "På grund av den stora mängden resestörningar kan det ta upp till 30 dagar att behandla din flygbolagskredit. Du kommer att få ett till e-postmeddelande när flygbolagskrediten är tillgänglig. I e-postmeddelandet får du information om mängden flygbolagskredit, giltighetstiden och hur du använder den för en framtida flygresa."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1019521099 = messageFormatterFn((function(  ) {
  return function(d) { return "Länk till reseguiden för " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b655143054 = messageFormatterFn((function(  ) {
  return function(d) { return "Länk till reseguiden för " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a449208513 = messageFormatterFn((function(  ) {
  return function(d) { return "Se alla tillgängliga resor från " + d["0"] + " till " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a365585525 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa alla resor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a855839434 = messageFormatterFn((function(  ) {
  return function(d) { return "Ansök nu"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1148854759 = messageFormatterFn((function(  ) {
  return function(d) { return "Läs information"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1004586017 = messageFormatterFn((function(  ) {
  return function(d) { return "Tabellen tjänar bara som en illustration"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1034445272 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa info"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1154559112 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa recension"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1439519985 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b144025213 = messageFormatterFn((function(  ) {
  return function(d) { return "Dölj info"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1726211635 = messageFormatterFn((function(  ) {
  return function(d) { return "Dölj recension"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1323818730 = messageFormatterFn((function(  ) {
  return function(d) { return "Valt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1917119059 = messageFormatterFn((function(  ) {
  return function(d) { return "Valt bort"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b681392803 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan även hantera dina cookieinställningar när som helst"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1836710315 = messageFormatterFn((function(  ) {
  return function(d) { return "Reseguide för " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a559993984 = messageFormatterFn((function(  ) {
  return function(d) { return "Reseguide för " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1654357870 = messageFormatterFn((function(  ) {
  return function(d) { return "Reseguide för " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1516365139 = messageFormatterFn((function(  ) {
  return function(d) { return "Ankomstflygplats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1533329999 = messageFormatterFn((function(  ) {
  return function(d) { return "Avreseflygplats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b138840629 = messageFormatterFn((function(  ) {
  return function(d) { return "Pris tur-och-retur"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1366446132 = messageFormatterFn((function(  ) {
  return function(d) { return "Distans"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b455915277 = messageFormatterFn((function(  ) {
  return function(d) { return "Avreseort"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1624024175 = messageFormatterFn((function(  ) {
  return function(d) { return "Destination"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1498555578 = messageFormatterFn((function(  ) {
  return function(d) { return "IATA-kod för ankomstflygplats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a296664694 = messageFormatterFn((function(  ) {
  return function(d) { return "IATA-kod för avreseflygplats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1912215036 = messageFormatterFn((function(  ) {
  return function(d) { return "Populärt flygbolag"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1284491833 = messageFormatterFn((function(  ) {
  return function(d) { return "Snittflygtid"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b52880802 = messageFormatterFn((function(  ) {
  return function(d) { return "Antal verkande flygbolag"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a743197013 = messageFormatterFn((function(  ) {
  return function(d) { return "Antal flygalternativ"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1557479828 = messageFormatterFn((function(  ) {
  return function(d) { return "Verkande flygbolag"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1263546953 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyginformation för " + d["0"] + " till " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1848577441 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " timmar";}, one: function() { return number(d["0"]) + " timme";}, two: function() { return number(d["0"]) + " timmar";}, few: function() { return number(d["0"]) + " timmar";}, many: function() { return number(d["0"]) + " timmar";}, other: function() { return number(d["0"]) + " timmar";} }) + " " + plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + " min";}, one: function() { return number(d["1"]) + " min";}, two: function() { return number(d["1"]) + " min";}, few: function() { return number(d["1"]) + " min";}, many: function() { return number(d["1"]) + " min";}, other: function() { return number(d["1"]) + " min";} }) + " med bil"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1144201390 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " timmar";}, one: function() { return number(d["0"]) + " timme";}, two: function() { return number(d["0"]) + " timmar";}, few: function() { return number(d["0"]) + " timmar";}, many: function() { return number(d["0"]) + " timmar";}, other: function() { return number(d["0"]) + " timmar";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a217880958 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " min";}, one: function() { return number(d["0"]) + " min";}, two: function() { return number(d["0"]) + " min";}, few: function() { return number(d["0"]) + " min";}, many: function() { return number(d["0"]) + " min";}, other: function() { return number(d["0"]) + " min";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b781004361 = messageFormatterFn((function(  ) {
  return function(d) { return "Flygplatskod"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a402063989 = messageFormatterFn((function(  ) {
  return function(d) { return "Land"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b478744875 = messageFormatterFn((function(  ) {
  return function(d) { return "Flygplatsens namn"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1413995234 = messageFormatterFn((function(  ) {
  return function(d) { return "Antal flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b863564871 = messageFormatterFn((function(  ) {
  return function(d) { return "Flygplatser för " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b793168731 = messageFormatterFn((function(  ) {
  return function(d) { return "Res med " + d["0"] + " idag och flyg till flera destinationer från dessa inrikes och internationella flygplatser."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a199309953 = messageFormatterFn((function(  ) {
  return function(d) { return "Flygbolag"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1310261399 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1375855736 = messageFormatterFn((function(  ) {
  return function(d) { return "Avgång"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1872725329 = messageFormatterFn((function(  ) {
  return function(d) { return "Avgår"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a914848773 = messageFormatterFn((function(  ) {
  return function(d) { return "Ankomst"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b551905646 = messageFormatterFn((function(  ) {
  return function(d) { return "Ankommer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b52953222 = messageFormatterFn((function(  ) {
  return function(d) { return "Stopp"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a959459512 = messageFormatterFn((function(  ) {
  return function(d) { return "Se pris"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1819406348 = messageFormatterFn((function(  ) {
  return function(d) { return "Terminal"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1513350981 = messageFormatterFn((function(  ) {
  return function(d) { return "Gate"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1477845617 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingen data tillgänglig för tillfället"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1155148519 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har inga uppgifter för det här flyget på det här datumet just nu."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a101717345 = messageFormatterFn((function(  ) {
  return function(d) { return "Försök igen senare"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b409901633 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "TOTAL RESTID: " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " h";}, one: function() { return number(d["0"]) + " h";}, two: function() { return number(d["0"]) + " h";}, few: function() { return number(d["0"]) + " h";}, many: function() { return number(d["0"]) + " h";}, other: function() { return number(d["0"]) + " h";} }) + " " + plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + " m";}, one: function() { return number(d["1"]) + " m";}, two: function() { return number(d["1"]) + " m";}, few: function() { return number(d["1"]) + " m";}, many: function() { return number(d["1"]) + " m";}, other: function() { return number(d["1"]) + " m";} }) + " | TOTAL STRÄCKA: " + d["2"] + " " + d["3"]; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1845286717 = messageFormatterFn((function(  ) {
  return function(d) { return "Resesökningar tillhandahålls av Expedia."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1371707714 = messageFormatterFn((function(  ) {
  return function(d) { return "Hämtningsplats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1033409954 = messageFormatterFn((function(  ) {
  return function(d) { return "Hittar du inte det du letar efter?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1662295908 = messageFormatterFn((function(  ) {
  return function(d) { return "Se alla hyrbilar i " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a912499526 = messageFormatterFn((function(  ) {
  return function(d) { return "Se alla bilar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a343992822 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "De lägsta priser som hittades under " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return "de senaste " + number(d["0"]) + " dagarna";}, one: function() { return "det senaste dygnet";}, two: function() { return "de senaste " + number(d["0"]) + " dagarna";}, few: function() { return "de senaste " + number(d["0"]) + " dagarna";}, many: function() { return "de senaste " + number(d["0"]) + " dagarna";}, other: function() { return "de senaste " + number(d["0"]) + " dagarna";} }) + ". Priser och tillgänglighet kan ändras. Ytterligare villkor kan gälla."; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1726050662 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "De lägsta priser som hittades under " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return "de senaste " + number(d["0"]) + " timmarna";}, one: function() { return "den senaste timmen";}, two: function() { return "de senaste " + number(d["0"]) + " timmarna";}, few: function() { return "de senaste " + number(d["0"]) + " timmarna";}, many: function() { return "de senaste " + number(d["0"]) + " timmarna";}, other: function() { return "de senaste " + number(d["0"]) + " timmarna";} }) + ". Priser och tillgänglighet kan ändras. Ytterligare villkor kan gälla. "; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a852025301 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " personer";}, one: function() { return number(d["0"]) + " person";}, two: function() { return number(d["0"]) + " personer";}, few: function() { return number(d["0"]) + " personer";}, many: function() { return number(d["0"]) + " personer";}, other: function() { return number(d["0"]) + " personer";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b946483087 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " eller liknande"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a715819995 = messageFormatterFn((function(  ) {
  return function(d) { return "per dag"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1090216158 = messageFormatterFn((function(  ) {
  return function(d) { return "totalt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b881757170 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " Airport (" + d["1"] + ")"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1422295710 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", " + d["1"] + ", " + d["2"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1427153363 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1270646672 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " " + d["1"] + " från centrala " + d["2"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1840251746 = messageFormatterFn((function(  ) {
  return function(d) { return "Obegränsad körsträcka"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1017030551 = messageFormatterFn((function(  ) {
  return function(d) { return "Begränsad körsträcka"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a457101267 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " gratis miles";}, one: function() { return number(d["0"]) + " gratis mile";}, two: function() { return number(d["0"]) + " gratis miles";}, few: function() { return number(d["0"]) + " gratis miles";}, many: function() { return number(d["0"]) + " gratis miles";}, other: function() { return number(d["0"]) + " gratis miles";} }) + "/dag"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2084722279 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " gratis km";}, one: function() { return number(d["0"]) + " gratis km";}, two: function() { return number(d["0"]) + " gratis km";}, few: function() { return number(d["0"]) + " gratis km";}, many: function() { return number(d["0"]) + " gratis km";}, other: function() { return number(d["0"]) + " gratis km";} }) + "/dag"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b821802723 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " gratis miles";}, one: function() { return number(d["0"]) + " gratis mile";}, two: function() { return number(d["0"]) + " gratis miles";}, few: function() { return number(d["0"]) + " gratis miles";}, many: function() { return number(d["0"]) + " gratis miles";}, other: function() { return number(d["0"]) + " gratis miles";} }) + "/vecka"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1986045975 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " gratis km";}, one: function() { return number(d["0"]) + " gratis km";}, two: function() { return number(d["0"]) + " gratis km";}, few: function() { return number(d["0"]) + " gratis km";}, many: function() { return number(d["0"]) + " gratis km";}, other: function() { return number(d["0"]) + " gratis km";} }) + "/vecka"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1088090375 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " gratis miles";}, one: function() { return number(d["0"]) + " gratis mile";}, two: function() { return number(d["0"]) + " gratis miles";}, few: function() { return number(d["0"]) + " gratis miles";}, many: function() { return number(d["0"]) + " gratis miles";}, other: function() { return number(d["0"]) + " gratis miles";} }) + "/månad"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2062913203 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " gratis km";}, one: function() { return number(d["0"]) + " gratis km";}, two: function() { return number(d["0"]) + " gratis km";}, few: function() { return number(d["0"]) + " gratis km";}, many: function() { return number(d["0"]) + " gratis km";}, other: function() { return number(d["0"]) + " gratis km";} }) + "/månad"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b758413311 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " gratis miles";}, one: function() { return number(d["0"]) + " gratis mile";}, two: function() { return number(d["0"]) + " gratis miles";}, few: function() { return number(d["0"]) + " gratis miles";}, many: function() { return number(d["0"]) + " gratis miles";}, other: function() { return number(d["0"]) + " gratis miles";} }) + " totalt"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1237802363 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " gratis km";}, one: function() { return number(d["0"]) + " gratis km";}, two: function() { return number(d["0"]) + " gratis km";}, few: function() { return number(d["0"]) + " gratis km";}, many: function() { return number(d["0"]) + " gratis km";}, other: function() { return number(d["0"]) + " gratis km";} }) + " totalt"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2025299625 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " till " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a845488577 = messageFormatterFn((function(  ) {
  return function(d) { return "När är det bäst att resa till " + d["0"] + "?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a482988566 = messageFormatterFn((function(  ) {
  return function(d) { return "När är det bäst att resa till " + d["0"] + "?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1505007959 = messageFormatterFn((function(  ) {
  return function(d) { return "Osäker på när du ska resa till " + d["0"] + "? Du kan se årets pristrender nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1250481472 = messageFormatterFn((function(  ) {
  return function(d) { return "Osäker på när du ska resa till " + d["0"] + "? Du kan se årets pristrender nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1801844541 = messageFormatterFn((function(  ) {
  return function(d) { return "Mer information"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a943196479 = messageFormatterFn((function(  ) {
  return function(d) { return "Ikon för pristrend"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1567860875 = messageFormatterFn((function(  ) {
  return function(d) { return "Se alla avsnitt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1344183362 = messageFormatterFn((function(  ) {
  return function(d) { return "Dölj alla avsnitt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1417098321 = messageFormatterFn((function(  ) {
  return function(d) { return "Dela"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2019833038 = messageFormatterFn((function(  ) {
  return function(d) { return "E-post"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1672772633 = messageFormatterFn((function(  ) {
  return function(d) { return "Kopiera länk"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b520694580 = messageFormatterFn((function(  ) {
  return function(d) { return "Dela på " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b996529338 = messageFormatterFn((function(  ) {
  return function(d) { return "Dela via e-post"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1043324876 = messageFormatterFn((function(  ) {
  return function(d) { return "Något gick tyvärr snett på vårt håll. Försök igen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1787999122 = messageFormatterFn((function(  ) {
  return function(d) { return "Okej"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1094563774 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta ditt perfekta ställe™"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a374799841 = messageFormatterFn((function(  ) {
  return function(d) { return "Liknande boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b991851537 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " hotell";}, one: function() { return number(d["0"]) + " hotell";}, two: function() { return number(d["0"]) + " hotell";}, few: function() { return number(d["0"]) + " hotell";}, many: function() { return number(d["0"]) + " hotell";}, other: function() { return number(d["0"]) + " hotell";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1107871100 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " aktiviteter";}, one: function() { return number(d["0"]) + " aktivitet";}, two: function() { return number(d["0"]) + " aktiviteter";}, few: function() { return number(d["0"]) + " aktiviteter";}, many: function() { return number(d["0"]) + " aktiviteter";}, other: function() { return number(d["0"]) + " aktiviteter";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1927018092 = messageFormatterFn((function(  ) {
  return function(d) { return "Karta är inte tillgänglig för tillfället"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a198184151 = messageFormatterFn((function(  ) {
  return function(d) { return "Recensioner för " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1440305053 = messageFormatterFn((function(  ) {
  return function(d) { return "Fler än 14 nätter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b949172316 = messageFormatterFn((function(  ) {
  return function(d) { return "När är det bäst att besöka " + d["0"] + "?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a282660068 = messageFormatterFn((function(  ) {
  return function(d) { return "Ditt flyg gör att du kan spara på hotell, hyrbilar och aktiviteter."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1145997517 = messageFormatterFn((function(  ) {
  return function(d) { return "Avresa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b221825703 = messageFormatterFn((function(  ) {
  return function(d) { return "hittades för 1 minut sen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1879520441 = messageFormatterFn((function(  ) {
  return function(d) { return "Skapa ett paket"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1809179410 = messageFormatterFn((function(  ) {
  return function(d) { return "Något gick snett"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b961512609 = messageFormatterFn((function(  ) {
  return function(d) { return "Länk till reseguiden för " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a812308103 = messageFormatterFn((function(  ) {
  return function(d) { return "Incheckningsinstruktioner"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2102354245 = messageFormatterFn((function(  ) {
  return function(d) { return "Hur räknas priserna ut?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b558498434 = messageFormatterFn((function(  ) {
  return function(d) { return "Ditt paketerbjudande gör att du kan spara på hotell och aktiviteter."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1019228914 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter boende"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1070155713 = messageFormatterFn((function(  ) {
  return function(d) { return "Flerspråkig personal"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2003709289 = messageFormatterFn((function(  ) {
  return function(d) { return "Utforska olika destinationer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1528697449 = messageFormatterFn((function(  ) {
  return function(d) { return "Obegränsad körsträcka"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1040236789 = messageFormatterFn((function(  ) {
  return function(d) { return "Ålder på spädbarn " + d["0"] + ", " + d["1"] + " år"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a386240493 = messageFormatterFn((function(  ) {
  return function(d) { return "Gäster"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1679326788 = messageFormatterFn((function(  ) {
  return function(d) { return "Hämtning och avlämning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a793448626 = messageFormatterFn((function(  ) {
  return function(d) { return "Enkelresa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b50420883 = messageFormatterFn((function(  ) {
  return function(d) { return "Boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1642555719 = messageFormatterFn((function(  ) {
  return function(d) { return "Stad eller flygplats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a234536395 = messageFormatterFn((function(  ) {
  return function(d) { return "Avboka din resa, så behandlar vi din avbokning som vi anger i din resplan med resplansnummer " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1783964121 = messageFormatterFn((function(  ) {
  return function(d) { return "Golfbana på området"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a806540032 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har samarbetat med våra resepartners för att erbjuda dig ersättning i form av en värdekupong om du bestämmer dig för att avboka din icke-återbetalningsbara bokning."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b242269686 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa fler boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a506119845 = messageFormatterFn((function(  ) {
  return function(d) { return "Husdjur"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a311688157 = messageFormatterFn((function(  ) {
  return function(d) { return "Verifierad Expediarecension"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b165177469 = messageFormatterFn((function(  ) {
  return function(d) { return "Foto från Trover, ”" + d["0"] + "”, av " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a897414541 = messageFormatterFn((function(  ) {
  return function(d) { return "hittades för 1 dag sen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1775444727 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi känner inte igen telefonnumret. Kontrollera telefonnumret och försök igen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a439670692 = messageFormatterFn((function(  ) {
  return function(d) { return "Bra för strandsemester"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a596978242 = messageFormatterFn((function(  ) {
  return function(d) { return "7."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b320262960 = messageFormatterFn((function(  ) {
  return function(d) { return "Ja, jag bekräftar att jag vill avboka min kommande bokning med " + d["0"] + ". Jag förstår att avbokningen är gratis och leder till att min bokning tas bort."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a729836659 = messageFormatterFn((function(  ) {
  return function(d) { return "Enastående"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1769011674 = messageFormatterFn((function(  ) {
  return function(d) { return "1 stopp"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a549618384 = messageFormatterFn((function(  ) {
  return function(d) { return "Transport till/från flygplatsen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1720812913 = messageFormatterFn((function(  ) {
  return function(d) { return "Gratis frukost"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1793925311 = messageFormatterFn((function(  ) {
  return function(d) { return "Längd"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a873078748 = messageFormatterFn((function(  ) {
  return function(d) { return "Klar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a596975359 = messageFormatterFn((function(  ) {
  return function(d) { return "4."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a186640316 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa fler"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b298411220 = messageFormatterFn((function(  ) {
  return function(d) { return "Förare under " + d["0"] + " år eller över " + d["1"] + " år kan behöva betala en extraavgift."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2013955204 = messageFormatterFn((function(  ) {
  return function(d) { return "Tidigare sökningar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b727261304 = messageFormatterFn((function(  ) {
  return function(d) { return "Se fler områden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b447276971 = messageFormatterFn((function(  ) {
  return function(d) { return "Avresa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1723499216 = messageFormatterFn((function(  ) {
  return function(d) { return "Begränsad körsträcka"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1795039438 = messageFormatterFn((function(  ) {
  return function(d) { return "På grund av att omständigheterna ständigt ändras ber vi dig att återkomma inom 7 dagar av ditt resedatum."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1943034247 = messageFormatterFn((function(  ) {
  return function(d) { return "Ute efter sport-, konsert- eller teaterevenemang?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a608614695 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " per natt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a535980359 = messageFormatterFn((function(  ) {
  return function(d) { return "Gör om din sökning."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1102037451 = messageFormatterFn((function(  ) {
  return function(d) { return "1 resultat"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1388037264 = messageFormatterFn((function(  ) {
  return function(d) { return "- " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1517815968 = messageFormatterFn((function(  ) {
  return function(d) { return "Budget"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a911647165 = messageFormatterFn((function(  ) {
  return function(d) { return "Rabattkod"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1951729325 = messageFormatterFn((function(  ) {
  return function(d) { return "Klart, du har valt " + d["0"] + " nätter. Spara ändringar och stäng datumväljaren."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1397152021 = messageFormatterFn((function(  ) {
  return function(d) { return "Incheckning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1025193322 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj ett hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b395111585 = messageFormatterFn((function(  ) {
  return function(d) { return "Direkt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1334386947 = messageFormatterFn((function(  ) {
  return function(d) { return "Ålder på barn " + d["0"] + ", " + d["1"] + " år"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b811399991 = messageFormatterFn((function(  ) {
  return function(d) { return "Boendetyp"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b73422155 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a596976320 = messageFormatterFn((function(  ) {
  return function(d) { return "5."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1816568803 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - 1 min med bil"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b38153427 = messageFormatterFn((function(  ) {
  return function(d) { return "När du bokar hotell och hyrbil samtidigt förhandlar vi fram otroliga erbjudanden, så att du sparar pengar. Besparingarna på det här paketet täcker kostnaden för din hyrbil."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1392050640 = messageFormatterFn((function(  ) {
  return function(d) { return "Väldigt bra"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1646911886 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange en destination"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2014947606 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har samlat in " + d["0"] + " recensioner totalt för alla hämtningsplatser i " + d["1"] + " med ett snittbetyg på " + d["2"] + " av " + d["3"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1154138399 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi vet inte riktigt vad som hände. Försök att söka igen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a829761497 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " från centrum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a31831415 = messageFormatterFn((function(  ) {
  return function(d) { return "Par uppskattar:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a84486363 = messageFormatterFn((function(  ) {
  return function(d) { return "Barnpassning (avgift)"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1111180302 = messageFormatterFn((function(  ) {
  return function(d) { return "Avlämningsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1186643816 = messageFormatterFn((function(  ) {
  return function(d) { return "Reception öppen dygnet runt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1514597157 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotellnamn, stad eller flygplats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a926546460 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa alla " + d["0"] + " boenden nära " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1929159397 = messageFormatterFn((function(  ) {
  return function(d) { return "Underbart"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1479938265 = messageFormatterFn((function(  ) {
  return function(d) { return "Företagscenter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1426711224 = messageFormatterFn((function(  ) {
  return function(d) { return "Vissa av dessa recensioner kan ha maskinöversatts till engelska."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2080698238 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1395970511 = messageFormatterFn((function(  ) {
  return function(d) { return "Länk till reseguiden för " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1856517184 = messageFormatterFn((function(  ) {
  return function(d) { return "Tillgång till ski-in/ski-out"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a986495428 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " områdesrecensioner"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a474133929 = messageFormatterFn((function(  ) {
  return function(d) { return "Känt för"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b718714325 = messageFormatterFn((function(  ) {
  return function(d) { return "Avboka"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a918149432 = messageFormatterFn((function(  ) {
  return function(d) { return "Avgiftsfri parkeringsservice"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2117518423 = messageFormatterFn((function(  ) {
  return function(d) { return "hittades för 1 timme sen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2128138978 = messageFormatterFn((function(  ) {
  return function(d) { return "Se alla tillgängliga boenden i " + d["1"] + " från " + d["0"] + " per natt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a43404070 = messageFormatterFn((function(  ) {
  return function(d) { return "Din boendeavbokning behandlas"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1884786845 = messageFormatterFn((function(  ) {
  return function(d) { return "Conciergetjänster"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1943012760 = messageFormatterFn((function(  ) {
  return function(d) { return "Lyx"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1563499998 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta billiga hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a475815795 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - Boende vid stranden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a853469179 = messageFormatterFn((function(  ) {
  return function(d) { return "Se priser och tillgänglighet"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1350870919 = messageFormatterFn((function(  ) {
  return function(d) { return "Snittpriset är " + d["0"] + " per natt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a962839399 = messageFormatterFn((function(  ) {
  return function(d) { return "Paket med flyg eller hyrbil kan bara bokas för vistelser på ett hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1440304092 = messageFormatterFn((function(  ) {
  return function(d) { return "10-14 nätter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2110646290 = messageFormatterFn((function(  ) {
  return function(d) { return "Det verkar som om du redan har skickat in den här förfrågan. Vi behandlar den nu."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2077568035 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta fler boenden genom att lägga till dessa populära filter till din sökning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a961676800 = messageFormatterFn((function(  ) {
  return function(d) { return "Resplansnummer " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2110538963 = messageFormatterFn((function(  ) {
  return function(d) { return "Rökfri fastighet"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1115219688 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " i snittpris per natt för hotell med minst 4 stjärnor."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b859896854 = messageFormatterFn((function(  ) {
  return function(d) { return "Utomhuspool"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1832302544 = messageFormatterFn((function(  ) {
  return function(d) { return "Senast visade hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1495675625 = messageFormatterFn((function(  ) {
  return function(d) { return "Bra för golfspelare"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1646502177 = messageFormatterFn((function(  ) {
  return function(d) { return "Resebesparingar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1016120763 = messageFormatterFn((function(  ) {
  return function(d) { return "Läs mer om " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a904827480 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök och jämför flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1772179581 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " stopp"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1525646837 = messageFormatterFn((function(  ) {
  return function(d) { return "Boendets namn"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a66759396 = messageFormatterFn((function(  ) {
  return function(d) { return "Varifrån flyger du?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1541135527 = messageFormatterFn((function(  ) {
  return function(d) { return "Alla bekvämligheter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a363753167 = messageFormatterFn((function(  ) {
  return function(d) { return "Söker du efter en annan destination?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1496423112 = messageFormatterFn((function(  ) {
  return function(d) { return "Inget önskemål"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b678752416 = messageFormatterFn((function(  ) {
  return function(d) { return "Pris per natt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b213294364 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter flygplats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a806540993 = messageFormatterFn((function(  ) {
  return function(d) { return "Om du väljer att avboka skickar vi dig en kupong till samma värde som det ursprungliga priset. Bara meddela oss om du vill avboka eller behålla din bokning."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a17308015 = messageFormatterFn((function(  ) {
  return function(d) { return "Upphämtning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1253078062 = messageFormatterFn((function(  ) {
  return function(d) { return "Du sparar " + d["0"] + " % i snitt med paketpriser"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1595083779 = messageFormatterFn((function(  ) {
  return function(d) { return "All-inclusive"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b284442812 = messageFormatterFn((function(  ) {
  return function(d) { return "Börja med din första destination"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a640123298 = messageFormatterFn((function(  ) {
  return function(d) { return "Nuvarande plats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1233865018 = messageFormatterFn((function(  ) {
  return function(d) { return "Återresa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1778552821 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2092869443 = messageFormatterFn((function(  ) {
  return function(d) { return "På privat strand"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1166995631 = messageFormatterFn((function(  ) {
  return function(d) { return "10-15 nätter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a596972476 = messageFormatterFn((function(  ) {
  return function(d) { return "1."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2126287366 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter evenemangsbiljetter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b540705705 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " områdesrecension"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2119345246 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " i snitt/natt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1074976997 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi hittar inte det här resplansnumret. Kontrollera numret och försök igen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b771558356 = messageFormatterFn((function(  ) {
  return function(d) { return "(" + d["0"] + " recension)"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2063106168 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - " + d["1"] + " - " + d["2"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1428292896 = messageFormatterFn((function(  ) {
  return function(d) { return "Boendeklass (" + d["0"] + ")"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b460762506 = messageFormatterFn((function(  ) {
  return function(d) { return "Boendetyp (" + d["0"] + ")"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1556864929 = messageFormatterFn((function(  ) {
  return function(d) { return "Vill du behålla din kredit och använda den för en framtida flygresa med samma flygbolag behöver du inte göra något."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2052786577 = messageFormatterFn((function(  ) {
  return function(d) { return "När är det bäst att resa till " + d["0"] + "?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b635877213 = messageFormatterFn((function(  ) {
  return function(d) { return "Det har uppstått ett problem."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1926360167 = messageFormatterFn((function(  ) {
  return function(d) { return "1 rum x 1 natt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1166994670 = messageFormatterFn((function(  ) {
  return function(d) { return "6-9 nätter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b17392844 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi meddelar dig via e-post, till den e-postadress som du använde vid bokningen, med ytterligare information om din återbetalning när vi är klara."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b205585706 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " resultat laddas nedan"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2050123100 = messageFormatterFn((function(  ) {
  return function(d) { return "hittades för " + d["0"] + " dagar sen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1466256187 = messageFormatterFn((function(  ) {
  return function(d) { return "Resplansnummer " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1454918849 = messageFormatterFn((function(  ) {
  return function(d) { return "Expertråd om kryssningar " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1150989807 = messageFormatterFn((function(  ) {
  return function(d) { return "Om du vill behålla din kredit och använda den för en framtida flygresa med samma flygbolag, behöver du inte göra något."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b900350675 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi beklagar. Ett fel har inträffat hos oss. Försök igen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1946319294 = messageFormatterFn((function(  ) {
  return function(d) { return "Husdjur"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1530355794 = messageFormatterFn((function(  ) {
  return function(d) { return "Recensioner för " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1269135504 = messageFormatterFn((function(  ) {
  return function(d) { return "Fantastiska resor med otroliga besparingar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b851287226 = messageFormatterFn((function(  ) {
  return function(d) { return "Gratis fast höghastighetsinternet"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2119065657 = messageFormatterFn((function(  ) {
  return function(d) { return "Foto av " + d["0"] + " (" + d["1"] + ") / Urklipp från original"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1445990509 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " resultat"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a251471427 = messageFormatterFn((function(  ) {
  return function(d) { return "Fler resealternativ"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1440303131 = messageFormatterFn((function(  ) {
  return function(d) { return "7-9 nätter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a310535976 = messageFormatterFn((function(  ) {
  return function(d) { return "Det här formuläret kan inte användas för att avboka kryssningar. Logga in på ditt konto och avboka från din resplan online."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1782355171 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi hittade inte din plats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a596974398 = messageFormatterFn((function(  ) {
  return function(d) { return "3."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a713827921 = messageFormatterFn((function(  ) {
  return function(d) { return "Avbryt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1832211405 = messageFormatterFn((function(  ) {
  return function(d) { return "Flera städer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1476990903 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi känner inte igen e-postadressen. Kontrollera e-postadressen och försök igen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b159985945 = messageFormatterFn((function(  ) {
  return function(d) { return "(minst)"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1648180240 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta de bästa kryssningserbjudandena med dina favoriter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a584381963 = messageFormatterFn((function(  ) {
  return function(d) { return "Barnpassning ingår"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a843764610 = messageFormatterFn((function(  ) {
  return function(d) { return "3 stjärnor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1080309386 = messageFormatterFn((function(  ) {
  return function(d) { return "Klicka för hotellerbjudanden i " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1735877786 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta ditt nästa hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1326289290 = messageFormatterFn((function(  ) {
  return function(d) { return "10."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b41677502 = messageFormatterFn((function(  ) {
  return function(d) { return "1 rum x " + d["0"] + " nätter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2077954716 = messageFormatterFn((function(  ) {
  return function(d) { return "Avbryt, stäng datumfönstret utan att spara ändringarna. Eller ändra datumen nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1372186767 = messageFormatterFn((function(  ) {
  return function(d) { return "från " + d["0"] + ", tur-och-retur"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1945935853 = messageFormatterFn((function(  ) {
  return function(d) { return "Karta"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a138513755 = messageFormatterFn((function(  ) {
  return function(d) { return "Direktflyg tur och retur ingår"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1571191426 = messageFormatterFn((function(  ) {
  return function(d) { return "Tur-och-returflyg ingår"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1556866851 = messageFormatterFn((function(  ) {
  return function(d) { return "Återbetalningen gäller endast för flyget som anges ovan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b353730102 = messageFormatterFn((function(  ) {
  return function(d) { return "Se färre sevärdheter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1063729014 = messageFormatterFn((function(  ) {
  return function(d) { return "Val av rum och resenärer, " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2017667333 = messageFormatterFn((function(  ) {
  return function(d) { return "Ditt paketerbjudande gör att du kan spara på hotell och hyrbilar."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a165389346 = messageFormatterFn((function(  ) {
  return function(d) { return "snittpris per natt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a596980164 = messageFormatterFn((function(  ) {
  return function(d) { return "9."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1962122411 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " per dag"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a463294314 = messageFormatterFn((function(  ) {
  return function(d) { return "Prisöversikt för paketet med hotell och hyrbil"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1995351208 = messageFormatterFn((function(  ) {
  return function(d) { return "Varifrån reser du?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1767123659 = messageFormatterFn((function(  ) {
  return function(d) { return "Det pris per natt som visas är snittpriset baserat på en vistelse för två personer, ett rum och en natt. Snittpriset räknas ut baserat på det lägsta priset per natt från de senaste 24 timmarna för boenden som är tillgängliga på marknaden 45 dagar från och med idag."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b117877574 = messageFormatterFn((function(  ) {
  return function(d) { return "Boende"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1288559258 = messageFormatterFn((function(  ) {
  return function(d) { return "Se alla tillgängliga boenden nära " + d["1"] + " från " + d["0"] + " per natt."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1410819304 = messageFormatterFn((function(  ) {
  return function(d) { return "Upphämtningsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1196556707 = messageFormatterFn((function(  ) {
  return function(d) { return "Utforska efter intresse"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1137034817 = messageFormatterFn((function(  ) {
  return function(d) { return "Nej, avboka inte"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1023050939 = messageFormatterFn((function(  ) {
  return function(d) { return "Osäker på när du ska resa till " + d["0"] + "? Du kan se årets pristrender nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b305550858 = messageFormatterFn((function(  ) {
  return function(d) { return "Din hyrbil gör att du kan spara på hotell och aktiviteter."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1166996592 = messageFormatterFn((function(  ) {
  return function(d) { return "15+ nätter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2005143866 = messageFormatterFn((function(  ) {
  return function(d) { return "Min 4 stjärnor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b958981270 = messageFormatterFn((function(  ) {
  return function(d) { return "Billigt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b50425688 = messageFormatterFn((function(  ) {
  return function(d) { return "Hyrbilar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b50422805 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2038961686 = messageFormatterFn((function(  ) {
  return function(d) { return "Var ska hämtning och avlämning ske?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1153202641 = messageFormatterFn((function(  ) {
  return function(d) { return "Max 2 stjärnor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1055604331 = messageFormatterFn((function(  ) {
  return function(d) { return "Stopp " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b358791802 = messageFormatterFn((function(  ) {
  return function(d) { return "Resteman"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a864497249 = messageFormatterFn((function(  ) {
  return function(d) { return "Restaurang"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1742789823 = messageFormatterFn((function(  ) {
  return function(d) { return "För förare under " + d["0"] + " år eller över " + d["1"] + " år kan en extraavgift tillkomma."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b867430036 = messageFormatterFn((function(  ) {
  return function(d) { return "Ditt flygbolag tar hand om alla avbokningar. Kontakta flygbolaget direkt."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2125819484 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " i snittpris per natt för hotell med 3 stjärnor."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b921262957 = messageFormatterFn((function(  ) {
  return function(d) { return "Destination"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1302368647 = messageFormatterFn((function(  ) {
  return function(d) { return "Klar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a24077797 = messageFormatterFn((function(  ) {
  return function(d) { return "Klart, du har valt 1 natt. Spara ändringar och stäng datumväljaren."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1839490132 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa fler"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a135221510 = messageFormatterFn((function(  ) {
  return function(d) { return "Din flygavbokning behandlas"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a928924095 = messageFormatterFn((function(  ) {
  return function(d) { return "Pris per natt (" + d["0"] + ")"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b802703866 = messageFormatterFn((function(  ) {
  return function(d) { return "Förare mellan " + d["0"] + " - " + d["1"] + " år gammal"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1354129583 = messageFormatterFn((function(  ) {
  return function(d) { return "1 hyrbil"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1440302170 = messageFormatterFn((function(  ) {
  return function(d) { return "2-6 nätter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1417493484 = messageFormatterFn((function(  ) {
  return function(d) { return "vistelse på 1 natt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a816970919 = messageFormatterFn((function(  ) {
  return function(d) { return "Hyr en bil"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1930350916 = messageFormatterFn((function(  ) {
  return function(d) { return "Karta med " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a626445172 = messageFormatterFn((function(  ) {
  return function(d) { return "När är det bäst att resa till " + d["0"] + "?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1218485568 = messageFormatterFn((function(  ) {
  return function(d) { return "hittades för " + d["0"] + " timmar sen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1405223414 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj en flygplats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a480594841 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kan inte utföra din avbokning eftersom det är mindre än 24 timmar kvar till ditt incheckningsdatum."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b570234467 = messageFormatterFn((function(  ) {
  return function(d) { return "Flygbolagets bekräftelsenummer: " + d["0"] + " (" + d["1"] + ")"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a488882133 = messageFormatterFn((function(  ) {
  return function(d) { return "Ute efter sport-, konsert- eller teaterevenemang? Sök efter evenemangsbiljetter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1064366260 = messageFormatterFn((function(  ) {
  return function(d) { return "Semesterboenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a659447400 = messageFormatterFn((function(  ) {
  return function(d) { return "Ditt paketerbjudande gör att du kan spara på hotell."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1713413904 = messageFormatterFn((function(  ) {
  return function(d) { return "hittades för " + d["0"] + " minuter sen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1699350504 = messageFormatterFn((function(  ) {
  return function(d) { return "Betalningstyper"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b442275598 = messageFormatterFn((function(  ) {
  return function(d) { return "Avgiftsfri parkering"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1874625107 = messageFormatterFn((function(  ) {
  return function(d) { return "Skapa en resa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1525706807 = messageFormatterFn((function(  ) {
  return function(d) { return "<span>av 5</span>"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1509724409 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - " + d["1"] + " min promenad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a115376511 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b688212676 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kommer att kontakta dig när din kupong är tillgänglig. Du behöver logga in på ditt konto hos " + d["0"] + " för att få tillgång till kupongkoden. Om du inte har något konto hos " + d["0"] + ", kommer vi att skapa ett genom att använda e-postadressen " + d["1"] + ". Vi skapar ett tillfälligt lösenord för dig och ber dig att skapa ett nytt lösenord när du loggar in för första gången."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a183290554 = messageFormatterFn((function(  ) {
  return function(d) { return "Datum för avresa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a367866420 = messageFormatterFn((function(  ) {
  return function(d) { return "Utcheckning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1971795233 = messageFormatterFn((function(  ) {
  return function(d) { return "Boendeklass"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a403621455 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - 1 min promenad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b46307242 = messageFormatterFn((function(  ) {
  return function(d) { return "flyg tur-och-retur"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1702228336 = messageFormatterFn((function(  ) {
  return function(d) { return "Tvättmöjligheter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b478083702 = messageFormatterFn((function(  ) {
  return function(d) { return "Kompakt hyrbil och vistelse på en natt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a596977281 = messageFormatterFn((function(  ) {
  return function(d) { return "6."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a596973437 = messageFormatterFn((function(  ) {
  return function(d) { return "2."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1480534102 = messageFormatterFn((function(  ) {
  return function(d) { return "När du bokar hotell och hyrbil samtidigt förhandlar vi fram otroliga erbjudanden, så att du sparar pengar."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a596979203 = messageFormatterFn((function(  ) {
  return function(d) { return "8."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b948169794 = messageFormatterFn((function(  ) {
  return function(d) { return "Aktivera platstjänster"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1496849658 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta erbjudanden ombord toppkryssningar över hela världen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1124566722 = messageFormatterFn((function(  ) {
  return function(d) { return "Gratis avbokning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a987379075 = messageFormatterFn((function(  ) {
  return function(d) { return "Din aktivitet gör att du kan spara på hotell och hyrbilar."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2043345448 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj rum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1281764598 = messageFormatterFn((function(  ) {
  return function(d) { return "Resplansnummer " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1789334713 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - " + d["1"] + " min med bil"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b679901 = messageFormatterFn((function(  ) {
  return function(d) { return "Inget önskemål"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1093004463 = messageFormatterFn((function(  ) {
  return function(d) { return "Destination, boendenamn, flygplats, sevärdhet eller adress"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a238538927 = messageFormatterFn((function(  ) {
  return function(d) { return "direktflyg tur-och-retur"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1687270075 = messageFormatterFn((function(  ) {
  return function(d) { return "Totalt för två vuxna"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1283219578 = messageFormatterFn((function(  ) {
  return function(d) { return "Se fler sevärdheter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b933938937 = messageFormatterFn((function(  ) {
  return function(d) { return "Upphämtningstid"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a941359054 = messageFormatterFn((function(  ) {
  return function(d) { return "Återresa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b970222310 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1877311248 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa färre"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1896734544 = messageFormatterFn((function(  ) {
  return function(d) { return "Paketerbjudanden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1560755753 = messageFormatterFn((function(  ) {
  return function(d) { return "När du väljer ett alternativ kommer sidan med sökresultat att öppnas med det förvalda filtret"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a91865625 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b505920064 = messageFormatterFn((function(  ) {
  return function(d) { return "Läs recensioner av " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1047714562 = messageFormatterFn((function(  ) {
  return function(d) { return "Val av resenärer, " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1752080094 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa " + d["0"] + " resultat"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2066130157 = messageFormatterFn((function(  ) {
  return function(d) { return "Barn och extrasängar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1551443059 = messageFormatterFn((function(  ) {
  return function(d) { return "Saker att göra"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a46918469 = messageFormatterFn((function(  ) {
  return function(d) { return "Business-service, dygnet runt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b129462187 = messageFormatterFn((function(  ) {
  return function(d) { return "Spara med paketbokning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1701615119 = messageFormatterFn((function(  ) {
  return function(d) { return "1 natt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a290288969 = messageFormatterFn((function(  ) {
  return function(d) { return "Jag har läst och godkänner <a href=\"" + d["0"] + "\">reglerna och villkoren för programmet för paketpriser</a> och är införstådd med att paketpriser endast kan bokas i kombination med en flygbokning, en hyrbilsbokning eller en tågbokning för samma resenär och resa."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1500505093 = messageFormatterFn((function(  ) {
  return function(d) { return "Gratis wi-fi"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a691676887 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta billiga hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1121805794 = messageFormatterFn((function(  ) {
  return function(d) { return "Prisuppgifter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b424227094 = messageFormatterFn((function(  ) {
  return function(d) { return "Familjevänligt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1401764218 = messageFormatterFn((function(  ) {
  return function(d) { return "Husdjur tillåtna"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1440301209 = messageFormatterFn((function(  ) {
  return function(d) { return "Alla"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2013834153 = messageFormatterFn((function(  ) {
  return function(d) { return "Jag behöver inte boende för den här mellanlandningen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1166993709 = messageFormatterFn((function(  ) {
  return function(d) { return "Mindre än 6 nätter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2063107129 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1607851090 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange stad eller sevärdhet"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1916912629 = messageFormatterFn((function(  ) {
  return function(d) { return "Konferenscenter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1864356597 = messageFormatterFn((function(  ) {
  return function(d) { return "Hitta mer information om " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1634577065 = messageFormatterFn((function(  ) {
  return function(d) { return "Hyrbilar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a202228172 = messageFormatterFn((function(  ) {
  return function(d) { return "Se färre områden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1209049502 = messageFormatterFn((function(  ) {
  return function(d) { return "Osäker på när du ska resa till " + d["0"] + "? Du kan se årets pristrender nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1059546484 = messageFormatterFn((function(  ) {
  return function(d) { return "vistelse på " + d["0"] + " nätter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b885638866 = messageFormatterFn((function(  ) {
  return function(d) { return "Allt är klart."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2071935906 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", " + d["1"] + " och " + d["2"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2050065450 = messageFormatterFn((function(  ) {
  return function(d) { return "Länk till reseguiden för " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2071934945 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " och " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a843477145 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har bara valt en. Välj minst två reseprodukter för att söka efter semesterpaket."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1131062270 = messageFormatterFn((function(  ) {
  return function(d) { return "Boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a48380275 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " i snittpris per natt för hotell med max 2 stjärnor."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1042213222 = messageFormatterFn((function(  ) {
  return function(d) { return "Bra för par"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1392788914 = messageFormatterFn((function(  ) {
  return function(d) { return "Livsmedelsaffär"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b888309837 = messageFormatterFn((function(  ) {
  return function(d) { return "Inomhuspool"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1850459772 = messageFormatterFn((function(  ) {
  return function(d) { return "Se mer av området?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b835677091 = messageFormatterFn((function(  ) {
  return function(d) { return "Alla"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b242054739 = messageFormatterFn((function(  ) {
  return function(d) { return "Hämtar din nuvarande plats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1130062784 = messageFormatterFn((function(  ) {
  return function(d) { return "Våra ackrediteringar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b693250941 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b143951851 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyg + hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b870885850 = messageFormatterFn((function(  ) {
  return function(d) { return "Vart flyger du?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b910240492 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi meddelar dig via e-post, till den e-postadress som du använde vid bokningen, med ytterligare information om din återbetalning när vi är klara."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1797240827 = messageFormatterFn((function(  ) {
  return function(d) { return "Ditt flygbolag tar hand om alla avbokningar. Kontakta flygbolaget direkt."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a839028753 = messageFormatterFn((function(  ) {
  return function(d) { return "Avlämningstid"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1870251926 = messageFormatterFn((function(  ) {
  return function(d) { return "Boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b848455294 = messageFormatterFn((function(  ) {
  return function(d) { return "Tack för att du har valt att boka resor med " + d["0"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1803108742 = messageFormatterFn((function(  ) {
  return function(d) { return "De bästa hotellen i " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a205669394 = messageFormatterFn((function(  ) {
  return function(d) { return "Klicka och avboka | " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1354894055 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter stad eller attraktion"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1947794044 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " per person"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1099819749 = messageFormatterFn((function(  ) {
  return function(d) { return "Snittpris per natt för hotell för två vuxna. </b> Alla priser anges i " + d["0"] + " ."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1578374413 = messageFormatterFn((function(  ) {
  return function(d) { return "Din resa börjar här"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b983010590 = messageFormatterFn((function(  ) {
  return function(d) { return "Begränsa din hotellsökning i " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b546420422 = messageFormatterFn((function(  ) {
  return function(d) { return "Osäker på när du ska besöka " + d["0"] + "? Du kan se årets pristrender nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1765876871 = messageFormatterFn((function(  ) {
  return function(d) { return "Avlämning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a718658365 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi hittar inte det här resplansnumret. Kontrollera numret och försök igen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a703101749 = messageFormatterFn((function(  ) {
  return function(d) { return "Förare mellan " + d["0"] + " och " + d["1"] + " år gammal"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a703185049 = messageFormatterFn((function(  ) {
  return function(d) { return "Annons"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b340061867 = messageFormatterFn((function(  ) {
  return function(d) { return "Försök igen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b819469318 = messageFormatterFn((function(  ) {
  return function(d) { return "Om den här annonsen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b129383736 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har problem med att hämta informationen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1855544026 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kan inte tillhandahålla informationen just nu."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b598582521 = dateToPartsFormatterFn({"2":Globalize("sv-SE").numberFormatter({"raw":"00"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.b1713128889 = dateToPartsFormatterFn({"2":Globalize("sv-SE").numberFormatter({"raw":"00"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.a1020431450 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.b102022508 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.b1658987865 = dateToPartsFormatterFn({"2":Globalize("sv-SE").numberFormatter({"raw":"00"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.b525865380 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.a138734151 = dateToPartsFormatterFn({"2":Globalize("sv-SE").numberFormatter({"raw":"00"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.b1604846841 = dateToPartsFormatterFn({"2":Globalize("sv-SE").numberFormatter({"raw":"00"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.b1075352569 = dateToPartsFormatterFn({"2":Globalize("sv-SE").numberFormatter({"raw":"00"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.a778860058 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.a1917559463 = dateToPartsFormatterFn({"2":Globalize("sv-SE").numberFormatter({"raw":"00"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.b1458254600 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"S","mon":"M","tue":"T","wed":"O","thu":"T","fri":"F","sat":"L"}}}});
Globalize.b1155449977 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"söndag","mon":"måndag","tue":"tisdag","wed":"onsdag","thu":"torsdag","fri":"fredag","sat":"lördag"}}}});
Globalize.a1886271879 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"januari","2":"februari","3":"mars","4":"april","5":"maj","6":"juni","7":"juli","8":"augusti","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.a2044317881 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.a1940389690 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"}),"2":Globalize("sv-SE").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.a1495233863 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"d MMM","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mars","4":"apr.","5":"maj","6":"juni","7":"juli","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.b437476141 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"januari","2":"februari","3":"mars","4":"april","5":"maj","6":"juni","7":"juli","8":"augusti","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.b1538193427 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"januari","2":"februari","3":"mars","4":"april","5":"maj","6":"juni","7":"juli","8":"augusti","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.b1537508234 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"d MMM y","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mars","4":"apr.","5":"maj","6":"juni","7":"juli","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.a1825018375 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"EEEE d MMM","timeSeparator":":","days":{"E":{"4":{"sun":"söndag","mon":"måndag","tue":"tisdag","wed":"onsdag","thu":"torsdag","fri":"fredag","sat":"lördag"}}},"months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mars","4":"apr.","5":"maj","6":"juni","7":"juli","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.b919139814 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"E d MMM","timeSeparator":":","days":{"E":{"1":{"sun":"sön","mon":"mån","tue":"tis","wed":"ons","thu":"tors","fri":"fre","sat":"lör"}}},"months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mars","4":"apr.","5":"maj","6":"juni","7":"juli","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.b219868770 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.b1334415138 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.b1459618639 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.a1712894699 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.b1280274114 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.a1289051827 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.a517447902 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.b1226133090 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.b696638818 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.b1701190031 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.b1998694082 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b1609427967 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.b1991610530 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.a1050111326 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.b1667365822 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"d"}));
Globalize.a1548982609 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a1923092432 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.b1582251748 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.b1159479676 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.b1158794483 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.a1207287824 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.b540426063 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.a1394192973 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.a279646605 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.a2045967648 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.a923513690 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.a333787629 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.a499670818 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.a2131509645 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.a387928653 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.a917422925 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.a1804396256 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.b384632339 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.a196706802 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^S/],["mon",/^M/],["tue",/^T/],["wed",/^O/],["thu",/^T/],["fri",/^F/],["sat",/^L/]]});
Globalize.a1391787853 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["thu",/^torsdag/],["sun",/^söndag/],["mon",/^måndag/],["tue",/^tisdag/],["wed",/^onsdag/],["fri",/^fredag/],["sat",/^lördag/]]});
Globalize.a138542413 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["2",/^februari/],["11",/^november/],["12",/^december/],["1",/^januari/],["8",/^augusti/],["10",/^oktober/],["4",/^april/],["3",/^mars/],["6",/^juni/],["7",/^juli/],["5",/^maj/]]});
Globalize.a1069814451 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.a1704585600 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b1072882367 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["4",/^apr\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["3",/^mars/],["6",/^juni/],["7",/^juli/],["5",/^maj/]]});
Globalize.a1209022029 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["2",/^februari/],["11",/^november/],["12",/^december/],["1",/^januari/],["8",/^augusti/],["10",/^oktober/],["4",/^april/],["3",/^mars/],["6",/^juni/],["7",/^juli/],["5",/^maj/]]});
Globalize.a454582067 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["2",/^februari/],["11",/^november/],["12",/^december/],["1",/^januari/],["8",/^augusti/],["10",/^oktober/],["4",/^april/],["3",/^mars/],["6",/^juni/],["7",/^juli/],["5",/^maj/]]});
Globalize.a455267260 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["4",/^apr\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["3",/^mars/],["6",/^juni/],["7",/^juli/],["5",/^maj/]]});
Globalize.b733172479 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE d MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["thu",/^torsdag/],["sun",/^söndag/],["mon",/^måndag/],["tue",/^tisdag/],["wed",/^onsdag/],["fri",/^fredag/],["sat",/^lördag/]],"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["4",/^apr\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["3",/^mars/],["6",/^juni/],["7",/^juli/],["5",/^maj/]]});
Globalize.a1073635680 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"E d MMM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["thu",/^tors/],["sun",/^sön/],["mon",/^mån/],["tue",/^tis/],["wed",/^ons/],["fri",/^fre/],["sat",/^lör/]],"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["4",/^apr\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["3",/^mars/],["6",/^juni/],["7",/^juli/],["5",/^maj/]]});
module.exports = Globalize;
